import { createI18n } from "vue-i18n";

const messages = {
  en: {
    search: "Search here...",
    change_unit_members: "Change Unit Members",
    pending_members_list: "Pending Members List",
    members: "Members",
    delete_members_list: "Delete Members List",
    delete_member: "Delete Member",
    abandoned: "Added to draft list by mistake. Not our ideal.",
    duplicate_number_entry:
      "He is added with another number, this is double entry.",
    reason_to_delete: "Reason to Delete",
    select_reason: "Select Reason",
    incorrectly_added: "Incorrectly Added",
    died: "Died",
    duplicate_entry: "Duplicate Entry",
    no_longer_needed: "He/She said doesn't want membership anymore.",
    no_longer_needed_2: "Unit committee decided to remove membership.",
    no_longer_needed_3: "We are currently not interested in ideals.",
    financial_issues: "Financial Issues",
    character_issues: "Character Issues",
    last_time_added_by_mistake: "Last time added by mistake.",
    other_reason: "Other Reason",
    reason_to_delete_explain: "Explain reason to delete",
    approve_and_delete: "Approve and Delete Member",
    reject_and_delete: "Reject Delete Request",
    presiding_units_btn:
      "Click here to view unit where you are the presiding officer",
    presiding_zones_btn:
      "Click here to view zones where you are the presiding officer",
    presiding_districts_btn: "Click here to view districts where you are the presiding officer",
    members_list: "Members List",
    draft_list: "Draft List",
    dawa_directory: "Dawa Directory",
    unit_clusters: "Unit Clusters",
    cluster: "Cluster",
    select_cluster: "Select Cluster",
    district_cluster_mapping: "District Cluster Mapping",
    unit_data_collection: "Unit Data Collection",
    executives: "Executives",
    unit_level_executives: "Unit Level Executives",
    zone_level_executives: "Zone Level Executives",
    district_zone_executive_list: "District/Zone Executive List",
    executive_members: "Executive Members",
    filters: "Filters",
    all_wings: "All Wings",
    all_zones: "All Zones",
    all_units: "All Units",
    all_positions: "All Positions",
    all_departments: "All Departments",
    apply_filters: "Apply Filters",
    clear_filters: "Clear Filters",
    no_executives_found: "No executives found",
    no_executives_in_unit: "No executives in this unit",
    total_executives: "Total Executives",
    export: "Export",
    print: "Print",
    position: "Position",
    department: "Department",
    departments: "Departments",
    election_officers: "Election Officers",
    membership_report: "Membership Report",
    unit_membership_report_election: "Unit Membership Report & Unit Election",
    zone_membership_report_election:
      "Unit Membership, Election Report & Zonal Election",
    distict_membership_report_election:
      "Zone Membership, Election Report & District Election",
    election_attendance: "Election Attendance",
    reports: "Reports",
    balavedi: "Balavedi",
    back_to_list: "Go back to Members List",
    members_under_mobile: "Members under your mobile number.",
    members_under_mobile_of: "Members under {{name}}'s mobile number.",
    not_in_draft: "Your number is not added to the draft list.",
    fill_pending_data: "Pending data to fill.",
    upload_profile_photo: "Profile Photo",
    upload: "Upload",
    save: "Save",
    name_address: "Name and Address",
    name: "Name",
    dob_year: "Year of Birth",
    mobile: "Mobile",
    mobile_update_warning:
      "If you change your mobile number, all your members' mobile numbers will be updated.",
    whatsapp: "WhatsApp",
    email: "Email",
    blood_group: "Blood Group",
    blood_donation_willing: "Willing to donate blood?",
    yes: "Yes",
    no: "No",
    nri_status: "Are you an NRI?",
    nri_yes: "NRI",
    nri_notnow: "Was NRI before, now settled in home country.",
    current_location: "Current Location",
    in_state: "In State",
    education_qualification: "Education Qualification",
    physical_education_qualification:
      "Physical Education Qualification (Last completed course)",
    plustwo_subject: "Plus Two Subject",
    islamic_education_qualification:
      "Islamic Education Qualification (Last completed course)",
    islamic_special_degree: "Special Islamic Degree",
    // save_next and next already defined above
    language_info_title: "Languages Known",
    speaking_languages: "Languages you can speak",
    known_languages: "Languages you know",
    writing_languages: "Languages you can write",
    speech_languages: "Languages you can teach/speak",
    select_option: "Select Option",
    studying: "Studying",
    doing_job: "Doing Job",
    retired: "Retired",
    no_job: "No Job",
    house_wife: "House Wife",
    balavedi_not_studying: "Balavedi - Not Studying",
    job_section_title: "Job Information",
    where_study: "Where are you studying?",
    state: "State",
    district: "District",
    what_study: "What are you studying?",
    plustwo: "Plus Two",
    campus_type: "Campus Type",
    study_course: "Course of Study",
    stream: "Stream",
    institution_name: "Institution/College Name",
    study_year: "Year of Study",
    course_completing_year: "Course Completing Year",
    other_course_details:
      "If your course is not listed above or if you have other details, please specify",
    job_category: "Job Category",
    job: "Job",
    job_sub_category: "Job Sub Category",
    job_divisions: "Job Divisions",
    job_sub_divisions: "Job Sub Divisions",
    other_job_details:
      "If your job is not listed above or if you have other details, please specify",
    // Summary / Signature
    summary_title: "g. Summary & Signature",
    summary_title_profile: "Summary & Signature",
    agreement_title: "Agreement Text",
    agreement_paragraph:
      "I hereby certify that I accept and will act according to the organization's rules and regulations as propagated by the teachings mentioned.",
    agree_label: "I agree to all the above terms and conditions",
    viewing_other_notice:
      "This is another member's biodata, so you cannot edit it",
    member_signature: "Member Signature (Malayalam: അംഗത്തിന്റെ ഒപ്പ്)",
    member_signature_mal: "അംഗത്തിന്റെ ഒപ്പ്",
    reupload_signature: "Re-upload Signature",
    cancel_keep_signature: "Cancel & Keep Existing Signature",
    signature_saved_title: "Signature Saved!",
    signature_saved_text: "Your signature was saved successfully.",
    signature_save_error: "Failed to save signature. Please try again.",
    // Disability Info
    disability_section_title: "F. Physical Disabilities",
    disability_section_title_profile: "Physical Disabilities",
    disability_label: "Physical Disability",
    // save_next and next already defined above
    select_disability: "Select physical disability!",
    child_label: "Sub Disability",
    // Extra Activity Info
    extra_activity_section_title: "E. Other Skills / Interests",
    extra_activity_section_title_profile: "Other Skills / Interests",
    islahi_year_label:
      "How many years have you been active in Salafi/Islahi organizations?",
    other_org_label:
      "Are you active in other social/political organizations? If yes, details?",
    contribute_label: "Areas you can contribute (Select at least three)",
    contribute_label_balavedi:
      "Select the activities you like and are most skilled at",
    social_media_label: "Social Media",
    save_next: "Save & Next",
    next: "Next",
    permanent_address_india: "Permanent Address (In India)",
    post_office: "Post Office",
    pin_code: "Pin Code",
    address: "Address",
    same_address: "Current address and permanent address are the same",
    select_local_body: "Select Local Body",
    panchayath: "Panchayath",
    select_panchayath_type: "Select Panchayath",
    select_nearest_place: "Select Nearest Place",
    house_status: "Type of House",
    vehicle_status: "Vehicle Details",
    outside_state_india: "Outside State (In India)",
    bio_data_sections: "Bio Data Sections",
    payment_information: "Payment Information",
    amount_to_pay: "Amount to pay",
    pending: "Pending",
    paid: "Paid",
    make_payment: "Make Payment",
    download_receipt: "Download Receipt",

    my_district: "My District",
    my_zone: "My Zone",
    my_unit: "My Unit",
    go_to_branch: "Click here to go to unit page",
    go_to_lajna: "Click here to go to Lajna page",
    my_campus: "My Campus",
    membership_biodata: "Membership & Biodata",
    membership_details: "Membership Details",
    membership_details_update: "Membership details & Biodata updations",
    nerpatham: "Nerpatham",
    nerpatham_desc: "Click here to add or update Nerpatham",
    my_biodata_form: "My Biodata Form",
    biodata_fill_edit: "Click here to fill/edit biodata",
    qr_code_scanner: "QR Code Scanner.",
    qr_code_attendance_desc: "Click here to mark attendance using QR code",
    change_pin: "Click to change your pin.",
    app_version: "App Version",
    logout: "Logout",
    wisdom: "Wisdom",
    youth: "Youth",
    students: "Students",
    women: "Womens",
    girls: "Girls",
    members_payments_btn: "Click here to view and pay member fees.",
    membership_report_download_btn:
      "Click here to download the membership report.",
    membership_consolidated_report_btn:
      "Click here to view and send the consolidated membership report to the zone.",
    membership_form_bulk_download_btn:
      "Click here to bulk download all expatriate member prints.",
    form_collection: "Form Collection",
    status: "Status",
    collected: "Collected",
    not_collected: "Not Collected",
    subscription: "Subscription",
    is_subscriber: "Are you a current subscriber?",
    receipt_number: "Receipt Number",
    subscription_number: "Subscription Number",
    current_status: "Current Status",
    select: "---Select---",
    place: "Place",
    abroad_mobile: "Abroad Mobile",
    action: "Action",
    approve_transfer: "Approve Transfer",
    reject_transfer: "Reject Transfer",
    call: "Call",
    restore_to_members_list: "Restore To Members List",
    send_guide_link: "Send Guide Link",
    edit: "Edit",
    download_form: "Download Form",
    form_collected_status: "Form Collected Status",
    renew_member: "Renew Member",
    qhls_register: "Register QHLS",
    transfer_to_unit: "Transfer to Unit",
    verification_report: "Verification Report",
    print_biodata: "Print Biodata",
    view_biodata: "View Biodata",
    delete_request: "Delete Request",
    delete: "Delete",
    send_to_pending_members_list: "Send To Pending List",
    approve_delete_request: "Approve Delete Request",
    reject_delete_request: "Reject Delete Request",
    cancel_delete_request: "Cancel Delete Request",
    cancel: "Cancel",
    change_unit: "Change Unit",
    select_district: "Select District",
    select_zone: "Select Zone",
    select_unit: "Select Unit",
    reason: "Reason",
    submit: "Submit",
    click_here_to_view_and_pay_fee_details:
      "Click here to view and pay fee details",
    click_here_to_download_membership_report:
      "Click here to download membership report",
    click_here_to_consolidated_report: "Click here to consolidated report",
    click_here_to_bulk_download_expatriate_prints:
      "Click here to bulk download expatriate prints",
    edit_member: "Edit Member",
    add_member: "Add Member",
    renew_membership: "Renew Membership",
    member_current_status: "Member Current Status",
    lajna_membership: "Lajna Membership",
    lajna_member_status: "Lajna Member Status",
    not_member: "Not a Member",
    is_member: "Member",
    download_biodata: "Download Biodata",
    restore_member: "Restore Member",
    transfer_unit_actions: "Transfer Unit Actions",
    not_registered: "Not Registered",
    registered: "Registered",
    eligible: "Eligible to Participate",
    forign_mobile: "Forign Mobile Number",
    no_information: "No Information",
    abroad: "Abroad",
    active_in_native: "Active in Native",
    not_active_in_native: "Not Active in Native",
    membership_verification: "Membership  Verification",
    verification_status: "Verification Status",
    verified: "Verified",
    not_verified: "Not Verified",
    not_verified_reason: "Not Verified Reason",
    remark: "Remark",
    verified_completed: "Verification Completed",
    verification_not_completed: "Verification Not Completed",
    mobile_number: "Mobile Number",
    whatsapp_number: "WhatsApp Number",
    enter_name: "Enter Name",
    wing: "Wing",
    wings: "Wings",
    select_wing: "Select Wing",
    member_details: "Members Details",
    age: "Age",
    enter_age: "Enter Age",
    select_profession: "Select Profession",
    name_regex: "Type Name in English",
    name_required: "Name is required!",
    age_required: "Age is required!",
    job_required: "Job is required!",
    mobile_required: "Mobile Number is required!",
    wing_required: "Wing is required!",
    associated: "How is he/she associated with our organization?",
    of: "of",
    options_selected: "options selected",
    member_status: "Member Status",
    membership_status: "Membership Status",
    note: "Note",
    add: "Add",
    remove: "Remove",
    move_to_members_list: "Move to Members List",
    no_data: "No Data...",
    save_member_list: "Save and Move to Members List",
    move_to_karad_list: "Move to Karad List",
    save_move_to_karad: "Save and Move to Karad List",
    optional: "Optional",
    cluster_admin_add: "Zone admins will add clusters in your unit",
    search_clusters: "Search clusters...",
    add_cluster: "Add Cluster",
    delete_selected: "Delete Selected",
    no_clusters: "No clusters found",
    cluster_selected: "Cluster Selected",
    no_clusters_available: "No clusters available for selected panchayath",
    select_all: "Select All Clusters",
    not_editable: "You can only fill data in your own unit",
    basic_information: "Basic Information",
    has_centre: "Is there a centre for unit activities?",
    yes_2: "Yes",
    no_2: "No",
    building_type: "Building Type",
    own: "Own Building",
    rent: "Rent",
    worker_home: "Relative's Home",
    other: "Other",
    office_location: "Office Location",
    enter_office_location: "Enter office location",
    masjid_details: "Masjid Details",
    enter_masjid_location: "Enter Google Map Location",

    has_masjid_mujahid: "Is there a Mujahid masjid in the unit?",
    masjid: "Masjid",
    masjid_affiliation: "Which organization is the masjid affiliated with?",
    knm: "K.N.M",
    markaz: "Markas Dawa",
    masjid_location: "Masjid location",
    has_jumua: "Is this a masjid where Jumu'ah is conducted?",
    bio_data: "Bio Data",
    jumua_attendance:
      "If Jumu'ah is conducted, approximately how many people attend?",
    select_range: "Select range",
    under_100: "Below 100",
    between_100_300: "100-300",
    between_300_500: "300-500",
    between_500_1000: "500-1000",
    above_1000: "Above 1000",
    parking_capacity: "How many vehicles can be parked?",
    enter_parking_capacity: "Enter number of vehicles",
    facilities: "Facilities available in the masjid",
    women_facility: "Facility for women",
    meeting_hall: "Meeting hall",
    ac_facility: "Air conditioning facility",
    staff_count: "How many staff members are under the masjid?",
    enter_staff_count: "Enter number of staff",
    imam_name: "Imam's name",
    enter_imam_name: "Enter Imam's name",
    imam_state: "Imam's state",
    enter_imam_state: "Enter Imam's state",
    imam_phone: "Imam's phone number",
    enter_imam_phone: "Enter Imam's phone number",
    add_masjid: "Add masjid",

    madrasa_details: "Madrasa details",
    has_madrasa_mujahid: "Is there a Mujahid madrasa?",
    madrasa: "Madrasa",
    madrasa_affiliation: "Which organization is the madrasa affiliated with?",
    madrasa_name: "Madrasa name",
    enter_madrasa_name: "Enter madrasa name",
    madrasa_started_year: "Year madrasa started",
    enter_madrasa_started_year: "Enter the year madrasa started",
    class_format: "Class format",
    daily: "Daily",
    weekly: "Weekly",
    madrasa_location: "Madrasa location",
    enter_madrasa_location: "Enter madrasa location from Google Maps",
    add_madrasa: "Add madrasa",

    arabic_college_details: "Arabic college details",
    has_arabic_college_mujahid:
      "Is there a Mujahid Arabic college in the unit ?",
    college_affiliation:
      "Which organization is the Arabic college affiliated with?",
    college_building_type: "Type of Arabic college building",
    college_name: "Arabic college name",
    enter_college_name: "Enter college name",
    college_started_year: "Year started",
    enter_college_started_year: "Enter year started",
    course_details: "Course details",
    plus2: "Plus 2",
    afsalul_ulama_prelim: "Afzal-ul-Ulama Preliminary",
    afsalul_ulama_final: "Afzal-ul-Ulama Final",
    number_of_teachers: "How many teachers are there?",
    enter_teachers_count: "Enter number of teachers",
    college_location: "Arabic college location",
    enter_college_location: "Enter location from Google Maps",

    social_media_details: "Social media details",
    social_media_details_unit:
      "Enter the social media links available in the unit below",
    facebook: "Facebook",
    enter_facebook_link: "Enter Facebook link",
    youtube: "YouTube",
    enter_youtube_link: "Enter YouTube link",
    instagram: "Instagram",
    enter_instagram_link: "Enter Instagram link",
    wisdom_media: "Wisdom Media",
    enter_wisdom_media_link: "Enter Wisdom Media link",

    land_and_building: "Land & Building",
    wisdom_land: "Wisdom land under unit control (in cents)",
    land_in_cent: "Land in cents",
    trust_land: "Land under trust control (in cents)",
    enter_trust_land_in_cent: "Enter trust land in cents",
    other_land: "Other land under unit control",
    enter_other_land: "Enter other land in cents",

    qhls_details: "QHLS details",
    qhls: "QHLS",
    qhls_name: "QHLS name",
    enter_qhls_name: "Enter QHLS name",
    qhls_location: "QHLS location",
    enter_qhls_location: "Enter QHLS location from Google Maps",
    convener_name: "Convener name",
    enter_convener_name: "Enter convener name",
    convener_phone: "Convener phone number",
    enter_convener_phone: "Enter convener phone number",
    day: "Day conducted",
    select_day: "Select day",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    time: "Time",
    hour: "Hour",
    qhls_participants_count: "Number of participants",
    enter_qhls_participants_count: "Enter number of participants",
    qhls_started_year: "Year QHLS started",
    enter_qhls_started_year: "Enter year QHLS started",
    qhls_frequency: "Frequency",
    monthly: "Once a month",
    add_qhls: "Add QHLS",

    cre_details: "CRE details",
    cre: "CRE",
    cre_day: "Day CRE is conducted",

    other_services: "Other services",
    zakath_cell: "Zakat cell",
    orphan_care: "Orphan care",
    orphan_count: "Number of children supported",
    enter_orphan_count: "Enter number of children",
    wisdom_healthcare: "Wisdom Healthcare",
    main_healthcare_activities: "Main activities",
    enter_main_healthcare_activities: "Enter main activities",
    hifdh_college: "Qur’an Hifdh College",
    hifdh_students_count: "Number of students",
    enter_hifdh_students_count: "Enter number of students",
    library: "Library",
    book_sales: "Book sales",
    peace_radio: "Peace Radio kiosk",

    other_institutions: "Other institutions",
    enter_other_institution_1: "Other institution name 1",
    enter_other_institution_2: "Other institution name 2",
    enter_other_institution_3: "Other institution name 3",

    election_report: "Click here to view {level} election report.",
    add_executive_member: "Add Executive Member",
    edit_executive_member: "Edit Executive Member",
    executive_count: "Number of Executive Members",
    exc_count: "Executive Count",
    executive_count_selected: "Selected Executive Members",
    enter_executive_count: "Enter number of executive members",
    election_minutes_upload: "Upload Minutes",
    existing_files: "Existing Files",
    uploaded: "Uploaded",
    select_new_files_replace_old:
      "Select new files to replace old files (if any)",
    select_minutes_files: "Select minutes files",
    allowed_file_types: "Allowed file types: pdf, doc, docx, jpg, png",
    selected_files: "Selected Files",
    uploading_files: "Uploading files...",
    replace_files: "Replace Files",
    upload_files: "Upload Files",
    close: "Close",
    exc_members_count: "Number of executive members: ",

    unit: "Unit",
    designation: "Designation",
    list: "List",

    field_required: "This field is required",
    building_type_required: "Building type is required",
    office_location_required: "Office location is required",
    masjid_required: "Masjid details are required",
    college_affiliation_required: "College affiliation is required",
    college_building_type_required: "College building type is required",
    college_name_required: "College name is required",
    hour_required: "Hour is required",
    convener_phone_required: "Convener phone number is required",

    wing_required_field: "Wing is required",
    designation_required: "Designation is required",

    executive_members_list: "Executive Members List",

    edit_election_officer: "Edit Election Officer",
    add_election_officer: "Add Election Officer",

    code: "Code",
    election_officers_list: "Election Officers List",
    no_election_officers_found: "No election officers found for this wing.",

    country_code_required: "Country code is required",
    mobile_number_length: "Mobile number must be 10 digits",
    mobile_number_required: "Mobile number is required",
    clusters_list: "Clusters List",
    no_members_added: "No members added yet",
    attendance: "Attendance",

    language: "Languages",
    create_new_account: "Create new account",
    login: "Login",
    home: "Home",
    menu: "Menu",
    old: "Old",

    registration_links: "Registration Links",

    latest_news: "Latest News",
    read_more: "Read More",
    apps_links: "Apps & Links",
    social_profiles: "Social Profiles",
    city_kozhikode: "Kozhikode",
    city_thiruvananthapuram: "Thiruvananthapuram",
    city_kasargod: "Kasaragod",
    city_kochi: "Kochi",
    loading: "Loading...",
    salah_fajr: "Fajr",
    salah_dhuhr: "Dhuhr",
    salah_asr: "Asr",
    salah_maghrib: "Maghrib",
    salah_isha: "Isha",
    help_desk: "Help Desk",
    how_to_use_app: "1. Where to get Wisdom Guide mobile app",
    how_to_use_app_link:
      "Anyone can access the app by visiting the link: http://guide.wisdomislam.org/",
    availability: "2. Is the app available on all mobile phones?",
    yes_availability:
      "Yes, Wisdom Guide can be used on Android, iOS, Windows, as well as on all mobile phones, computers, and laptops.",
    how_to_install: "3. How to use the app from the link",
    how_to_install_link:
      "When you click the link, it will open in your device browser (e.g., Google Chrome, etc.). From there, you can install it on your phone just like a mobile app. For this, use the 'Add to Home' option in the browser. Watch this video for better understanding.",
    how_to_login: "4. What should users keep in mind while logging in?",
    how_to_login_1:
      "You must log in using your mobile number. First-time users will receive a PIN number via SMS. Remember this PIN number carefully. The same PIN is required when logging in from another device or when logging in again after logging out from the current device.",
    how_to_change_pin: "5. Can this PIN number be changed?",
    how_to_change_pin_1:
      "Currently, there is an option under 'Profile' to set the PIN number as you wish. You can use that to change the PIN.",
    how_to_get_pin_again:
      "6. What should users do if they forget the PIN number?",
    how_to_get_pin_again_1:
      "As done the first time, by entering your mobile number again, you can receive the PIN number via SMS. Use this feature in the app.",
    clear_cache: "Clear cache and restart the app",
    my_profile: "My Profile",
    meeting_report: "Click here to view meeting reports.",
    conducted: "Conducted",
    date: "Date",
    location: "Location",
    participants: "Participants",
    meeting_period: "Meeting Period",
    my_meetings: "My Meetings",
    create_meeting: "Create Meeting",
    meeting_level: "Meeting Level",
    meeting_type: "Meeting Type",
    wing_meeting: "Wing Meeting",
    meeting_name: "Meeting Name",
    meeting_date: "Meeting Date",
    meeting_time: "Meeting Time",
    meeting_mode: "Meeting Mode",
    physical: "Physical",
    online: "Online",
    total: "Total",
    added_by_member: "Added by Member",
    public: "Public",
    download_result: "Download Result",
    nerpatham_target: "Nerpatham Target",
    target: "Target",
    enter_target: "Enter target",
    i_will_attend: "I will attend",
    my_attendance: "My Attendance",
    participant_id: "Participant ID",
    meeting_link: "Meeting Link",
    report: "Report",
    qr_code: "QR Code",
    scanner: "Scanner",
    all: "All",
    present: "Present",
    absent: "Absent",
    leave: "Leave",
    my_duties: "My Duties",
    questionnaire: "Questionnaire",
    minutes: "Minutes",
    meeting_minutes: "Meeting Minutes",
    assigned_member: "Assigned Member",
    select_member: "Select Member",
    text: "Text",
    select_meeting_mode: "Select meeting mode",
    date_from: "Date from",
    date_to: "Date to",
    clear: "Clear",
    confirmed: "Confirmed",
    increase: "Increase",
    decided: "Decided",
    happened: "Happened",
    fee_status: "Fee Status",
    balavedi_teams: "Balavedi Teams",
    captain: "Captain",
    select_captain: "Select Captain",
    current_captain: "Current Captain",
    vice_captain: "Vice Captain",
    select_vice_captain: "Select Vice Captain",
    current_vice_captain: "Current Vice Captain",
    team_members: "Team Members",
    maximum_7_allowed: "Maximum 7 members allowed",
    selected: "Selected",
    members_7: "7 Members",
    new: "New",
    remove_from_team: "Remove from Team",
    name_english_only: "Name (English only)",
    enter_name_required: "Enter name",
    father_name_english_only: "Father's Name (English only)",
    enter_mobile: "Enter mobile",
    enter_country_code: "Enter country code",
    age_minimum: "Age must be at least 1",
    maximum_7_team_members: "Maximum 7 team members allowed",

    delete_reason_1: "Not eligible for membership, added by mistake",
    delete_reason_2: "Was our worker earlier, now not interested",
    delete_reason_3: "Is our supporter, said no need for membership",
    delete_reason_4: "Is our worker, tried many times but not responding",
    delete_reason_5: "In Gulf, biodata not filled",
    delete_reason_6: "No smartphone, so biodata not filled",
    delete_reason_7: "Doesn't know how to fill biodata, so not filled",
    delete_reason_8: "Number in card is wrong, so can't login",
    delete_reason_9: "PIN not received, so can't login",
    delete_reason_other: "Other reasons",
    blood_group_required: "Select blood group!",
    blood_donation_required: "Select blood donation willingness!",
    current_location_required: "Select current location!",
    select_state_required: "Select state!",
    select_country_required: "Select country!",
    select_abroad_city_required: "Enter city name!",
    home_name_required: "Type home name!",
    country_required: "Select country!",
    house_status_required: "Select house status!",
    fill_status: "Click to fill/edit bio data",
    completed: "Completed",
    associated_1: "QHLS Student",
    associated_2: "CRE Student",
    associated_3: "Will attend Jumuah",
    associated_4: "Will attend Jamaath",
    associated_5: "Will attend our meetings",
    associated_6: "Will attend public events",
    associated_7: "Will provide financial help",
    associated_8: "Participated in Proface/Focus",
    associated_9: "Participated in ProfCon",
    associated_10: "Will attend state conference",
    associated_11: "Participated in Family Conference",
    associated_12: "Will attend Vijnana Vedi",
    associated_13: "Through Zakat Cell",
    associated_14: "Through Udhiya",
    associated_15: "Through Fitr Zakat",
    associated_16: "Through Orphan Care",
    associated_17: "Through Wisdom Health Care",
    associated_18: "Other ways",

    // associated values
    asso_value_1: "QHLS Student",
    asso_value_2: "CRE Student",
    asso_value_3: "Will attend Jumuah",
    asso_value_4: "Will attend Jamaath",
    asso_value_5: "Will attend our meetings",
    asso_value_6: "Will attend public events",
    asso_value_7: "Will provide financial help",
    asso_value_8: "Participated in Proface/Focus",
    asso_value_9: "Participated in ProfCon",
    asso_value_10: "Will attend state conference",
    asso_value_11: "Participated in Family Conference",
    asso_value_12: "Will attend Vijnana Vedi",
    asso_value_13: "Through Zakat Cell",
    asso_value_14: "Through Udhiya",
    asso_value_15: "Through Fitr Zakat",
    asso_value_16: "Through Orphan Care",
    asso_value_17: "Through Wisdom Health Care",
    asso_value_18: "Other ways",
    register_now: "Register Now",
    attended: "Attended",
    quick_actions: "Quick Actions",
    admin_controls: "Admin Controls",
    switch_admin_level: "Switch Admin Level",
    switch_to: "Switch to {level}",
    level: "Level",
    self_registration: "Self Registration",
    registration_notice: "Register by ticking the names of the members under your number.",
    already_registered: "Already registered.",
    event_dashboard: "Event Dashboard",
    registration_report: "Registration Report",
    registration_summary: "Registration Summary",
    male: "Male",
    female: "Female",
    male_members: "Male Members",
    female_members: "Female Members",
    participants_summary_with_family: "Participants Summary [With Family]",
    sweet_buds: "Sweet Buds",
    butterflies: "Butterflies",
    little_wings: "Little Wings",
    teenspace: "Teenspace",
    event_registration_report: "Event Registration Report",

    checkin: "Check-in",
    checkin_list: "Check-in List",

    total_unit_election_report: "Total Unit Election Report",
    unit_election_report: "Unit Election Report",

    general_body_council: "Zonal General Council",
    district_general_body_council: "District General Council",
    district_womens_council: "District Womens Council",
    district_girls_council: "District Girls Council",
    womens_council: "Zonal Womens Council",
    girls_council: "Zonal Girls Council",
    org_councilers_list: "District / State Councilors",
    zone: "Zone",
    zone_election_report: "Zone Election Report",
    circulars: "Circulars",
    tap_to_edit: "Tap to edit",
    enter_your_name: "Enter your name",
    name_is_required: "Name is required",
    name_updated_successfully: "Name updated successfully",
    update_failed: "Update failed",
    name_too_short: "Name must be at least 2 characters long",
    name_too_long: "Name cannot exceed 50 characters",
    name_invalid_characters: "Name contains invalid characters",
    edit_names: "Edit Names",
    edit_profile_names: "Edit Profile Names",
    loading_profiles: "Loading profiles...",
    profile_id: "Profile ID",
    no_profiles_found: "No profiles found",
    failed_to_load_profiles: "Failed to load profiles",
    profile_name_updated: "Profile name updated successfully",
  },

  // Malayalam
  ml: {
    search: "ഇവിടെ സെർച്ച് ചെയ്യുക...",
    change_unit_members: "യൂണിറ്റ് മാറ്റേണ്ട അംഗങ്ങൾ",
    pending_members_list: "പെൻഡിംഗ് മെമ്പേഴ്‌സ് ലിസ്റ്റ്",
    members: "മെമ്പർമാർ",
    delete_members_list: "ഡിലീറ്റ് ചെയ്യേണ്ടവരുടെ ലിസ്റ്റ്",
    delete: "ഡിലീറ്റ് ചെയ്യുക",
    delete_member: "അംഗത്തെ ഡിലീറ്റ് ചെയ്യുക",
    reason_to_delete: "ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം",
    died: "മരണപ്പെട്ടു",
    duplicate_entry: "ഈ വ്യക്തിയെ നിലവിൽ ചേർത്തിട്ടുണ്ട്",
    duplicate_number_entry:
      "ഇദ്ദേഹത്തെ മറ്റൊരു നമ്പർ വെച്ച് ചേർത്തിട്ടുണ്ട്, ഇത് ഡബിൾ എൻട്രി ആണ്.",
    abandoned: "കരട് ലിസ്റ്റിൽ അബദ്ധത്തിൽ ചേർത്തിയതാണ്. നമ്മുടെ ആദർശമല്ല.",
    no_longer_needed: "ഇനി മെമ്പർഷിപ്പ് വേണ്ട എന്ന് അദ്ദേഹം പറഞ്ഞു",
    no_longer_needed_2: "മെമ്പർഷിപ്പ് ഒഴിവാക്കാൻ ശാഖാ കമ്മിറ്റി തീരുമാനിച്ചു",
    no_longer_needed_3: "ആദർശപരമായി നമ്മോട് ഇപ്പോൾ താൽപര്യമില്ല.",
    financial_issues: "സാമ്പത്തിക മേഖലയിൽ ഉള്ള പ്രശ്നങ്ങൾ",
    character_issues:
      "നമ്മുടെ പ്രസ്ഥാനത്തിന് യോജിക്കാത്ത സ്വഭാവ പരമായ പ്രശ്നങ്ങൾ.",
    last_time_added_by_mistake:
      "കഴിഞ്ഞതവണ അബദ്ധത്തിൽ ചേർത്തിയതാണ്. നമ്മുടെ ആദർശമല്ല.",
    other_reason: "മറ്റു കാരണങ്ങൾ.",
    reason_to_delete_explain: "ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം എഴുതുക",
    approve_and_delete: "അംഗത്തെ അംഗീകൃതമായി ഡിലീറ്റ് ചെയ്യുക",
    reject_and_delete: "ഡിലീറ്റ് അഭ്യർത്ഥന നിരസിക്കുക",
    presiding_units_btn:
      "താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ ശാഖകൾ ലഭിക്കാൻ ഇവിടെ അമർത്തുക",
    presiding_zones_btn: "താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ മണ്ഡലങ്ങൾ ലഭിക്കാൻ ഇവിടെ അമർത്തുക",
    presiding_districts_btn: "താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ ജില്ലകൾ ലഭിക്കാൻ ഇവിടെ അമർത്തുക",
    members_list: "മെമ്പേഴ്‌സ് ലിസ്റ്റ്",
    draft_list: "കരട് ലിസ്റ്റ്",
    dawa_directory: "ദഅവ ഡയറക്ടറി",
    unit_clusters: "യൂണിറ്റ് ക്ലസ്റ്ററുകൾ",
    cluster: "ക്ലസ്റ്റർ",
    select_cluster: "ക്ലസ്റ്റർ തിരഞ്ഞെടുക്കുക",
    district_cluster_mapping: "ജില്ല ക്ലസ്റ്റർ മാപ്പിംഗ്",
    unit_data_collection: "യൂണിറ്റ് ഡാറ്റാ ശേഖരണം",
    executives: "എക്സിക്യൂട്ടീവുകൾ",
    election_officers: "ഇലക്ഷൻ ഓഫീസർമാർ",
    membership_report: "മെമ്പർഷിപ്പ് റിപ്പോർട്ട്",
    unit_membership_report_election:
      "യൂണിറ്റ് മെമ്പർഷിപ്പ് റിപ്പോർട്ട് & യൂനിറ്റ് ഇലക്ഷൻ",
    zone_membership_report_election:
      "യൂണിറ്റ് മെമ്പർഷിപ്പ്, ഇലക്ഷൻ റിപ്പോർട്ട് & മണ്ഡലം ഇലക്ഷൻ",
    district_membership_report_election:
      "മണ്ഡലം മെമ്പർഷിപ്പ്, ഇലക്ഷൻ റിപ്പോർട്ട് & ജില്ലാ ഇലക്ഷൻ",
    election_attendance: "ഇലക്ഷൻ ഹാജർ",
    reports: "റിപ്പോർട്ടുകൾ",
    balavedi: "ബാലവേദി",
    select_local_body: "ലോക്കൽ ബോഡി തിരഞ്ഞെടുക്കുക",
    panchayath: "പഞ്ചായത്ത്",
    select_panchayath_type: "പഞ്ചായത്ത് തിരഞ്ഞെടുക്കുക",
    select_nearest_place: "ഏറ്റവും അടുത്ത സ്ഥലം തിരഞ്ഞെടുക്കുക",
    back_to_list: "മെമ്പേഴ്‌സ് ലിസ്റ്റിലേക്ക് തിരിച്ചു പോകാൻ ഇവിടെ അമർത്തുക",
    country: "രാജ്യം",
    select_ward: "ക്ലസ്റ്റർ / വാർഡ് തെരഞ്ഞെടുക്കുക",
    house_status: "താമസിക്കുന്ന വീട്",
    vehicle_status: "സ്വന്തം വാഹനത്തിന്റെ വിവരങ്ങൾ",
    same_address: "ഇപ്പോഴത്തെ അഡ്രസ്സും സ്ഥിരം അഡ്രസ്സും ഒന്നുതന്നെയാണ്",
    members_under_mobile: "നിങ്ങളുടെ മൊബൈൽ നമ്പറിന്റെ കീഴിലുള്ള മെമ്പർമാർ.",
    members_under_mobile_of:
      "{{name}} യുടെ മൊബൈൽ നമ്പറിന്റെ കീഴിലുള്ള മെമ്പർമാർ.",
    not_in_draft: "നിങ്ങളുടെ നമ്പർ കരട് ലിസ്റ്റിൽ ചേർത്തിട്ടില്ല.",
    fill_pending_data: "ഫിൽ ചെയ്യാൻ ബാക്കിയുള്ള ഡാറ്റകൾ.",
    upload_profile_photo: "പ്രൊഫൈൽ ഫോട്ടോ",
    upload: "Upload",
    save: "സേവ് ചെയ്യുക",
    name_address: "പേരും മേൽവിലാസവും",
    name: "പേര്",
    dob_year: "ജനന വർഷം",
    mobile: "മൊബൈൽ",
    mobile_update_warning:
      "മൊബൈൽ നമ്പർ മാറ്റുകയാണെങ്കിൽ താങ്കളുടെ എല്ലാ മെമ്പർമാരുടെയും മൊബൈൽ നമ്പർ അപ്ഡേറ്റ് ചെയ്യുന്നതാണ്",
    whatsapp: "വാട്സ്ആപ്പ്",
    email: "ഇ മെയിൽ",
    blood_group: "രക്ത ഗ്രൂപ്പ്",
    blood_donation_willing: "രക്തദാനം ചെയ്യാൻ സന്നദ്ധനാണോ?",
    yes: "അതെ",
    no: "അല്ല",
    nri_status: "താങ്കൾ പ്രവാസിയാണോ?",
    nri_yes: "പ്രവാസിയാണ്.",
    nri_notnow: "മുമ്പ് പ്രവാസി ആയിരുന്നു, ഇപ്പോൾ നാട്ടിൽ സ്ഥിരമായി.",
    current_location: "ഇപ്പൊൾ താമസിക്കുന്ന പ്രദേശം",
    in_state: "സംസ്ഥാനത്ത്",
    education_qualification: "വിദ്യാഭ്യാസ യോഗ്യത",
    physical_education_qualification:
      "ഭൗതിക വിദ്യാഭ്യാസ യോഗ്യത (ഏറ്റവും അവസാനം പൂർത്തിയാക്കിയ കോഴ്സ്)",
    plustwo_subject: "പ്ലസ് ടു വിഷയം",
    islamic_education_qualification:
      "മതപരമായ വിദ്യാഭ്യാസ യോഗ്യത (ഏറ്റവും അവസാനം പൂർത്തിയാക്കിയ കോഴ്സ്)",
    islamic_special_degree: "ബിരുദം",
    // save_next and next already defined above
    language_info_title: "കൈകാര്യം ചെയ്യുന്ന ഭാഷകൾ",
    speaking_languages: "സംസാരിക്കുന്ന ഭാഷകൾ",
    known_languages: "നിങ്ങൾക്ക് അറിയുന്ന ഭാഷകൾ",
    writing_languages: "എഴുതാൻ കഴിയുന്ന ഭാഷകൾ",
    speech_languages: "പ്രസംഗിക്കാൻ / ക്ലാസ് എടുക്കാൻ കഴിയുന്ന ഭാഷകൾ",
    select_option: "തിരഞ്ഞെടുക്കുക",
    studying: "പഠിക്കുന്നു",
    doing_job: "ജോലി ചെയ്യുന്നു",
    retired: "വിരമിച്ചു",
    no_job: "ജോലി ഇല്ല",
    house_wife: "ഗൃഹിണി",
    balavedi_not_studying: "ബാലവേദി - പഠിക്കുന്നില്ല",
    job_section_title: "ജോലി വിവരങ്ങൾ",
    where_study: "എവിടെയാണ് പഠിക്കുന്നത്?",
    state: "സംസ്ഥാനം",
    district: "ജില്ല",
    what_study: "എന്താണ് പഠിക്കുന്നത്?",
    plustwo: "പ്ലസ് ടു",
    campus_type: "ക്യാമ്പസിന്റെ തരം",
    study_course: "പഠിക്കുന്ന കോഴ്സ്",
    stream: "സ്ട്രീം",
    institution_name: "കോളേജ്/ക്യാമ്പസിന്റെ പേര്",
    study_year: "പഠിക്കുന്ന വർഷം",
    course_completing_year: "കോഴ്‌സ് പൂർത്തിയാക്കുന്ന വർഷം",
    other_course_details:
      "മുകളിലുള്ള ലിസ്റ്റിൽ ഇല്ലെങ്കിൽ അല്ലെങ്കിൽ മറ്റ് വിവരങ്ങൾ ഉണ്ടെങ്കിൽ ഇവിടെ നൽകുക",
    job_category: "ജോലി വിഭാഗം",
    job: "ജോലി",
    job_sub_category: "ജോലി ഉപവിഭാഗം",
    job_divisions: "ജോലി ഡിവിഷനുകൾ",
    job_sub_divisions: "ജോലി ഉപഡിവിഷനുകൾ",
    other_job_details:
      "മുകളിലുള്ള ലിസ്റ്റിൽ ഇല്ലെങ്കിൽ അല്ലെങ്കിൽ മറ്റ് ജോലിയുമായി ബന്ധപ്പെട്ട വിവരങ്ങൾ ഇവിടെ നൽകുക",
    // Summary / Signature (Malayalam translations)
    summary_title: "g. സംഗ്രഹം & ഒപ്പ്",
    summary_title_profile: "സംഗ്രഹം & ഒപ്പ്",
    agreement_title: "അനുമതി എഴുത്ത്",
    agreement_paragraph:
      "പരിശുദ്ധ ഖുര്‍ആനും സ്വഹീഹായ ഹദീസ് എന്നിവയും സച്ചരിതരായ മുൻഗാമികളുടെ നിർദേശപ്രകാരം സംഘടനയുടെ നിയമങ്ങളും ചട്ടങ്ങളും പിന്തുടർന്ന് പ്രവർത്തിക്കുമെന്ന് ഞാൻ ഇവിടെ സാക്ഷ്യം നൽകുന്നു.",
    agree_label:
      "ഞാൻ മേൽപ്പറഞ്ഞ എല്ലാ നിബന്ധനകളെയും നിബന്ധനകളും സമ്മതിക്കുന്നു",
    viewing_other_notice:
      "ഇത് മറ്റൊരാളുടെ ബയോഡാറ്റയാണ്, അതിനാൽ നിങ്ങൾക്ക് ഇത് എഡിറ്റ് ചെയ്യാൻ സാധിക്കില്ല",
    member_signature: "അംഗത്തിന്റെ ഒപ്പ്",
    member_signature_mal: "അംഗത്തിന്റെ ഒപ്പ്",
    reupload_signature: "ഒപ്പ് വീണ്ടും അപ്ലോഡ് ചെയ്യുക",
    cancel_keep_signature: "റദ്ദാക്കുക & നിലവിലുള്ള ഒപ്പ് സൂക്ഷിക്കുക",
    signature_saved_title: "ഒപ്പ് സേവ് ചെയ്തു!",
    signature_saved_text: "നിങ്ങളുടെ ഒപ്പ് വിജയകരമായി സേവ് ചെയ്തു.",
    signature_save_error:
      "ഒപ്പ് സേവ് ചെയ്യുമ്പോൾ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    // Disability Info
    disability_section_title: "F. ശാരീരീരിക വെല്ലുവിളികൾ",
    disability_section_title_profile: "ശാരീരീരിക വെല്ലുവിളികൾ",
    disability_label: "ശാരീരീരിക വെല്ലുവിളികൾ",
    // save_next and next already defined above
    select_disability: "ശാരീരീരിക വെല്ലുവിളികൾ സെലക്ട് ചെയ്യുക!",
    child_label: "ഉപ വെല്ലുവിളികൾ",
    // Extra Activity Info
    extra_activity_section_title: "E. മറ്റു കഴിവുകൾ / അഭിരുചികൾ",
    extra_activity_section_title_profile: "മറ്റു കഴിവുകൾ / അഭിരുചികൾ",
    islahi_year_label:
      "സലഫി/ ഇസ്ലാഹി സംഘടനാ രംഗത്ത് എത്രകാലമായി പ്രവർത്തിക്കുന്നു?",
    other_org_label:
      "മറ്റു സാമൂഹ്യ രാഷ്ട്രീയ സംഘടനകളിൽ പ്രവർത്തിക്കുന്നുണ്ടോ? ഉണ്ടെങ്കിൽ വിവരങ്ങൾ?",
    contribute_label:
      "താങ്കൾക്ക് പ്രവർത്തിക്കാൻ കഴിയുന്ന മേഖലകൾ (ചുരുങ്ങിയത് മൂന്ന് എണ്ണം തിരഞ്ഞെടുക്കുക)",
    contribute_label_balavedi:
      "നിങ്ങൾക്ക് ചെയ്യാൻ ഇഷ്ടമുള്ള, കൂടുതൽ കഴിവുള്ള കാര്യങ്ങൾ തിരഞ്ഞെടുക്കൂ",
    social_media_label: "സോഷ്യൽ മീഡിയ",
    save_next: "സേവ് & അടുത്തത്",
    next: "അടുത്തത്",
    permanent_address_india: "സ്ഥിരം മേൽവിലാസം(ഇന്ത്യയിൽ)",
    outside_state_india: "സംസ്ഥാനത്തിന് പുറത്ത് (ഇന്ത്യയിൽ)",
    abroad: "വിദേശത്ത് ആണ്",
    bio_data_sections: "ബയോഡാറ്റ സെക്ഷനുകൾ",
    payment_information: "പേയ്മെന്റ് വിവരങ്ങൾ",
    amount_to_pay: "പേയ് ചെയ്യേണ്ട തുക",
    pending: "പെൻഡിംഗ്",
    paid: "പെയ്ഡ്",
    make_payment: "പേയ്മെന്റ് ചെയ്യുക",
    download_receipt: "രസീത് ഡൗൺലോഡ് ചെയ്യുക",

    my_district: "എന്റെ ജില്ല",
    my_zone: "എന്റെ മണ്ഡലം",
    my_unit: "എന്റെ ശാഖ",
    go_to_branch: "ശാഖയിലേക്ക് പോകാൻ ഇവിടെ അമർത്തുക",
    go_to_lajna: "ലജ്‌ന പേജിലേക് പോകാൻ ഇവിടെ അമർത്തുക",
    my_campus: "എന്റെ ക്യാമ്പസ്",
    membership_biodata: "മെമ്പർഷിപ്പ് & ബയോഡാറ്റ",
    membership_details: "മെമ്പർഷിപ്പ് വിവരങ്ങൾ",
    membership_details_update: "മെമ്പർഷിപ്പ് വിവരങ്ങളും ബയോഡാറ്റ അപ്ഡേഷനുകളും",
    nerpatham: "നേർപഥം",
    nerpatham_desc: "നേർപഥം ചേർക്കാനും പുതുക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
    my_biodata_form: "എന്റെ ബയോ ടാറ്റ ഫോം",
    biodata_fill_edit:
      "ബയോ ഡാറ്റ ഫിൽ ചെയ്യാൻ/എഡിറ്റ് ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
    qr_code_scanner: "ക്യു ആർ കോഡ് സ്കാനർ.",
    qr_code_attendance_desc:
      "ക്യു ആർ കോഡ് വെച്ച് അറ്റന്റൻസ് മാർക്ക് ചെയ്യാൻ ഇവിടെ അമർത്തുക",
    change_pin: "പിൻ നമ്പർ മാറ്റാൻ ഇവിടെ അമർത്തുക",
    app_version: "ആപ്പ് പതിപ്പ്",
    logout: "ലോഗ് ഔട്ട്",
    wisdom: "വിസ്ഡം",
    youth: "യൂത്ത്",
    students: "സ്റ്റുഡന്റ്സ്",
    women: "വുമൺ",
    girls: "ഗേൾസ്",
    members_payments_btn:
      "ഫീസ് അടച്ചതിന്റെ വിവരങ്ങൾ കാണാനും. ഫീസ് അടക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    membership_report_download_btn:
      "മെമ്പർഷിപ് റിപ്പോർട്ട് ഡൌൺലോഡ് ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    membership_consolidated_report_btn:
      "മെമ്പർഷിപ് കൺസോളിഡേറ്റഡ് റിപ്പോർട്ട് കാണാനും മണ്ഡലത്തിലേക്ക് അയക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    membership_form_bulk_download_btn:
      "എല്ലാ പ്രവാസികളുടെയും  പ്രിന്റ്  ഒരുമിച്ചു ഡൌൺലോഡ് ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    form_collection: "ഫോം ശേഖരണം",
    status: "സ്റ്റാറ്റസ്",
    collected: "ശേഖരിച്ചു",
    not_collected: "ശേഖരിച്ചിട്ടില്ല",
    subscription: "വരിക്ക",
    is_subscriber: "നിലവിൽ വരിക്കാരൻ ആണോ?",
    receipt_number: "രസീത് നമ്പർ",
    subscription_number: "വരിക്ക നമ്പർ",
    current_status: "ഇപ്പോഴത്തെ സ്റ്റാറ്റസ്",
    select: "---തിരഞ്ഞെടുക്കുക---",
    place: "സ്ഥലം",
    abroad_mobile: "വിദേശത്തെ മൊബൈൽ നമ്പർ",
    action: "നടപടി",
    approve_transfer: "ട്രാൻസ്ഫർ അംഗീകരിക്കുക",
    reject_transfer: "ട്രാൻസ്ഫർ നിരാകരിക്കുക",
    call: "കാൾ ചെയ്യുക",
    restore_to_members_list: "മെമ്പർമാർ ലിസ്റ്റിലേക്ക് തിരിച്ചെടുക്കുക",
    send_guide_link: "ഗൈഡ് ലിങ്ക് അയയ്ക്കുക",
    edit: "എഡിറ്റ് ചെയ്യുക",
    download_form: "ഫോം ഡൗൺലോഡ് ചെയ്യുക",
    form_collected_status: "ഫോം ശേഖരിച്ച നില",
    renew_member: "മെമ്പർ പുതുക്കുക",
    qhls_register: "QHLS രജിസ്റ്റർ ചെയ്യാൻ",
    transfer_to_unit: "യൂണിറ്റിലേക്ക് ട്രാൻസ്ഫർ ചെയ്യുക",
    verification_report: "വെരിഫിക്കേഷൻ റിപ്പോർട്ട്",
    print_biodata: "ബയോഡാറ്റ പ്രിന്റ് ചെയ്യുക",
    view_biodata: "ബയോഡാറ്റ കാണുക",
    delete_request: "ഡിലീറ്റ് അഭ്യർത്ഥന",
    send_to_pending_members_list: "പെൻഡിംഗ് മെമ്പർ ലിസ്റ്റിലേക്ക് അയയ്ക്കുക",
    approve_delete_request: "ഡിലീറ്റ് അഭ്യർത്ഥന അംഗീകരിക്കുക",
    reject_delete_request: "ഡിലീറ്റ് അഭ്യർത്ഥന നിരാകരിക്കുക",
    cancel_delete_request: "ഡിലീറ്റ് അഭ്യർത്ഥന റദ്ദാക്കുക",
    cancel: "റദ്ദാക്കുക",
    change_unit: "യൂണിറ്റ് മാറ്റുക",
    select_district: "ജില്ല തിരഞ്ഞെടുക്കുക",
    select_zone: "മണ്ഡലം തിരഞ്ഞെടുക്കുക",
    select_unit: "യൂണിറ്റ് തിരഞ്ഞെടുക്കുക",
    reason: "കാരണം",
    submit: "സമർപ്പിക്കുക",
    click_here_to_view_and_pay_fee_details:
      "ഫീസ് അടച്ചതിന്റെ വിവരങ്ങൾ കാണാനും. ഫീസ് അടക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    click_here_to_download_membership_report:
      "മെമ്പർഷിപ് റിപ്പോർട്ട് ഡൌൺലോഡ് ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
    click_here_to_consolidated_report:
      "മെമ്പർഷിപ് കൺസോളിഡേറ്റഡ് റിപ്പോർട്ട് കാണാനും മണ്ഡലത്തിലേക്ക് അയക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    click_here_to_bulk_download_expatriate_prints:
      "എല്ലാ പ്രവാസികളുടെയും  പ്രിന്റ്  ഒരുമിച്ചു ഡൌൺലോഡ് ചെയ്യാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
    edit_member: "മെമ്പർ എഡിറ്റ് ചെയ്യുക",
    add_member: "മെമ്പർ ചേർക്കുക",
    renew_membership: "മെമ്പർഷിപ്പ് പുതുക്കുക",
    member_current_status: "ഇപ്പോഴത്തെ സ്റ്റാറ്റസ്",
    lajna_membership: "ലജ്‌ന മെമ്പർഷിപ്പ്",
    lajna_member_status: "ലജ്‌ന മെമ്പർ സ്റ്റാറ്റസ്",
    not_member: "അംഗമല്ല",
    is_member: "അംഗമാണ്",
    download_biodata: "ബയോഡാറ്റ ഡൗൺലോഡ് ചെയ്യുക",
    restore_member: "മെമ്പർ തിരിച്ചെടുക്കുക",
    transfer_unit_actions: "യൂണിറ്റ് ട്രാൻസ്ഫർ നടപടികൾ",
    not_registered: "റജിസ്റ്റർ ചെയ്തിട്ടില്ല",
    registered: "രജിസ്റ്റർ ചെയ്തവർ",
    eligible: "പങ്കെടുക്കേണ്ടവർ",
    forign_mobile: "വിദേശത്തെ മൊബൈൽ നമ്പർ",
    no_information: "വിവരം ലഭ്യമല്ല",
    active_in_native: "നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് ആണ്",
    not_active_in_native: "നാട്ടിൽ ഉണ്ട് ആക്റ്റീവ് അല്ല",
    membership_verification: "മെമ്പർഷിപ്പ് വെരിഫിക്കേഷൻ",
    verification_status: "വെരിഫിക്കേഷൻ സ്റ്റാറ്റസ്",
    verified: "വെരിഫൈ ചെയ്തു",
    not_verified: "വെരിഫൈ ചെയ്തിട്ടില്ല",
    not_verified_reason: "വെരിഫൈ ചെയ്യാത്ത കാരണം",
    remark: "റിമാർക്ക്",
    verified_completed: "വെരിഫിക്കേഷൻ പൂർത്തിയായി",
    verification_not_completed: "വെരിഫിക്കേഷൻ പൂർത്തിയാക്കിയിട്ടില്ല",
    mobile_number: "മൊബൈൽ നമ്പർ",
    whatsapp_number: "വാട്സ്ആപ്പ് നമ്പർ",
    enter_name: "പേര് നൽകുക",
    wing: "വിഭാഗം",
    wings: "വിഭാഗങ്ങൾ",
    select_wing: "വിഭാഗം തിരഞ്ഞെടുക്കുക",
    member_details: "അംഗത്തിന്റെ വിശദാംശങ്ങൾ",
    age: "വയസ്സ്",
    enter_age: "വയസ്സ് നൽകുക",
    select_profession: "ജോലി തിരഞ്ഞെടുക്കുക",
    name_regex: "പേര് ഇംഗീഷിൽ തന്നെ ടൈപ്പ് ചെയ്യുക!",
    name_required: "പേര് ടൈപ്പ് ചെയ്യുക!",
    age_required: "വയസ്സ് ടൈപ്പ് ചെയ്യുക!",
    job_required: "ജോലി തിരഞ്ഞെടുക്കുക!",
    mobile_required: "മൊബൈൽ നമ്പർ ടൈപ്പ് ചെയ്യുക!",
    wing_required: "വിങ് സെലക്ട് ചെയ്യുക!",
    associated: "നമ്മുടെ കൂട്ടായ്മയുമായി ഇദ്ദേഹം ബന്ധപ്പെടുന്നത് എങ്ങിനെയാണ് ?",
    of: "നിന്നും",
    options_selected: "ഓപ്ഷനുകൾ തിരഞ്ഞെടുത്തു",
    member_status: "അംഗത്തിന്റെ സ്ഥിതി",
    membership_status: "മെമ്പർഷിപ്പ് സ്ഥിതി",
    note: "കുറിപ്പ്",
    add: "ചേർക്കുക",
    education_required:
      "സ്കൂൾ/ക്യാമ്പസ്/കോഴ്സ് വിവരങ്ങൾ പൂർത്തിയാക്കിയിട്ടില്ല",
    remove: "ഒഴിവാക്കുക",
    move_to_members_list: "മെമ്പർമാർ ലിസ്റ്റിലേക്ക് മാറ്റുക",
    no_data: "ഡാറ്റ ലഭ്യമല്ല",
    become_member: "അംഗമാകുക",
    save_member_list: "സേവ് ചെയ്ത് മെമ്പർമാർ ലിസ്റ്റിലേക്ക് മാറ്റുക",
    select_reason: "കാരണം തിരഞ്ഞെടുക്കുക",
    incorrectly_added: "തെറ്റായി ചേർത്തതാണ്",
    move_to_karad_list: "കരട് ലിസ്റ്റിലേക്ക് മാറ്റുക",
    optional: "നിർബന്ധമല്ല",
    cluster_admin_add:
      "നിങ്ങളുടെ ശാഖയിലെ ക്ലസ്റ്ററുകൾ മണ്ഡലം അഡ്മിന്മാർ ചേർക്കും",
    search_clusters: "ക്ലസ്റ്ററുകൾ സെർച്ച് ചെയ്യുക...",
    add_cluster: "ക്ലസ്റ്റർ ചേർക്കുക",
    delete_selected: "തിരഞ്ഞെടുത്തവ ഡിലീറ്റ് ചെയ്യുക",
    no_clusters: "ഈ യൂണിറ്റിൽ ക്ലസ്റ്ററുകൾ ഇല്ല",
    cluster_selected: "ക്ലസ്റ്റർ തിരഞ്ഞെടുക്കപ്പെട്ടത്",
    no_clusters_available: "തിരഞ്ഞെടുത്ത പഞ്ചായത്തിൽ ക്ലസ്റ്ററുകൾ ലഭ്യമല്ല",
    select_all: "എല്ലാ ക്ലസ്റ്ററുകളും തിരഞ്ഞെടുക്കുക",
    not_editable: "താകളുടെ ശാഖയിൽ മാത്രമേ താകൾക്ക് വിവരങ്ങൾ നൽകാൻ കഴിയൂ",
    basic_information: "അടിസ്ഥാന വിവരങ്ങൾ",
    has_centre: "ശാഖാ പ്രവർത്തനങ്ങൾക്ക് ഒരു കേന്ദ്രം നിലവിൽ ഉണ്ടോ ?",
    yes_2: "ഉണ്ട്",
    no_2: "ഇല്ല",
    building_type: "കെട്ടിടത്തിന്റെ തരം",
    own: "സ്വന്തം കെട്ടിടം",
    rent: "വാടക കെട്ടിടം",
    worker_home: "പ്രവർത്തകൻ്റെ വീട്",
    other: "മറ്റുള്ളവ",
    office_location: "ഓഫീസ് സ്ഥലം",
    enter_office_location: "ഓഫീസ് സ്ഥലം നൽകുക",
    masjid_details: "പള്ളിയുടെ വിവരങ്ങൾ",
    enter_masjid_location: "ഗൂഗിൾ മാപ്പിൽ നിന്ന് പള്ളി ലൊക്കേഷൻ നൽകുക",

    has_masjid_mujahid: "ശാഖയിൽ മുജാഹിദ് പള്ളി ഉണ്ടോ ?",
    masjid: "പള്ളി",
    masjid_affiliation: "പള്ളി ഏത് സംഘടനയുമായി ബന്ധപ്പെട്ടിരിക്കുന്നു ?",
    knm: "കെ.എൻ.എം",
    markaz: "മർകസ് ദഅവ",
    masjid_location: "പള്ളിയുടെ ലൊക്കേഷൻ",
    has_jumua: "ജുമുഅ നടക്കുന്ന പള്ളി ആണോ ?",
    jumua_attendance: "ജുമുഅ ഉണ്ടെങ്കിൽ എത്ര പേര് ഏകദേശം പങ്കെടുക്കും ?",
    select_range: "പരിധി തിരഞ്ഞെടുക്കുക",
    under_100: "100-ൽ താഴെ",
    between_100_300: "100-300",
    between_300_500: "300-500",
    between_500_1000: "500-1000",
    above_1000: "1000-ൽ മുകളിൽ",
    parking_capacity: "എത്ര വാഹനങ്ങൾക്ക് പാർക്കിംഗ് സൗകര്യം ഉണ്ട് ?",
    enter_parking_capacity: "വാഹനങ്ങളുടെ എണ്ണം നൽകുക",
    facilities: "പള്ളിയിൽ ഉള്ള സൗകര്യങ്ങൾ",
    women_facility: "സ്ത്രീകൾക്ക് സൗകര്യം",
    meeting_hall: "മീറ്റിംഗ് ഹോൾ",
    ac_facility: "എയർ കണ്ടീഷൻ സൗകര്യം",
    staff_count: "പള്ളിയുടെ കീഴിൽ എത്ര ജീവനക്കാർ ഉണ്ട് ?",
    enter_staff_count: "ജീവനക്കാരുടെ എണ്ണം നൽകുക",
    imam_name: "ഇമാമിൻ്റെ പേര്",
    enter_imam_name: "ഇമാമിൻ്റെ പേര് നൽകു",
    imam_state: "ഇമാമിൻ്റെ സംസ്ഥാനം",
    enter_imam_state: "ഇമാമിൻ്റെ സംസ്ഥാനം നൽകുക",
    imam_phone: "ഇമാമിൻ്റെ ഫോൺ നമ്പർ",
    enter_imam_phone: "ഇമാമിൻ്റെ ഫോൺ നമ്പർ നൽകുക",
    add_masjid: "പള്ളി ചേർക്കുക",

    madrasa_details: "മദ്റസ വിവരങ്ങൾ",
    has_madrasa_mujahid: "മുജാഹിദ് മദ്റസ ഉണ്ടോ ?",
    madrasa: "മദ്റസ",
    madrasa_affiliation: "മദ്റസ ഏത് സംഘടനയുമായി ബന്ധപ്പെട്ടിരിക്കുന്നു ?",
    madrasa_name: "മദ്റസയുടെ പേര്",
    enter_madrasa_name: "മദ്റസയുടെ പേര് നൽകുക",
    madrasa_started_year: "മദ്റസ ആരംഭിച്ച വർഷം",
    enter_madrasa_started_year: "മദ്റസ ആരംഭിച്ച വർഷം നൽകുക",
    class_format: "ക്ലാസ്സ് രൂപം",
    daily: "ദൈനംദിനം",
    weekly: "ആഴ്ചയിൽ ഒരിക്കൽ",
    madrasa_location: "മദ്റസയുടെ ലൊക്കേഷൻ",
    enter_madrasa_location: "ഗൂഗിൾ മാപ്പിൽ നിന്ന് മദ്റസയുടെ ലൊക്കേഷൻ നൽകുക",
    add_madrasa: "മദ്റസ ചേർക്കുക",

    arabic_college_details: "അറബിക് കോളേജ് വിവരങ്ങൾ",
    has_arabic_college_mujahid: "മുജാഹിദ് അറബിക് കോളേജ് ശാഖയിൽ ഉണ്ടോ ?",
    college_affiliation:
      "അറബിക് കോളേജ് ഏത് സംഘടനയുമായി ബന്ധപ്പെട്ടിരിക്കുന്നു ?",
    college_building_type: "അറബിക് കോളേജിന്റെ കെട്ടിടത്തിന്റെ തരം",
    college_name: "അറബിക് കോളേജിന്റെ പേര്",
    enter_college_name: "കോളേജിന്റെ പേര് നൽകുക",
    college_started_year: "തുടങ്ങിയ വർഷം",
    enter_college_started_year: "തുടങ്ങിയ വർഷം നൽകുക",
    course_details: "കോഴ്സ് വിവരങ്ങൾ",
    plus2: "പ്ലസ് 2",
    afsalul_ulama_prelim: "അഫ്സൽ അൽ-ഉലമ പ്രിലിമിനറി",
    afsalul_ulama_final: "അഫ്സൽ അൽ-ഉലമ ഫൈനൽ",
    number_of_teachers: "എത്ര അധ്യാപകർ ഉണ്ട് ?",
    enter_teachers_count: "അധ്യാപകരുടെ എണ്ണം നൽകുക",
    college_location: "അറബിക് കോളേജിന്റെ ലൊക്കേഷൻ",
    enter_college_location: "ഗൂഗിൾ മാപ്പിൽ നിന്ന് ലൊക്കേഷൻ നൽകുക",

    social_media_details: "സോഷ്യൽ മീഡിയ വിശദാംശങ്ങൾ",
    social_media_details_unit:
      "ശാഖയിൽ നിലവിലുള്ള സോഷ്യൽ മീഡിയ ലിങ്കുകൾ താഴെ കൊടുക്കുക",
    facebook: "ഫേസ്ബുക്ക്",
    enter_facebook_link: "ഫേസ്ബുക്ക് ലിങ്ക് നൽകുക",
    youtube: "യൂട്യൂബ്",
    enter_youtube_link: "യൂട്യൂബ് ലിങ്ക് നൽകുക",
    instagram: "ഇൻസ്റ്റഗ്രാം",
    enter_instagram_link: "ഇൻസ്റ്റഗ്രാം ലിങ്ക് നൽകുക",
    wisdom_media: "വിസ്ഡം മീഡിയ",
    enter_wisdom_media_link: "വിസ്ഡം മീഡിയ ലിങ്ക് നൽകുക",

    land_and_building: "ഭൂമി & കെട്ടിടം",
    wisdom_land: "ശാഖയുടെ നിയന്ത്രണത്തിൽ ഉള്ള വിസ്ഡം ഭൂമി (സെൻ്റ്)",
    land_in_cent: "ഭൂമി സെൻ്റിൽ",
    trust_land: "ട്രസ്റ്റ് നിയന്ത്രണത്തിൽ ഉള്ള ഭൂമി (സെൻ്റ്)",
    enter_trust_land_in_cent: "ട്രസ്റ്റ് ഭൂമി സെൻ്റിൽ നൽകുക",
    other_land: "ശാഖയുടെ നിയന്ത്രണത്തിൽ ഉള്ള മറ്റ് ഭൂമി",
    enter_other_land: "മറ്റു ഭൂമി സെൻ്റിൽ നൽകുക",

    qhls_details: "QHLS വിശദാംശങ്ങൾ",
    qhls: "QHLS",
    qhls_name: "QHLS പേര്",
    enter_qhls_name: "QHLS പേര് നൽകുക",
    qhls_location: "QHLS ലൊക്കേഷൻ",
    enter_qhls_location: "ഗൂഗിൾ മാപ്പിൽ നിന്ന് QHLS ലൊക്കേഷൻ നൽകുക",
    convener_name: "കൺവീനർ പേര്",
    enter_convener_name: "കൺവീനർ പേര് നൽകുക",
    convener_phone: "കൺവീനർ ഫോൺ നമ്പർ",
    enter_convener_phone: "കൺവീനർ ഫോൺ നമ്പർ നൽകുക",
    day: "നടക്കുന്ന ദിവസം",
    select_day: "ദിവസം തിരഞ്ഞെടുക്കുക",
    monday: "തിങ്കൾ",
    tuesday: "ചൊവ്വ",
    wednesday: "ബുധൻ",
    thursday: "വ്യാഴം",
    friday: "വെള്ളി",
    saturday: "ശനി",
    sunday: "ഞായർ",
    time: "സമയം",
    hour: "മണിക്കൂർ",
    qhls_participants_count: "പങ്കെടുക്കുന്നവരുടെ എണ്ണം",
    enter_qhls_participants_count: "പങ്കെടുക്കുന്നവരുടെ എണ്ണം നൽകുക",
    qhls_started_year: "QHLS ആരംഭിച്ച വർഷം",
    enter_qhls_started_year: "QHLS ആരംഭിച്ച വർഷം നൽകുക",
    qhls_frequency: "ആവൃത്തി",
    monthly: "മാസത്തിൽ ഒരിക്കൽ",
    add_qhls: "QHLS ചേർക്കുക",

    cre_details: "CRE വിശദാംശങ്ങൾ",
    cre: "CRE",
    cre_day: "CRE നടക്കുന്ന ദിവസം",

    other_services: "മറ്റു സേവനങ്ങൾ",
    zakath_cell: "സഖത്ത് സെൽ",
    orphan_care: "അനാഥ ശുശ്രൂഷ",
    orphan_count: "സഹായം നൽകുന്ന കുട്ടികളുടെ എണ്ണം",
    enter_orphan_count: "കുട്ടികളുടെ എണ്ണം നൽകുക",
    wisdom_healthcare: "വിസ്ഡം ഹെൽത്ത് കെയർ",
    main_healthcare_activities: "പ്രധാന പ്രവർത്തനങ്ങൾ",
    enter_main_healthcare_activities: "പ്രധാന പ്രവർത്തനങ്ങൾ നൽകുക",
    hifdh_college: "ഖുർആൻ ഹിഫ്ദ് കോളേജ്",
    hifdh_students_count: "പഠിക്കുന്ന കുട്ടികളുടെ എണ്ണം",
    enter_hifdh_students_count: "കുട്ടികളുടെ എണ്ണം നൽകുക",
    library: "ലൈബ്രറി",
    book_sales: "പുസ്തക വിൽപ്പന",
    peace_radio: "പീസ് റേഡിയോ കിയോസ്ക്ക്",

    other_institutions: "മറ്റു സ്ഥാപനങ്ങൾ",
    enter_other_institution_1: "മറ്റു സ്ഥാപനത്തിന്റെ പേര് 1",
    enter_other_institution_2: "മറ്റു സ്ഥാപനത്തിന്റെ പേര് 2",
    enter_other_institution_3: "മറ്റു സ്ഥാപനത്തിന്റെ പേര് 3",

    election_report: "{level} ഇലക്ഷൻ റിപ്പോർട്ട് കാണാൻ ഇവിടെ അമർത്തുക",
    edit_executive_member: "എക്സിക്യൂട്ടീവ് അംഗം എഡിറ്റ് ചെയ്യുക",
    add_executive_member: "എക്സിക്യൂട്ടീവ് അംഗം ചേർക്കുക",

    executive_count: "എക്സിക്യൂട്ടീവ് എണ്ണം",
    exc_count: "എക്സിക്യൂട്ടീവ് എണ്ണം",
    executive_count_selected: "എക്സിക്യൂട്ടീവ് ആയി സെലക്ട് ചെയ്തവരുടെ എണ്ണം",
    enter_executive_count: "എക്സിക്യൂട്ടീവ് അംഗങ്ങളുടെ എണ്ണം നൽകുക",
    election_minutes_upload: "മിനിറ്റ്സ് അപ്ലോഡ്",
    existing_files: "നിലവിലുള്ള ഫയലുകൾ",
    uploaded: "അപ്ലോഡ് ചെയ്തു",
    select_new_files_replace_old:
      "പുതിയ ഫയലുകൾ സെലക്ട് ചെയ്യുക (അപ്ലോഡ് ചെയ്യുമ്പോൾ പഴയവ മാറ്റി പുതിയവ ചേർക്കും)",
    select_minutes_files: "മിനിറ്റ്സ് ഫയലുകൾ സെലക്ട് ചെയ്യുക",
    allowed_file_types:
      "ഇമേജുകൾ, PDF, Word ഫയലുകൾ അപ്ലോഡ് ചെയ്യാം. ഒന്നിലധികം ഫയലുകൾ സെലക്ട് ചെയ്യാം.",
    selected_files: "സെലക്ട് ചെയ്ത ഫയലുകൾ",
    uploading_files: "അപ്ലോഡ് ചെയ്യുന്നു...",
    replaced_files: "റീ-അപ്ലോഡ് ചെയ്യുക",
    upload_files: "അപ്ലോഡ് ചെയ്യുക",
    close: "അടയ്ക്കുക",
    exc_members_count: "എക്സിക്യൂട്ടീവ് അംഗങ്ങളുടെ എണ്ണം :",
    list: "ലിസ്റ്റ്",

    unit: "ശാഖ",
    designation: "പദവി",

    field_required: "ഈ ഫീൽഡ് നിർബന്ധമാണ്",
    building_type_required: "കെട്ടിടത്തിന്റെ തരം നിർബന്ധമാണ്",
    office_location_required: "ഓഫീസ് സ്ഥലം നിർബന്ധമാണ്",
    masjid_required: "മസ്ജിദ് വിശദാംശങ്ങൾ നിർബന്ധമാണ്",
    college_affiliation_required: "കോളേജ് ബന്ധം നിർബന്ധമാണ്",
    college_building_type_required: "കോളേജ് കെട്ടിടത്തിന്റെ തരം നിർബന്ധമാണ്",
    college_name_required: "കോളേജ് നാമം നിർബന്ധമാണ്",
    hour_required: "മണിക്കൂർ നിർബന്ധമാണ്",
    convener_phone_required: "കൺവീനർ ഫോൺ നമ്പർ നിർബന്ധമാണ്",
    wing_required_field: "വിങ് നിർബന്ധമാണ്",
    designation_required: "പദവി നിർബന്ധമാണ്",
    executive_members_list: "ഭാരവാഹികളുടെ ലിസ്റ്റ്",

    edit_election_officer: "ഇലക്ഷൻ ഓഫീസർ എഡിറ്റ് ചെയ്യുക",
    add_election_officer: "ഇലക്ഷൻ ഓഫീസർ ചേർക്കുക",
    code: "കോഡ്",
    election_officers_list: "ഇലക്ഷൻ ഓഫീസർമാരുടെ ലിസ്റ്റ്",

    country_code_required: "രാജ്യ കോഡ് നിർബന്ധമാണ്",
    mobile_number_length: "മൊബൈൽ നമ്പർ 10 അക്കങ്ങൾ ആയിരിക്കണം",
    mobile_number_required: "മൊബൈൽ നമ്പർ നിർബന്ധമാണ്",
    clusters_list: "ക്ലസ്റ്റർ ലിസ്റ്റ്",
    no_members_added: "ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല",
    attendance: "അറ്റന്റൻസ്",

    language: "ഭാഷ",
    create_new_account: "പുതിയ അക്കൗണ്ട് ഉണ്ടാക്കുക",
    login: "ലോഗിൻ",
    home: "ഹോം",
    menu: "മെനു",
    registration_links: "രജിസ്ട്രേഷൻ ലിങ്കുകൾ",
    latest_news: "ഏറ്റവും പുതിയ വാർത്തകൾ.",
    read_more: "കൂടുതൽ വായിക്കുക",
    apps_links: "ആപ്പുകൾ & ലിങ്കുകൾ",
    social_profiles: "സോഷ്യൽ പ്രൊഫൈലുകൾ",
    city_kozhikode: "കോഴിക്കോട്",
    city_thiruvananthapuram: "തിരുവനന്തപുരം",
    city_kasargod: "കാസർഗോഡ്",
    city_kochi: "കൊച്ചി",
    loading: "ലോഡിംഗ്...",
    salah_fajr: "ഫജർ",
    salah_dhuhr: "ദുഹർ",
    salah_asr: "അസർ",
    salah_maghrib: "മഗ്രിബ്",
    salah_isha: "ഇഷാ",
    help_desk: "ഹെൽപ്പ് ഡെസ്ക്",
    how_to_use_app: "1. വിസ്‌ഡം ഗൈഡ് മൊബൈൽ ആപ്പ് എവിടെ നിന്ന് ലഭിക്കും",
    how_to_use_app_link:
      "http://guide.wisdomislam.org/ എന്ന ലിങ്കിൽ കയറിയാൽ ആർക്കും ആപ്പ് ലഭിക്കും.",
    availability: "2. എല്ലാ മൊബൈൽ ഫോണുകളിലും ആപ്പ് ലഭിക്കുമോ?",
    yes_availability:
      "ലഭിക്കും ആൻഡ്രോയിഡ്, ios, വിൻഡോസ് തുടങ്ങി എല്ലാ മൊബൈൽ ഫോണുകളിലും കമ്പ്യൂട്ടറുകളിലും ലാപ്ടോപ്പുകളിലും വിസ്‌ഡം ഗൈഡ് ഉപയോഗിക്കാൻ സാധിക്കും.",
    how_to_install: "3. ലിങ്കിൽ നിന്ന് എങ്ങനെയാണ് ആപ്പ് ഉപയോഗിക്കുക",
    how_to_install_link:
      "ലിങ്കിൽ ക്ലിക്ക് ചെയ്താൽ ലിങ്ക് നിങ്ങളുടെ ഡിവൈസിലെ ബ്രൗസറിൽ (ഉദാ: google chrome, etc.) ആണ് തുറക്കുക. ഇവിടെ നിന്നും ഒരു മൊബൈൽ ആപ്പ് ഉപയോഗിക്കുന്ന രീതിയിൽ നിങ്ങളുടെ ഫോണിലേക്ക് ഇൻസ്റ്റാൾ ചെയ്യാൻ സാധിക്കും. അതിനായി ബ്രൗസറിൽ ഉള്ള add to home എന്ന ഓപ്ഷൻ ഉപയോഗിക്കുക. കൂടുതൽ മനസിലാക്കാൻ ഈ വീഡിയോ കാണുക.",
    how_to_login: "4. ലോഗിൻ ചെയ്യുന്നവർ ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങൾ എന്തൊക്കെ?",
    how_to_login_1:
      "നിങ്ങളുടെ മൊബൈൽ നമ്പർ ഉപയോഗിച്ചാണ് ലോഗിൻ ചെയ്യേണ്ടത്. ആദ്യം ലോഗിൻ ചെയ്യുന്നവർക്ക് SMS ആയി ഒരു പിൻ നമ്പർ ലഭിക്കും. ഈ PIN നമ്പർ മറക്കാതെ ഓർത്തു വെക്കുക. മറ്റൊരു ഡിവൈസിൽ ലോഗിൻ ചെയ്യുമ്പോഴും നിലവിലെ ഡിവൈസിൽ നിന്ന് ലോഗൗട്ട് ചെയ്ത ശേഷം വീണ്ടും ലോഗിൻ ചെയ്യുമ്പോൾ ഒക്കെ ഈ PIN നമ്പർ ആണ് കൊടുക്കേണ്ടത്.",
    how_to_change_pin: "5. ഈ പിൻ നമ്പർ മാറ്റാൻ സാധിക്കുമോ ?",
    how_to_change_pin_1:
      "നിലവിൽ പിൻ നമ്പർ ഇഷ്ടാനുസരണം സെറ്റ് ചെയ്യാനുള്ള ഓപ്ഷൻ Profile എന്ന ഭാഗത്ത് ഉണ്ട്. അത് ഉപയോഗിച്ച് PIN നമ്പർ മാറ്റാവുന്നതാണ്.",
    how_to_get_pin_again: "6. പിൻ നമ്പർ മറന്നുപോയവർ എന്ത് ചെയ്യണം?",
    how_to_get_pin_again_1:
      "ആദ്യ തവണ ചെയ്ത പോലെ മൊബൈൽ നമ്പർ നൽകി വീണ്ടും SMS വഴി PIN നമ്പർ ലഭിക്കാനുള്ള സംവിധാനം ആപ്പിൽ ഉണ്ട്. അത് ഉപയോഗിക്കുക.",
    clear_cache: "കാഷെ മായ്‌ച്ച് ആപ്പ് പുനരാരംഭിക്കുക",
    my_profile: "എന്റെ പ്രൊഫൈൽ",
    meeting_report: "മീറ്റിംഗ് റിപ്പോർട്ട് കാണാൻ ക്ലിക്ക് ചെയ്യുക",
    conducted: "നടന്നു",
    date: "തീയതി",
    location: "സ്ഥലം",
    participants: "പങ്കെടുത്തവർ",
    my_meetings: "എന്റെ മീറ്റിംഗുകൾ",
    create_meeting: "മീറ്റിംഗ് ക്രിയേറ്റ് ചെയ്യുക",
    meeting_level: "മീറ്റിംഗ് ലെവൽ",
    meeting_type: "മീറ്റിംഗ് തരം",
    wing_meeting: "വിങ് മീറ്റിംഗ്",
    meeting_name: "യോഗത്തിന്റെ പേര്",
    meeting_date: "മീറ്റിംഗ്ം നടക്കുന്ന തീയതി",
    meeting_time: "മീറ്റിംഗ്ം നടക്കുന്ന സമയം",
    meeting_mode: "മീറ്റിംഗ് ഓൺലൈനോ/   ഓഫ്‌ലൈനോ ആണോ?",
    physical: "ഓഫ്‌ലൈൻ",
    online: "ഓൺലൈൻ",
    total: "ടോട്ടൽ",
    added_by_member: "അംഗങ്ങൾ ചേർത്തു",
    public: "പബ്ലിക്",
    download_result: "റിസൾട്ട് ഡൗൺലോഡ് ചെയ്യുക",
    nerpatham_target: "നേർപഥം ടാർഗെറ്റ്",
    target: "ടാർഗെറ്റ്",
    enter_target: "ടാർഗെറ്റ് നൽകുക",
    meeting_period: "മീറ്റിംഗിന്റെ കാലയളവ്",
    i_will_attend: "ഞാൻ പങ്കെടുക്കും",
    my_attendance: "എന്റെ അറ്റന്റൻസ്",
    participant_id: "പങ്കെടുക്കുന്നവരുടെ ഐഡി",
    meeting_link: "മീറ്റിംഗ് ലിങ്ക്",
    report: "റിപ്പോർട്ട്",
    qr_code: "QR കോഡ്",
    scanner: "സ്കാനർ",
    all: "എല്ലാവരും",
    present: "ഹാജരായി",
    absent: "ഹാജരായില്ല",
    leave: "ലീവ്",
    my_duties: "എന്റെ ഡ്യൂട്ടികൾ",
    questionnaire: "ചോദ്യാവലി",
    minutes: "മിനിട്‌സ്‌",
    meeting_minutes: "മീറ്റിംഗ് മിനിട്‌സ്‌",
    assigned_member: "അസൈൻ ചെയ്ത അംഗം",
    select_member: "അംഗത്തെ തിരഞ്ഞെടുക്കുക",
    text: "ടെക്സ്റ്റ്",
    select_meeting_mode: "മീറ്റിംഗ് മോഡ് തിരഞ്ഞെടുക്കുക",
    date_from: "തീയതി മുതൽ",
    date_to: "തീയതി വരെ",
    clear: "ക്ലിയർ",
    confirmed: "തീരുമാനം ആയത്",
    increase: "കൂടിയത്",
    decided: "നിശ്ചയിച്ചത്",
    happened: "നടന്നത്",
    fee_status: "ഫീസ് സ്റ്റാറ്റസ്",
    update: "അപ്ഡേറ്റ്",
    balavedi_teams: "ബാലവേദി ടീമുകൾ",
    captain: "ക്യാപ്റ്റൻ",
    select_captain: "ക്യാപ്റ്റനെ തിരഞ്ഞെടുക്കുക",
    current_captain: "നിലവിലെ ക്യാപ്റ്റൻ",
    vice_captain: "വൈസ് ക്യാപ്റ്റൻ",
    select_vice_captain: "വൈസ് ക്യാപ്റ്റനെ തിരഞ്ഞെടുക്കുക",
    current_vice_captain: "നിലവിലെ വൈസ് ക്യാപ്റ്റൻ",
    team_members: "ടീം അംഗങ്ങൾ",
    max_allowed: "പരമാവധി 7 അംഗങ്ങൾ അനുവദനീയമാണ്",
    selected: "തിരഞ്ഞെടുത്തു",
    members_7: "7 അംഗങ്ങൾ",
    new: "പുതിയത്",
    remove_from_team: "ടീമിൽ നിന്ന് നീക്കുക",
    name_english_only: "പേര് (ഇംഗ്ലീഷിൽ മാത്രം)",
    enter_name_required: "പേര് നൽകുക",
    father_name_english_only: "അച്ഛന്റെ പേര് (ഇംഗ്ലീഷിൽ മാത്രം)",
    enter_mobile: "മൊബൈൽ നൽകുക",
    enter_country_code: "കൺട്രി കോഡ് നൽകുക",
    age_minimum: "പ്രായം കുറഞ്ഞത് 1 ആയിരിക്കണം",
    maximum_7_team_members: "പരമാവധി 7 ടീം അംഗങ്ങൾ അനുവദനീയമാണ്",

    delete_reason_1: "മെമ്പർഷിപ്പിന് യോഗ്യനല്ല, തെറ്റായി ചേർത്തതാണ്",
    delete_reason_2:
      "നേരത്തെ നമ്മുടെ പ്രവർത്തകൻ. ഇപ്പൊ താല്പര്യം ഇല്ല എന്ന് പറഞ്ഞു",
    delete_reason_3: "നമ്മുടെ അനുഭാവിയാണ്, മെമ്പർഷിപ്പ് വേണ്ട എന്ന് പറഞ്ഞു",
    delete_reason_4:
      "നമ്മുടെ പ്രവർത്തകനാണ്, പലതവണ ശ്രമിച്ചിട്ടും പ്രതികരിക്കുന്നില്ല",
    delete_reason_5: "ഗൾഫിലാണ്, ബയോഡാറ്റ ഫില്ല് ചെയ്തിട്ടില്ല",
    delete_reason_6:
      "സ്മാർട്ട് ഫോൺ ഇല്ലാത്തതുകൊണ്ട് ബയോഡാറ്റ ഫിൽ ചെയ്തിട്ടില്ല",
    delete_reason_7: "ബയോഡാറ്റ ഫിൽ ചെയ്യാൻ അറിയില്ല, അതുകൊണ്ട് ചെയ്തിട്ടില്ല",
    delete_reason_8: "കരടിലെ നമ്പർ തെറ്റി പോയി. അത് കൊണ്ട് ലോഗിൻ കഴിയുന്നില്ല",
    delete_reason_9:
      "PIN ലഭിക്കുന്നില്ല. അത് കൊണ്ട് ലോഗിൻ ചെയ്യാൻ കഴിയുന്നില്ല",
    delete_reason_other: "മറ്റു കാരണങ്ങൾ",
    bio_data: "ബയോ ഡാറ്റ",
    blood_group_required: "ബ്ലഡ് ഗ്രൂപ്പ് സെലക്ട് ചെയ്യുക!",
    blood_donation_required: "രക്തദാനം സന്നദ്ധത തിരഞ്ഞെടുക്കുക!",
    current_location_required: "താമസിക്കുന്ന പ്രദേശം തിരഞ്ഞെടുക്കുക!",
    select_state_required: "സംസ്ഥാനം തിരഞ്ഞെടുക്കുക!",
    select_country_required: "രാജ്യം തിരഞ്ഞെടുക്കുക!",
    select_abroad_city_required: "സ്ഥലത്തിന്റെ പേര് എഴുതുക!",
    home_name_required: "വീട്ടുപേര് ടൈപ്പ് ചെയ്യുക!",
    country_required: "രാജ്യം തിരഞ്ഞെടുക്കുക!",
    house_status_required: "താമസിക്കുന്ന വീട് സെലക്ട് ചെയ്യുക!",
    fill_status: "ബയോ ഡാറ്റ പൂരിപ്പിക്കാൻ/തിരുത്താൻ ക്ലിക്ക് ചെയ്യുക",
    completed: "പൂർത്തിയായി",
    associated_1: "QHLS വിദ്യാർത്ഥി",
    associated_2: "CRE വിദ്യാർത്ഥി",
    associated_3: "ജുമുഅയിൽ പങ്കെടുക്കും",
    associated_4: "ജമാഅത്തിൽ പങ്കെടുക്കും",
    associated_5: "ഞങ്ങളുടെ യോഗങ്ങളിൽ പങ്കെടുക്കും",
    associated_6: "പൊതു പരിപാടികളിൽ പങ്കെടുക്കും",
    associated_7: "സാമ്പത്തിക സഹായം നൽകും",
    associated_8: "പ്രോഫേസ്/ഫോകസ്‌യിൽ പങ്കെടുത്തു",
    associated_9: "പ്രോഫ്‌കോൺ-ൽ പങ്കെടുത്തു",
    associated_10: "സംസ്ഥാന സമ്മേളനത്തിൽ പങ്കെടുക്കും",
    associated_11: "കുടുംബ സമ്മേളനത്തിൽ പങ്കെടുത്തു",
    associated_12: "വിജ്ഞാനവേദിയിൽ പങ്കെടുക്കും",
    associated_13: "സകാത്ത് സെൽ വഴി",
    associated_14: "ഉധിയ വഴി",
    associated_15: "ഫിത്തർ സകാത്ത് വഴി",
    associated_16: "അനാഥ ശുശ്രൂഷ വഴി",
    associated_17: "വിസ്ഡം ഹെൽത്ത് കെയർ വഴി",
    associated_18: "മറ്റ് വഴികൾ",
    register_now: "ഇപ്പോൾ രജിസ്റ്റർ ചെയ്യുക",
    attended: "പങ്കെടുത്തു",
    quick_actions: "ക്വിക്ക് ആക്ഷൻസ്",
    admin_controls: "അഡ്മിൻ കൺട്രോൾസ്",
    switch_admin_level: "അഡ്മിൻ ലെവൽ മാറ്റുക",
    switch_to: "മാറ്റുക {level} ലെവലിലേക്ക്",
    level: "ലെവൽ",
    self_registration: "സ്വയം രജിസ്ട്രേഷൻ",
    registration_notice: "താങ്കളുടെ നമ്പറിന് കീഴിലുള്ള മെമ്പർമാരുടെ പേര് ടിക്ക് ചെയ്തു രജിസ്റ്റർ ചെയ്യുക.",
    already_registered: "ഇപ്പോൾ തന്നെ രജിസ്റ്റർ ചെയ്തവർ",
    event_dashboard: "ഇവന്റ് ഡാഷ്ബോർഡ്",
    registration_report: "രജിസ്ട്രേഷൻ റിപ്പോർട്ട്",
    registration_summary: "രജിസ്ട്രേഷൻ സമ്മറി",
    male: "പുരുഷൻ",
    female: "സ്ത്രീ",
    male_members: "പുരുഷ അംഗങ്ങൾ",
    female_members: "സ്ത്രീ അംഗങ്ങൾ",
    participants_summary_with_family: "പങ്കാളികളുടെ സംഗ്രഹം [കുടുംബത്തോടുകൂടി]",
    sweet_buds: "സ്വീറ്റ് ബഡ്സ്",
    butterflies: "ബട്ടർഫ്ലൈസ്",
    little_wings: "ലിറ്റിൽ വിംഗ്സ്",
    teenspace: "ടീൻസ്പേസ്",
    event_registration_report: "ഇവന്റ് രജിസ്ട്രേഷൻ റിപ്പോർട്ട്",

    total_unit_election_report: "ആകെ യൂണിറ്റ് തിരഞ്ഞെടുപ്പ് റിപ്പോർട്ട്",
    unit_election_report: "യൂണിറ്റ് തിരഞ്ഞെടുപ്പ് റിപ്പോർട്ട്",

    general_body_council: "മണ്ഡലം ജനറൽ കൗൺസിൽ",
    district_general_body_council: "ജില്ല ജനറൽ കൗൺസിൽ",
    district_womens_council: "ജില്ല വിമെൻസ് കൗൺസിൽ",
    district_girls_council: "ജില്ല ഗേൾസ് കൗൺസിൽ",
    womens_council: "മണ്ഡലം വിമെൻസ് കൗൺസിൽ",
    girls_council: "മണ്ഡലം ഗേൾസ് കൗൺസിൽ",
    org_councilers_list: "ജില്ല / സംസ്ഥാന കൗൺസിലർമാർ",
    unit_level_executives: "യൂണിറ്റ് ലെവൽ എക്സിക്യൂട്ടീവ്",
    zone_level_executives: "മണ്ഡലം ലെവൽ എക്സിക്യൂട്ടീവ്",
    zone: "മണ്ഡലം",
    department: "വിഭാഗം",
    zone_election_report: "മണ്ഡലം തിരഞ്ഞെടുപ്പ് റിപ്പോർട്ട്",
    circulars: "സർക്കുലറുകൾ",
    tap_to_edit: "എഡിറ്റ് ചെയ്യാൻ ടാപ്പ് ചെയ്യുക",
    enter_your_name: "നിങ്ങളുടെ പേര് നൽകുക",
    name_is_required: "പേര് ആവശ്യമാണ്",
    name_updated_successfully: "പേര് വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",
    update_failed: "അപ്ഡേറ്റ് പരാജയപ്പെട്ടു",
    name_too_short: "പേര് കുറഞ്ഞത് 2 അക്ഷരങ്ങൾ ആയിരിക്കണം",
    name_too_long: "പേര് 50 അക്ഷരങ്ങളിൽ കൂടുതൽ ആകരുത്",
    name_invalid_characters: "പേരിൽ അസാധുവായ അക്ഷരങ്ങൾ ഉണ്ട്",
    edit_names: "പേരുകൾ എഡിറ്റ് ചെയ്യുക",
    edit_profile_names: "പ്രൊഫൈൽ പേരുകൾ എഡിറ്റ് ചെയ്യുക",
    loading_profiles: "പ്രൊഫൈലുകൾ ലോഡ് ചെയ്യുന്നു...",
    profile_id: "പ്രൊഫൈൽ ഐഡി",
    no_profiles_found: "പ്രൊഫൈലുകൾ കണ്ടെത്തിയില്ല",
    failed_to_load_profiles: "പ്രൊഫൈലുകൾ ലോഡ് ചെയ്യാൻ കഴിഞ്ഞില്ല",
    profile_name_updated: "പ്രൊഫൈൽ പേര് വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു",

  },

  // Tamil
  ta: {
    abandoned:
      "வரைவு பட்டியலில் தவறுதலாக சேர்க்கப்பட்டது. நமது இலட்சியம் அல்ல.",
    above_1000: "1000-க்கு மேல்",
    abroad: "வெளிநாடு",
    abroad_mobile: "வெளிநாட்டு மொபைல்",
    absent: "வரவில்லை",
    ac_facility: "குளிரூட்டும் வசதி",
    action: "நடவடிக்கை",
    active_in_native: "சொந்த ஊரில் செயலில் உள்ளார்",
    add: "சேர்க்க",
    add_cluster: "கிளஸ்டர் சேர்க்க",
    add_election_officer: "தேர்தல் அதிகாரி சேர்க்க",
    add_executive_member: "நிர்வாக உறுப்பினர் சேர்க்க",
    add_madrasa: "மதரஸா சேர்க்க",
    add_masjid: "மசூதி சேர்க்க",
    add_member: "உறுப்பினர் சேர்க்க",
    add_qhls: "QHLS சேர்க்க",
    added_by_member: "உறுப்பினரால் சேர்க்கப்பட்டது",
    address: "முகவரி",
    afsalul_ulama_final: "அஃப்ஸலுல் உலமா இறுதி",
    afsalul_ulama_prelim: "அஃப்ஸலுல் உலமா முதல்நிலை",
    age: "வயது",
    age_minimum: "வயது குறைந்தது 1 ஆக இருக்க வேண்டும்",
    age_required: "வயது அவசியம்!",
    agree_label:
      "மேலே குறிப்பிட்ட அனைத்து விதிமுறைகளையும் நிபந்தனைகளையும் நான் ஏற்றுக்கொள்கிறேன்",
    agreement_paragraph:
      "குறிப்பிடப்பட்ட போதனைகளின்படி அமைப்பின் விதிகள் மற்றும் ஒழுங்குமுறைகளை ஏற்று செயல்படுவேன் என்று இதன்மூலம் சான்றளிக்கிறேன்.",
    agreement_title: "ஒப்பந்த உரை",
    all: "அனைவரும்",
    allowed_file_types:
      "அனுமதிக்கப்பட்ட கோப்பு வகைகள்: pdf, doc, docx, jpg, png",
    amount_to_pay: "செலுத்த வேண்டிய தொகை",
    app_version: "ஆப் பதிப்பு",
    apps_links: "ஆப்கள் & இணைப்புகள்",
    approve_and_delete: "உறுப்பினரை அங்கீகரித்து நீக்கு",
    approve_delete_request: "நீக்கும் கோரிக்கையை அங்கீகரி",
    approve_transfer: "இடமாற்றத்தை அங்கீகரி",
    arabic_college_details: "அரபிக் கல்லூரி விவரங்கள்",
    assigned_member: "ஒதுக்கப்பட்ட உறுப்பினர்",
    associated: "நமது அமைப்புடன் அவர் எவ்வாறு தொடர்புடையவர்?",
    associated_1: "QHLS மாணவர்",
    associated_2: "CRE மாணவர்",
    associated_3: "ஜுமுஆவில் பங்கேற்பார்",
    associated_4: "ஜமாஅத்தில் பங்கேற்பார்",
    associated_5: "எங்கள் கூட்டங்களில் பங்கேற்பார்",
    associated_6: "பொது நிகழ்ச்சிகளில் பங்கேற்பார்",
    associated_7: "நிதி உதவி வழங்குவார்",
    associated_8: "ப்ரோஃபேஸ்/ஃபோகஸில் பங்கேற்றார்",
    associated_9: "ப்ரொஃப்கான்-ல் பங்கேற்றார்",
    associated_10: "மாநில மாநாட்டில் பங்கேற்பார்",
    associated_11: "குடும்ப மாநாட்டில் பங்கேற்றார்",
    associated_12: "விஞ்ஞான வேதியில் பங்கேற்பார்",
    associated_13: "சகாத் செல் மூலம்",
    associated_14: "உத்ஹியா மூலம்",
    associated_15: "பித்ர் சகாத் மூலம்",
    associated_16: "அனாதை பராமரிப்பு மூலம்",
    associated_17: "விஸ்டம் ஹெல்த் கேர் மூலம்",
    associated_18: "பிற வழிகள்",

    attendance: "வருகை",
    availability: "2. எல்லா மொபைல் போன்களிலும் ஆப் கிடைக்குமா?",
    back_to_list: "உறுப்பினர் பட்டியலுக்குத் திரும்பிச் செல்ல",
    balavedi: "பாலவேதி",
    balavedi_not_studying: "பாலவேதி - படிக்கவில்லை",
    balavedi_teams: "பாலவேதி அணிகள்",
    basic_information: "அடிப்படை தகவல்கள்",
    bio_data: "சுய விவரம்",
    become_member: "உறுப்பினராகு",
    between_100_300: "100-300",
    between_300_500: "300-500",
    between_500_1000: "500-1000",
    bio_data_sections: "பயோடேட்டா பிரிவுகள்",
    biodata_fill_edit: "பயோடேட்டா நிரப்ப/திருத்த இங்கே கிளிக் செய்யவும்",
    blood_donation_willing: "இரத்த தானம் செய்ய விருப்பமா?",
    blood_group: "இரத்த வகை",
    blood_group_required: "இரத்த வகையைத் தேர்வு செய்யவும்!",
    blood_donation_required: "இரத்த தான சிந்தையைத் தேர்வு செய்யவும்!",
    book_sales: "புத்தக விற்பனை",
    building_type: "கட்டிட வகை",
    building_type_required: "கட்டிட வகை அவசியம்",
    call: "அழைக்க",
    campus_type: "வளாக வகை",
    cancel: "ரத்து செய்",
    cancel_delete_request: "நீக்கும் கோரிக்கையை ரத்து செய்",
    cancel_keep_signature: "ரத்து செய் & தற்போதைய கையொப்பத்தை வைத்திரு",
    captain: "கேப்டன்",
    change_pin: "உங்கள் பின் மாற்ற இங்கே கிளிக் செய்யவும்.",
    change_unit: "யூனிட் மாற்று",
    change_unit_members: "யூனிட் மாற்ற வேண்டிய உறுப்பினர்கள்",
    character_issues: "குணநலன் பிரச்சினைகள்",
    child_label: "துணை இயலாமை",
    city_kasargod: "காசர்கோடு",
    city_kochi: "கொச்சி",
    city_kozhikode: "கோழிக்கோடு",
    city_thiruvananthapuram: "திருவனந்தபுரம்",
    class_format: "வகுப்பு வடிவம்",
    clear: "அழி",
    clear_cache: "கேச் அழித்து ஆப்பை மீண்டும் தொடங்கவும்",
    click_here_to_bulk_download_expatriate_prints:
      "வெளிநாட்டு உறுப்பினர் அச்சுகளை மொத்தமாக பதிவிறக்க இங்கே கிளிக் செய்யவும்",
    click_here_to_consolidated_report:
      "ஒருங்கிணைந்த அறிக்கைக்கு இங்கே கிளிக் செய்யவும்",
    click_here_to_download_membership_report:
      "உறுப்பினர் அறிக்கையை பதிவிறக்க இங்கே கிளிக் செய்யவும்",
    click_here_to_view_and_pay_fee_details:
      "கட்டண விவரங்களை பார்க்கவும் செலுத்தவும் இங்கே கிளிக் செய்யவும்",
    close: "மூடு",
    cluster: "கிளஸ்டர்",
    cluster_admin_add:
      "மண்டல நிர்வாகிகள் உங்கள் யூனிட்டில் கிளஸ்டர்களை சேர்ப்பார்கள்",
    cluster_selected: "கிளஸ்டர் தேர்ந்தெடுக்கப்பட்டது",
    clusters_list: "கிளஸ்டர் பட்டியல்",
    code: "குறியீடு",
    collected: "சேகரிக்கப்பட்டது",
    college_affiliation: "அரபிக் கல்லூரி எந்த அமைப்புடன் இணைந்துள்ளது?",
    college_affiliation_required: "கல்லூரி இணைப்பு அவசியம்",
    college_building_type: "அரபிக் கல்லூரி கட்டிட வகை",
    college_building_type_required: "கல்லூரி கட்டிட வகை அவசியம்",
    college_location: "அரபிக் கல்லூரி இடம்",
    college_name: "அரபிக் கல்லூரி பெயர்",
    college_name_required: "கல்லூரி பெயர் அவசியம்",
    college_started_year: "தொடங்கிய ஆண்டு",
    conducted: "நடத்தப்பட்டது",
    confirmed: "உறுதிப்படுத்தப்பட்டது",
    contribute_label:
      "நீங்கள் பங்களிக்கக்கூடிய பகுதிகள் (குறைந்தது மூன்று தேர்ந்தெடுக்கவும்)",
    contribute_label_balavedi:
      "நீங்கள் விரும்பும் மற்றும் திறமையான செயல்பாடுகளை தேர்ந்தெடுக்கவும்",
    convener_name: "அமைப்பாளர் பெயர்",
    convener_phone: "அமைப்பாளர் தொலைபேசி எண்",
    convener_phone_required: "அமைப்பாளர் தொலைபேசி எண் அவசியம்",
    country: "நாடு",
    country_code_required: "நாட்டின் குறியீடு அவசியம்",
    country_required: "நாட்டைத் தேர்வு செய்யவும்!",
    course_completing_year: "பாடநெறி முடியும் ஆண்டு",
    course_details: "பாடநெறி விவரங்கள்",
    completed: "முடிந்தது",
    cre: "CRE",
    cre_day: "CRE நடக்கும் நாள்",
    cre_details: "CRE விவரங்கள்",
    create_meeting: "கூட்டம் உருவாக்கு",
    create_new_account: "புதிய கணக்கு உருவாக்கு",
    current_captain: "தற்போதைய கேப்டன்",
    current_location: "தற்போதைய இடம்",
    current_location_required: "தற்போதைய இருப்பிடத்தைத் தேர்வு செய்யவும்!",
    current_status: "தற்போதைய நிலை",
    current_vice_captain: "தற்போதைய துணை கேப்டன்",
    daily: "தினசரி",
    date: "தேதி",
    date_from: "தேதி முதல்",
    date_to: "தேதி வரை",
    dawa_directory: "தவா அடைவு",
    day: "நடக்கும் நாள்",
    decided: "முடிவு செய்யப்பட்டது",
    delete: "நீக்கு",
    delete_member: "உறுப்பினரை நீக்கு",
    delete_members_list: "நீக்க வேண்டிய உறுப்பினர் பட்டியல்",
    delete_reason_1: "உறுப்பினர் தகுதி இல்லை, தவறுதலாக சேர்க்கப்பட்டது",
    delete_reason_2: "முன்பு நமது தொழிலாளி, இப்போது ஆர்வமில்லை",
    delete_reason_3: "நமது ஆதரவாளர், உறுப்பினர் தேவையில்லை என்றார்",
    delete_reason_4: "நமது தொழிலாளி, பலமுறை முயற்சித்தும் பதிலளிக்கவில்லை",
    delete_reason_5: "வளைகுடாவில் உள்ளார், பயோடேட்டா நிரப்பவில்லை",
    delete_reason_6: "ஸ்மார்ட்போன் இல்லை, பயோடேட்டா நிரப்பவில்லை",
    delete_reason_7: "பயோடேட்டா நிரப்ப தெரியாது, நிரப்பவில்லை",
    delete_reason_8: "அட்டையில் எண் தவறு, உள்நுழைய முடியவில்லை",
    delete_reason_9: "PIN கிடைக்கவில்லை, உள்நுழைய முடியவில்லை",
    delete_reason_other: "மற்ற காரணங்கள்",
    delete_request: "நீக்கும் கோரிக்கை",
    delete_selected: "தேர்ந்தெடுத்தவற்றை நீக்கு",
    designation: "பதவி",
    designation_required: "பதவி அவசியம்",
    died: "இறந்துவிட்டார்",
    disability_label: "உடல் குறைபாடு",
    disability_section_title: "F. உடல் குறைபாடுகள்",
    disability_section_title_profile: "உடல் குறைபாடுகள்",
    district: "மாவட்டம்",
    district_cluster_mapping: "மாவட்ட கிளஸ்டர் வரைபடம்",
    dob_year: "பிறந்த ஆண்டு",
    doing_job: "வேலை செய்கிறார்",
    download_biodata: "பயோடேட்டா பதிவிறக்கு",
    download_form: "படிவம் பதிவிறக்கு",
    download_receipt: "ரசீது பதிவிறக்கு",
    download_result: "முடிவு பதிவிறக்கு",
    draft_list: "வரைவு பட்டியல்",
    duplicate_entry: "நகல் உள்ளீடு",
    duplicate_number_entry:
      "வேறு எண்ணுடன் சேர்க்கப்பட்டுள்ளார், இது இரட்டை உள்ளீடு.",
    edit: "திருத்து",
    edit_election_officer: "தேர்தல் அதிகாரியை திருத்து",
    edit_executive_member: "நிர்வாக உறுப்பினரை திருத்து",
    edit_member: "உறுப்பினரை திருத்து",
    education_qualification: "கல்வித் தகுதி",
    education_required: "பள்ளி/வளாகம்/பாடநெறி தகவல் முழுமையடையவில்லை",
    election_attendance: "தேர்தல் வருகை",
    election_minutes_upload: "நிமிடங்கள் பதிவேற்று",
    election_officers: "தேர்தல் அதிகாரிகள்",
    election_officers_list: "தேர்தல் அதிகாரிகள் பட்டியல்",
    election_report:
      "{level} தேர்தல் அறிக்கையை பார்க்க இங்கே கிளிக் செய்யவும்.",
    eligible: "பங்கேற்க தகுதியானவர்",
    email: "மின்னஞ்சல்",
    enter_age: "வயது உள்ளிடவும்",
    enter_college_location: "கூகுள் மேப்ஸிலிருந்து இடத்தை உள்ளிடவும்",
    enter_college_name: "கல்லூரி பெயரை உள்ளிடவும்",
    enter_college_started_year: "தொடங்கிய ஆண்டை உள்ளிடவும்",
    enter_convener_name: "அமைப்பாளர் பெயரை உள்ளிடவும்",
    enter_convener_phone: "அமைப்பாளர் தொலைபேசி எண்ணை உள்ளிடவும்",
    enter_country_code: "நாட்டின் குறியீட்டை உள்ளிடவும்",
    enter_executive_count: "நிர்வாக உறுப்பினர்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_facebook_link: "பேஸ்புக் இணைப்பை உள்ளிடவும்",
    enter_hifdh_students_count: "மாணவர்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_imam_name: "இமாமின் பெயரை உள்ளிடவும்",
    enter_imam_phone: "இமாமின் தொலைபேசி எண்ணை உள்ளிடவும்",
    enter_imam_state: "இமாமின் மாநிலத்தை உள்ளிடவும்",
    enter_instagram_link: "இன்ஸ்டாகிராம் இணைப்பை உள்ளிடவும்",
    enter_madrasa_location: "கூகுள் மேப்ஸிலிருந்து மதரஸா இடத்தை உள்ளிடவும்",
    enter_madrasa_name: "மதரஸா பெயரை உள்ளிடவும்",
    enter_madrasa_started_year: "மதரஸா தொடங்கிய ஆண்டை உள்ளிடவும்",
    enter_main_healthcare_activities: "முக்கிய செயல்பாடுகளை உள்ளிடவும்",
    enter_masjid_location: "கூகுள் மேப் இடத்தை உள்ளிடவும்",
    enter_mobile: "மொபைல் உள்ளிடவும்",
    enter_name: "பெயர் உள்ளிடவும்",
    enter_name_required: "பெயர் உள்ளிடவும்",
    enter_office_location: "அலுவலக இடத்தை உள்ளிடவும்",
    enter_orphan_count: "குழந்தைகளின் எண்ணிக்கையை உள்ளிடவும்",
    enter_other_institution_1: "மற்ற நிறுவனம் பெயர் 1",
    enter_other_institution_2: "மற்ற நிறுவனம் பெயர் 2",
    enter_other_institution_3: "மற்ற நிறுவனம் பெயர் 3",
    enter_other_land: "மற்ற நிலத்தை சென்ட்களில் உள்ளிடவும்",
    enter_parking_capacity: "வாகனங்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_qhls_location: "கூகுள் மேப்ஸிலிருந்து QHLS இடத்தை உள்ளிடவும்",
    enter_qhls_name: "QHLS பெயரை உள்ளிடவும்",
    enter_qhls_participants_count: "பங்கேற்பாளர்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_qhls_started_year: "QHLS தொடங்கிய ஆண்டை உள்ளிடவும்",
    enter_staff_count: "ஊழியர்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_target: "இலக்கை உள்ளிடவும்",
    enter_teachers_count: "ஆசிரியர்களின் எண்ணிக்கையை உள்ளிடவும்",
    enter_trust_land_in_cent: "அறக்கட்டளை நிலத்தை சென்ட்களில் உள்ளிடவும்",
    enter_wisdom_media_link: "விஸ்டம் மீடியா இணைப்பை உள்ளிடவும்",
    enter_youtube_link: "யூடியூப் இணைப்பை உள்ளிடவும்",
    exc_count: "நிர்வாக எண்ணிக்கை",
    exc_members_count: "நிர்வாக உறுப்பினர்களின் எண்ணிக்கை: ",
    executive_count: "நிர்வாக உறுப்பினர்களின் எண்ணிக்கை",
    executive_count_selected: "தேர்ந்தெடுக்கப்பட்ட நிர்வாக உறுப்பினர்கள்",
    executive_members_list: "நிர்வாக உறுப்பினர்கள் பட்டியல்",
    executives: "நிர்வாகிகள்",
    existing_files: "தற்போதுள்ள கோப்புகள்",
    extra_activity_section_title: "E. மற்ற திறன்கள் / ஆர்வங்கள்",
    extra_activity_section_title_profile: "மற்ற திறன்கள் / ஆர்வங்கள்",
    facebook: "பேஸ்புக்",
    facilities: "மசூதியில் உள்ள வசதிகள்",
    father_name_english_only: "தந்தையின் பெயர் (ஆங்கிலத்தில் மட்டும்)",
    fee_status: "கட்டண நிலை",
    field_required: "இந்தத் துறை அவசியம்",
    fill_pending_data: "நிரப்ப வேண்டிய தரவு நிலுவையில் உள்ளது.",
    financial_issues: "நிதி பிரச்சினைகள்",
    fill_status: "உருவ விவரங்களை நிரப்ப/திருத்த கிளிக் செய்யவும்",
    forign_mobile: "வெளிநாட்டு மொபைல் எண்",
    form_collected_status: "படிவம் சேகரிக்கப்பட்ட நிலை",
    form_collection: "படிவ சேகரிப்பு",
    friday: "வெள்ளி",
    girls: "பெண்கள்",
    go_to_branch: "யூனிட் பக்கத்திற்கு செல்ல இங்கே கிளிக் செய்யவும்",
    go_to_lajna: "லஜ்னா பக்கத்திற்கு செல்ல இங்கே கிளிக் செய்யவும்",
    happened: "நடந்தது",
    has_arabic_college_mujahid: "யூனிட்டில் முஜாஹித் அரபிக் கல்லூரி உள்ளதா?",
    has_centre: "யூனிட் செயல்பாடுகளுக்கு மையம் உள்ளதா?",
    has_jumua: "ஜும்ஆ நடக்கும் மசூதியா?",
    has_madrasa_mujahid: "முஜாஹித் மதரஸா உள்ளதா?",
    has_masjid_mujahid: "யூனிட்டில் முஜாஹித் மசூதி உள்ளதா?",
    help_desk: "உதவி மையம்",
    hifdh_college: "குர்ஆன் ஹிஃப்த் கல்லூரி",
    hifdh_students_count: "மாணவர்களின் எண்ணிக்கை",
    home: "முகப்பு",
    home_name_required: "வீட்டுப் பெயரை எழுதவும்!",
    hour: "மணி",
    hour_required: "மணி அவசியம்",
    house_status: "வீட்டின் வகை",
    house_status_required: "வீட்டு நிலையைத் தேர்வு செய்யவும்!",
    house_wife: "இல்லத்தரசி",
    how_to_change_pin: "5. இந்த PIN எண்ணை மாற்ற முடியுமா?",
    how_to_change_pin_1:
      "தற்போது 'Profile' பகுதியில் PIN எண்ணை உங்கள் விருப்பப்படி அமைக்க விருப்பம் உள்ளது. அதைப் பயன்படுத்தி PIN மாற்றலாம்.",
    how_to_get_pin_again:
      "6. PIN எண்ணை மறந்துவிட்டால் பயனர்கள் என்ன செய்ய வேண்டும்?",
    how_to_get_pin_again_1:
      "முதல் முறை செய்தது போல், உங்கள் மொபைல் எண்ணை மீண்டும் உள்ளிட்டு, SMS மூலம் PIN எண்ணைப் பெறலாம். ஆப்பில் இந்த அம்சத்தைப் பயன்படுத்தவும்.",
    how_to_install: "3. இணைப்பிலிருந்து ஆப்பை எவ்வாறு பயன்படுத்துவது",
    how_to_install_link:
      "இணைப்பை கிளிக் செய்யும்போது, அது உங்கள் சாதன உலாவியில் திறக்கும் (எ.கா., Google Chrome, போன்றவை). அங்கிருந்து, மொபைல் ஆப் போல உங்கள் போனில் நிறுவலாம். இதற்கு, உலாவியில் 'Add to Home' விருப்பத்தைப் பயன்படுத்தவும். சிறந்த புரிதலுக்கு இந்த வீடியோவைப் பார்க்கவும்.",
    how_to_login: "4. உள்நுழையும்போது பயனர்கள் என்ன கவனத்தில் கொள்ள வேண்டும்?",
    how_to_login_1:
      "உங்கள் மொபைல் எண்ணைப் பயன்படுத்தி உள்நுழைய வேண்டும். முதல் முறை பயனர்கள் SMS மூலம் PIN எண்ணைப் பெறுவார்கள். இந்த PIN எண்ணை கவனமாக நினைவில் வைத்துக்கொள்ளுங்கள். வேறு சாதனத்தில் உள்நுழையும்போது அல்லது தற்போதைய சாதனத்திலிருந்து வெளியேறிய பின் மீண்டும் உள்நுழையும்போது இதே PIN தேவை.",
    how_to_use_app: "1. விஸ்டம் கைட் மொபைல் ஆப்பை எங்கே பெறுவது",
    how_to_use_app_link:
      "http://guide.wisdomislam.org/ இணைப்பைப் பார்வையிட்டு யாரும் ஆப்பை அணுகலாம்.",
    i_will_attend: "நான் கலந்துகொள்வேன்",
    imam_name: "இமாமின் பெயர்",
    imam_phone: "இமாமின் தொலைபேசி எண்",
    imam_state: "இமாமின் மாநிலம்",
    in_state: "மாநிலத்தில்",
    incorrectly_added: "தவறாக சேர்க்கப்பட்டது",
    increase: "அதிகரிப்பு",
    instagram: "இன்ஸ்டாகிராம்",
    institution_name: "நிறுவனம்/கல்லூரி பெயர்",
    is_member: "உறுப்பினர்",
    is_subscriber: "தற்போது சந்தாதாரரா?",
    islamic_education_qualification:
      "இஸ்லாமிய கல்வித் தகுதி (கடைசியாக முடித்த பாடநெறி)",
    islamic_special_degree: "சிறப்பு இஸ்லாமிய பட்டம்",
    islahi_year_label:
      "சலஃபி/இஸ்லாஹி அமைப்புகளில் எத்தனை ஆண்டுகள் செயல்பட்டுள்ளீர்கள்?",
    job: "வேலை",
    job_category: "வேலை வகை",
    job_divisions: "வேலை பிரிவுகள்",
    job_required: "வேலை அவசியம்!",
    job_section_title: "வேலை தகவல்",
    job_sub_category: "வேலை துணை வகை",
    job_sub_divisions: "வேலை துணை பிரிவுகள்",
    jumua_attendance:
      "ஜும்ஆ நடத்தப்பட்டால், சுமார் எத்தனை பேர் கலந்துகொள்கிறார்கள்?",
    knm: "கே.என்.எம்",
    known_languages: "உங்களுக்குத் தெரிந்த மொழிகள்",
    lajna_member_status: "லஜ்னா உறுப்பினர் நிலை",
    lajna_membership: "லஜ்னா உறுப்பினர்",
    land_and_building: "நிலம் & கட்டிடம்",
    land_in_cent: "நிலம் சென்ட்களில்",
    language: "மொழிகள்",
    language_info_title: "தெரிந்த மொழிகள்",
    last_time_added_by_mistake: "கடைசி முறை தவறுதலாக சேர்க்கப்பட்டது.",
    latest_news: "சமீபத்திய செய்திகள்",
    leave: "விடுப்பு",
    library: "நூலகம்",
    list: "பட்டியல்",
    loading: "ஏற்றுகிறது...",
    location: "இடம்",
    login: "உள்நுழை",
    logout: "வெளியேறு",
    madrasa: "மதரஸா",
    madrasa_affiliation: "மதரஸா எந்த அமைப்புடன் இணைந்துள்ளது?",
    madrasa_details: "மதரஸா விவரங்கள்",
    madrasa_location: "மதரஸா இடம்",
    madrasa_name: "மதரஸா பெயர்",
    madrasa_started_year: "மதரஸா தொடங்கிய ஆண்டு",
    main_healthcare_activities: "முக்கிய செயல்பாடுகள்",
    make_payment: "பணம் செலுத்து",
    markaz: "மர்கஸ் தவா",
    masjid: "மசூதி",
    masjid_affiliation: "மசூதி எந்த அமைப்புடன் இணைந்துள்ளது?",
    masjid_details: "மசூதி விவரங்கள்",
    masjid_location: "மசூதி இடம்",
    masjid_required: "மசூதி விவரங்கள் அவசியம்",
    max_allowed: "அதிகபட்சம் 7 உறுப்பினர்கள் அனுமதி",
    maximum_7_allowed: "அதிகபட்சம் 7 உறுப்பினர்கள் அனுமதி",
    maximum_7_team_members: "அதிகபட்சம் 7 அணி உறுப்பினர்கள் அனுமதி",
    meeting_date: "கூட்ட தேதி",
    meeting_hall: "கூட்ட அரங்கு",
    meeting_level: "கூட்ட நிலை",
    meeting_link: "கூட்ட இணைப்பு",
    meeting_minutes: "கூட்ட நிமிடங்கள்",
    meeting_mode: "கூட்ட முறை",
    meeting_name: "கூட்டப் பெயர்",
    meeting_period: "கூட்ட காலம்",
    meeting_report: "கூட்ட அறிக்கைகளைப் பார்க்க இங்கே கிளிக் செய்யவும்.",
    meeting_time: "கூட்ட நேரம்",
    meeting_type: "கூட்ட வகை",
    member_current_status: "உறுப்பினர் தற்போதைய நிலை",
    member_details: "உறுப்பினர் விவரங்கள்",
    member_signature: "உறுப்பினர் கையொப்பம் (மலையாளம்: അംഗത്തിന്റെ ഒപ്പ്)",
    member_signature_mal: "അംഗത്തിന്റെ ഒപ്പ്",
    member_status: "உறுப்பினர் நிலை",
    members: "உறுப்பினர்கள்",
    members_7: "7 உறுப்பினர்கள்",
    members_list: "உறுப்பினர் பட்டியல்",
    members_payments_btn:
      "உறுப்பினர் கட்டணங்களைப் பார்க்கவும் செலுத்தவும் இங்கே கிளிக் செய்யவும்.",
    members_under_mobile: "உங்கள் மொபைல் எண்ணின் கீழ் உள்ள உறுப்பினர்கள்.",
    members_under_mobile_of:
      "{{name}} இன் மொபைல் எண்ணின் கீழ் உள்ள உறுப்பினர்கள்.",
    membership_biodata: "உறுப்பினர் & பயோடேட்டா",
    membership_consolidated_report_btn:
      "ஒருங்கிணைந்த உறுப்பினர் அறிக்கையை பார்க்கவும் மண்டலத்திற்கு அனுப்பவும் இங்கே கிளிக் செய்யவும்.",
    membership_details: "உறுப்பினர் விவரங்கள்",
    membership_details_update:
      "உறுப்பினர் விவரங்கள் & பயோடேட்டா புதுப்பிப்புகள்",
    membership_form_bulk_download_btn:
      "அனைத்து வெளிநாட்டு உறுப்பினர் அச்சுகளையும் மொத்தமாக பதிவிறக்க இங்கே கிளிக் செய்யவும்.",
    membership_report: "உறுப்பினர் அறிக்கை",
    membership_report_download_btn:
      "உறுப்பினர் அறிக்கையை பதிவிறக்க இங்கே கிளிக் செய்யவும்.",
    membership_status: "உறுப்பினர் நிலை",
    membership_verification: "உறுப்பினர் சரிபார்ப்பு",
    menu: "மெனு",
    minutes: "நிமிடங்கள்",
    mobile: "மொபைல்",
    mobile_number: "மொபைல் எண்",
    mobile_number_length: "மொபைல் எண் 10 இலக்கங்கள் இருக்க வேண்டும்",
    mobile_number_required: "மொபைல் எண் அவசியம்",
    mobile_required: "மொபைல் எண் அவசியம்!",
    mobile_update_warning:
      "உங்கள் மொபைல் எண்ணை மாற்றினால், உங்கள் அனைத்து உறுப்பினர்களின் மொபைல் எண்களும் புதுப்பிக்கப்படும்.",
    monday: "திங்கள்",
    monthly: "மாதத்திற்கு ஒருமுறை",
    move_to_karad_list: "கரட் பட்டியலுக்கு நகர்த்து",
    move_to_members_list: "உறுப்பினர் பட்டியலுக்கு நகர்த்து",
    my_attendance: "என் வருகை",
    my_biodata_form: "என் பயோடேட்டா படிவம்",
    my_campus: "என் வளாகம்",
    my_district: "என் மாவட்டம்",
    my_duties: "என் கடமைகள்",
    my_meetings: "என் கூட்டங்கள்",
    my_profile: "என் சுயவிவரம்",
    my_unit: "என் யூனிட்",
    my_zone: "என் மண்டலம்",
    name: "பெயர்",
    name_address: "பெயர் மற்றும் முகவரி",
    name_english_only: "பெயர் (ஆங்கிலத்தில் மட்டும்)",
    name_regex: "பெயரை ஆங்கிலத்தில் டைப் செய்யவும்",
    name_required: "பெயர் அவசியம்!",
    nerpatham: "நேர்பதம்",
    nerpatham_desc:
      "நேர்பதம் சேர்க்க அல்லது புதுப்பிக்க இங்கே கிளிக் செய்யவும்",
    nerpatham_target: "நேர்பதம் இலக்கு",
    new: "புதிய",
    next: "அடுத்து",
    no: "இல்லை",
    no_2: "இல்லை",
    no_clusters: "கிளஸ்டர்கள் இல்லை",
    no_clusters_available:
      "தேர்ந்தெடுக்கப்பட்ட பஞ்சாயத்துக்கு கிளஸ்டர்கள் இல்லை",
    no_data: "தரவு இல்லை...",
    no_election_officers_found: "இந்தப் பிரிவுக்கு தேர்தல் அதிகாரிகள் இல்லை.",
    no_information: "தகவல் இல்லை",
    no_job: "வேலை இல்லை",
    no_longer_needed: "அவர்/அவள் இனி உறுப்பினர் தேவையில்லை என்றார்.",
    no_longer_needed_2: "யூனிட் குழு உறுப்பினரை நீக்க முடிவு செய்தது.",
    no_longer_needed_3: "தற்போது எங்களுக்கு இலட்சியங்களில் ஆர்வமில்லை.",
    no_members_added: "இதுவரை உறுப்பினர்கள் சேர்க்கப்படவில்லை",
    not_active_in_native: "சொந்த ஊரில் செயலில் இல்லை",
    not_collected: "சேகரிக்கப்படவில்லை",
    not_editable: "உங்கள் சொந்த யூனிட்டில் மட்டுமே தரவை நிரப்ப முடியும்",
    not_in_draft: "உங்கள் எண் வரைவு பட்டியலில் சேர்க்கப்படவில்லை.",
    not_member: "உறுப்பினர் அல்ல",
    not_registered: "பதிவு செய்யப்படவில்லை",
    not_verified: "சரிபார்க்கப்படவில்லை",
    not_verified_reason: "சரிபார்க்கப்படாத காரணம்",
    note: "குறிப்பு",
    nri_notnow: "முன்பு என்ஆர்ஐ, இப்போது சொந்த நாட்டில் குடியேறியுள்ளார்.",
    nri_status: "நீங்கள் என்ஆர்ஐயா?",
    nri_yes: "என்ஆர்ஐ",
    number_of_teachers: "எத்தனை ஆசிரியர்கள் உள்ளனர்?",
    of: "இல்",
    office_location: "அலுவலக இடம்",
    office_location_required: "அலுவலக இடம் அவசியம்",
    old: "பழைய",
    online: "ஆன்லைன்",
    optional: "விருப்பம்",
    options_selected: "விருப்பங்கள் தேர்ந்தெடுக்கப்பட்டன",
    orphan_care: "அனாதை பராமரிப்பு",
    orphan_count: "ஆதரவு பெறும் குழந்தைகளின் எண்ணிக்கை",
    other: "மற்றவை",
    other_course_details:
      "உங்கள் பாடநெறி மேலே பட்டியலிடப்படவில்லை அல்லது மற்ற விவரங்கள் இருந்தால், குறிப்பிடவும்",
    other_institutions: "மற்ற நிறுவனங்கள்",
    other_job_details:
      "உங்கள் வேலை மேலே பட்டியலிடப்படவில்லை அல்லது மற்ற விவரங்கள் இருந்தால், குறிப்பிடவும்",
    other_land: "யூனிட் கட்டுப்பாட்டில் உள்ள மற்ற நிலம்",
    other_org_label:
      "மற்ற சமூக/அரசியல் அமைப்புகளில் செயல்படுகிறீர்களா? ஆம் எனில், விவரங்கள்?",
    other_reason: "மற்ற காரணம்",
    other_services: "மற்ற சேவைகள்",
    outside_state_india: "மாநிலத்திற்கு வெளியே (இந்தியாவில்)",
    own: "சொந்த கட்டிடம்",
    paid: "செலுத்தப்பட்டது",
    panchayath: "பஞ்சாயத்து",
    parking_capacity: "எத்தனை வாகனங்கள் நிறுத்த முடியும்?",
    participant_id: "பங்கேற்பாளர் அடையாளம்",
    participants: "பங்கேற்பாளர்கள்",
    payment_information: "பணம் செலுத்தும் தகவல்",
    peace_radio: "பீஸ் ரேடியோ கியோஸ்க்",
    pending: "நிலுவையில்",
    pending_members_list: "நிலுவையில் உள்ள உறுப்பினர் பட்டியல்",
    permanent_address_india: "நிரந்தர முகவரி (இந்தியாவில்)",
    physical: "நேரடி",
    physical_education_qualification:
      "உடற்கல்வி தகுதி (கடைசியாக முடித்த பாடநெறி)",
    pin_code: "பின் குறியீடு",
    place: "இடம்",
    plus2: "பிளஸ் 2",
    plustwo: "பிளஸ் டூ",
    plustwo_subject: "பிளஸ் டூ பாடம்",
    post_office: "தபால் அலுவலகம்",
    present: "வந்தார்",
    presiding_units_btn:
      "நீங்கள் தலைமை அதிகாரியாக உள்ள யூனிட்டைப் பார்க்க இங்கே கிளிக் செய்யவும்",
    presiding_zones_btn:
      "Click here to view zones where you are the presiding officer",
    presiding_districts_btn: "Click here to view districts where you are the presiding officer",
    print_biodata: "பயோடேட்டா அச்சிடு",
    public: "பொது",
    qhls: "QHLS",
    qhls_details: "QHLS விவரங்கள்",
    qhls_frequency: "அதிர்வெண்",
    qhls_location: "QHLS இடம்",
    qhls_name: "QHLS பெயர்",
    qhls_participants_count: "பங்கேற்பாளர்களின் எண்ணிக்கை",
    qhls_register: "QHLS பதிவு செய்",
    qhls_started_year: "QHLS தொடங்கிய ஆண்டு",
    qr_code: "QR குறியீடு",
    qr_code_attendance_desc:
      "QR குறியீட்டைப் பயன்படுத்தி வருகையைக் குறிக்க இங்கே கிளிக் செய்யவும்",
    qr_code_scanner: "QR குறியீடு ஸ்கேனர்.",
    questionnaire: "கேள்வித்தாள்",
    quick_actions: "விரைவு செயல்கள்",
    read_more: "மேலும் படிக்க",
    reason: "காரணம்",
    reason_to_delete: "நீக்குவதற்கான காரணம்",
    reason_to_delete_explain: "நீக்குவதற்கான காரணத்தை விளக்கவும்",
    receipt_number: "ரசீது எண்",
    registered: "பதிவு செய்யப்பட்டது",
    registration_links: "பதிவு இணைப்புகள்",
    reject_and_delete: "நீக்கும் கோரிக்கையை நிராகரி",
    reject_delete_request: "நீக்கும் கோரிக்கையை நிராகரி",
    reject_transfer: "இடமாற்றத்தை நிராகரி",
    remark: "குறிப்பு",
    remove: "நீக்கு",
    remove_from_team: "அணியிலிருந்து நீக்கு",
    renew_member: "உறுப்பினரை புதுப்பி",
    renew_membership: "உறுப்பினரை புதுப்பி",
    rent: "வாடகை",
    replace_files: "கோப்புகளை மாற்று",
    replaced_files: "கோப்புகளை மீண்டும் பதிவேற்று",
    report: "அறிக்கை",
    reports: "அறிக்கைகள்",
    restore_member: "உறுப்பினரை மீட்டமை",
    restore_to_members_list: "உறுப்பினர் பட்டியலுக்கு மீட்டமை",
    retired: "ஓய்வு பெற்றவர்",
    reupload_signature: "கையொப்பத்தை மீண்டும் பதிவேற்று",
    salah_asr: "அஸர்",
    salah_dhuhr: "ளுஹர்",
    salah_fajr: "ஃபஜ்ர்",
    salah_isha: "இஷா",
    salah_maghrib: "மஃரிப்",
    same_address: "தற்போதைய முகவரியும் நிரந்தர முகவரியும் ஒன்றே",
    saturday: "சனி",
    save: "சேமி",
    save_member_list: "சேமித்து உறுப்பினர் பட்டியலுக்கு நகர்த்து",
    save_move_to_karad: "சேமித்து கரட் பட்டியலுக்கு நகர்த்து",
    save_next: "சேமி & அடுத்து",
    scanner: "ஸ்கேனர்",
    search: "இங்கே தேடுக...",
    search_clusters: "கிளஸ்டர்களை தேடுக...",
    select: "---தேர்ந்தெடுக்க---",
    select_all: "அனைத்து கிளஸ்டர்களையும் தேர்ந்தெடு",
    select_captain: "கேப்டனை தேர்ந்தெடு",
    select_cluster: "கிளஸ்டரை தேர்ந்தெடு",
    select_day: "நாளை தேர்ந்தெடு",
    select_disability: "உடல் குறைபாட்டை தேர்ந்தெடு!",
    select_district: "மாவட்டத்தை தேர்ந்தெடு",
    select_local_body: "உள்ளாட்சி அமைப்பை தேர்ந்தெடு",
    select_meeting_mode: "கூட்ட முறையை தேர்ந்தெடு",
    select_member: "உறுப்பினரை தேர்ந்தெடு",
    select_minutes_files: "நிமிட கோப்புகளை தேர்ந்தெடு",
    select_nearest_place: "அருகிலுள்ள இடத்தை தேர்ந்தெடு",
    select_new_files_replace_old:
      "பழைய கோப்புகளை மாற்ற புதிய கோப்புகளை தேர்ந்தெடு (ஏதேனும் இருந்தால்)",
    select_option: "விருப்பத்தை தேர்ந்தெடு",
    select_panchayath_type: "பஞ்சாயத்தை தேர்ந்தெடு",
    select_profession: "தொழிலை தேர்ந்தெடு",
    select_range: "வரம்பை தேர்ந்தெடு",
    select_reason: "காரணத்தை தேர்ந்தெடு",
    select_unit: "யூனிட்டை தேர்ந்தெடு",
    select_vice_captain: "துணை கேப்டனை தேர்ந்தெடு",
    select_ward: "கிளஸ்டர் / வார்டை தேர்ந்தெடு",
    select_wing: "பிரிவை தேர்ந்தெடு",
    select_zone: "மண்டலத்தை தேர்ந்தெடு",
    selected: "தேர்ந்தெடுக்கப்பட்டது",
    selected_files: "தேர்ந்தெடுக்கப்பட்ட கோப்புகள்",
    select_country_required: "நாட்டைத் தேர்வு செய்யவும்!",
    select_abroad_city_required: "நகரத்தின் பெயரை எழுதவும்!",
    select_state_required: "மாநிலத்தைத் தேர்வு செய்யவும்!",
    send_guide_link: "வழிகாட்டி இணைப்பை அனுப்பு",
    send_to_pending_members_list: "நிலுவை பட்டியலுக்கு அனுப்பு",
    signature_save_error:
      "கையொப்பத்தை சேமிப்பதில் தோல்வி. மீண்டும் முயற்சிக்கவும்.",
    signature_saved_text: "உங்கள் கையொப்பம் வெற்றிகரமாக சேமிக்கப்பட்டது.",
    signature_saved_title: "கையொப்பம் சேமிக்கப்பட்டது!",
    social_media_details: "சமூக ஊடக விவரங்கள்",
    social_media_details_unit:
      "யூனிட்டில் கிடைக்கும் சமூக ஊடக இணைப்புகளை கீழே உள்ளிடவும்",
    social_media_label: "சமூக ஊடகம்",
    social_profiles: "சமூக சுயவிவரங்கள்",
    speaking_languages: "நீங்கள் பேசக்கூடிய மொழிகள்",
    speech_languages: "நீங்கள் கற்பிக்க/பேசக்கூடிய மொழிகள்",
    staff_count: "மசூதியின் கீழ் எத்தனை ஊழியர்கள் உள்ளனர்?",
    state: "மாநிலம்",
    status: "நிலை",
    stream: "ஸ்ட்ரீம்",
    students: "மாணவர்கள்",
    study_course: "படிப்பு பாடநெறி",
    study_year: "படிப்பு ஆண்டு",
    studying: "படிக்கிறார்",
    submit: "சமர்ப்பி",
    subscription: "சந்தா",
    subscription_number: "சந்தா எண்",
    summary_title: "g. சுருக்கம் & கையொப்பம்",
    summary_title_profile: "சுருக்கம் & கையொப்பம்",
    sunday: "ஞாயிறு",
    target: "இலக்கு",
    team_members: "அணி உறுப்பினர்கள்",
    text: "உரை",
    thursday: "வியாழன்",
    time: "நேரம்",
    total: "மொத்தம்",
    transfer_to_unit: "யூனிட்டுக்கு இடமாற்றம்",
    transfer_unit_actions: "யூனிட் இடமாற்ற நடவடிக்கைகள்",
    trust_land: "அறக்கட்டளை கட்டுப்பாட்டில் உள்ள நிலம் (சென்ட்களில்)",
    tuesday: "செவ்வாய்",
    under_100: "100-க்கு கீழ்",
    unit: "யூனிட்",
    unit_clusters: "யூனிட் கிளஸ்டர்கள்",
    unit_data_collection: "யூனிட் தரவு சேகரிப்பு",
    unit_membership_report_election:
      "யூனிட் உறுப்பினர் அறிக்கை & யூனிட் தேர்தல்",
    zone_membership_report_election:
      "Unit Membership, Election Report & Zonal Election",
    district_membership_report_election:
      "மாவட்ட உறுப்பினர் அறிக்கை & மாவட்ட தேர்தல்",
    update: "புதுப்பி",
    upload: "பதிவேற்று",
    upload_files: "கோப்புகளை பதிவேற்று",
    upload_profile_photo: "சுயவிவர புகைப்படம்",
    uploaded: "பதிவேற்றப்பட்டது",
    uploading_files: "கோப்புகளை பதிவேற்றுகிறது...",
    vehicle_status: "வாகன விவரங்கள்",
    verification_not_completed: "சரிபார்ப்பு முடிக்கப்படவில்லை",
    verification_report: "சரிபார்ப்பு அறிக்கை",
    verification_status: "சரிபார்ப்பு நிலை",
    verified: "சரிபார்க்கப்பட்டது",
    verified_completed: "சரிபார்ப்பு முடிந்தது",
    vice_captain: "துணை கேப்டன்",
    view_biodata: "பயோடேட்டா பார்",
    viewing_other_notice:
      "இது மற்றொரு உறுப்பினரின் பயோடேட்டா, எனவே நீங்கள் அதை திருத்த முடியாது",
    wednesday: "புதன்",
    weekly: "வாராந்திர",
    what_study: "என்ன படிக்கிறீர்கள்?",
    where_study: "எங்கே படிக்கிறீர்கள்?",
    whatsapp: "வாட்ஸ்ஆப்",
    whatsapp_number: "வாட்ஸ்ஆப் எண்",
    wing: "பிரிவு",
    wing_meeting: "பிரிவு கூட்டம்",
    wing_required: "பிரிவு அவசியம்!",
    wing_required_field: "பிரிவு அவசியம்",
    wings: "பிரிவுகள்",
    wisdom: "விஸ்டம்",
    wisdom_healthcare: "விஸ்டம் சுகாதாரம்",
    wisdom_land: "யூனிட் கட்டுப்பாட்டில் உள்ள விஸ்டம் நிலம் (சென்ட்களில்)",
    wisdom_media: "விஸ்டம் மீடியா",
    women: "பெண்கள்",
    women_facility: "பெண்களுக்கான வசதி",
    worker_home: "உறவினர் வீடு",
    writing_languages: "நீங்கள் எழுதக்கூடிய மொழிகள்",
    yes: "ஆம்",
    yes_2: "ஆம்",
    yes_availability:
      "ஆம், விஸ்டம் கைட் ஆண்ட்ராய்டு, iOS, விண்டோஸ் மற்றும் அனைத்து மொபைல் போன்கள், கணினிகள், மடிக்கணினிகளில் பயன்படுத்தலாம்.",
    youth: "இளைஞர்",
    youtube: "யூடியூப்",
    zakath_cell: "ஸகாத் பிரிவு",
    register_now: "இப்போது பதிவு செய்",
    attended: "கலந்துகொண்டார்",
    admin_controls: "நிர்வாக கட்டுப்பாடுகள்",
    switch_admin_level: "நிர்வாக நிலையை மாற்று",
    switch_to: "க்கு மாற்று {level}",
    level: "நிலை",
    self_registration: "சுய பதிவு",
    registration_notice: "உங்கள் எண்ணின் கீழ் உள்ள உறுப்பினர்களின் பெயரை டிக் செய்து பதிவு செய்யவும்",
    already_registered: "ஏற்கனவே பதிவு செய்யப்பட்டவர்",
    event_dashboard: "நிகழ்வு டாஷ்போர்டு",
    registration_report: "பதிவு அறிக்கை",
    registration_summary: "பதிவு சுருக்கம்",
    male: "ஆண்",
    female: "ஸ்திரி",
    male_members: "ஆண் உறுப்பினர்கள்",
    female_members: "பெண் உறுப்பினர்கள்",
    participants_summary_with_family: "குடும்பத்துடன் பங்கேற்பாளர்கள் சுருக்கம்",
    sweet_buds: "இனிமையான பூக்கள்",
    butterflies: "பட்டாம்பூச்சிகள்",
    little_wings: "லிட்டில் விங்ஸ்",
    teenspace: "டீன்ஸ்பேஸ்",
    event_registration_report: "நிகழ்வு பதிவு அறிக்கை",
    total_unit_election_report: "மொத்த யூனிட் தேர்தல் அறிக்கை",
    unit_election_report: "யூனிட் தேர்தல் அறிக்கை",

    general_body_council: "பொது மன்றம் & கவுன்சில்",
    district_general_body_council: "மாவட்ட பொது மன்றம் & கவுன்சில்",
    district_womens_council: "மாவட்ட பெண்கள் கவுன்சில்",
    district_girls_council: "மாவட்ட பெண்கள் கவுன்சில்",
    womens_council: "பெண்கள் கவுன்சில்",
    girls_council: "பெண்கள் கவுன்சில்",
    org_councilers_list: "மாவட்ட / மாநில கவுன்சிலர்கள்",
    unit_level_executives: "யூனிட் நிலை நிர்வாகிகள்",
    zone_level_executives: "மண்டலம் நிலை நிர்வாகிகள்",
    zone: "மண்டலம்",
    department: "துறை",
    zone_election_report: "மண்டல தேர்தல் அறிக்கை",
    circulars: "சுற்றறிக்கை",

  },

  // Kannada
  kn: {
    abandoned: "ಕರಡು ಪಟ್ಟಿಯಲ್ಲಿ ತಪ್ಪಾಗಿ ಸೇರಿಸಲಾಗಿದೆ. ನಮ್ಮ ಆದರ್ಶವಲ್ಲ.",
    above_1000: "1000ಕ್ಕಿಂತ ಮೇಲೆ",
    abroad: "ವಿದೇಶ",
    abroad_mobile: "ವಿದೇಶ ಮೊಬೈಲ್",
    absent: "ಗೈರುಹಾಜರು",
    ac_facility: "ಹವಾನಿಯಂತ್ರಣ ಸೌಲಭ್ಯ",
    action: "ಕ್ರಮ",
    active_in_native: "ಸ್ವದೇಶದಲ್ಲಿ ಸಕ್ರಿಯ",
    add: "ಸೇರಿಸು",
    add_cluster: "ಕ್ಲಸ್ಟರ್ ಸೇರಿಸು",
    add_election_officer: "ಚುನಾವಣಾ ಅಧಿಕಾರಿ ಸೇರಿಸು",
    add_executive_member: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯ ಸೇರಿಸು",
    add_madrasa: "ಮದರಸಾ ಸೇರಿಸು",
    add_masjid: "ಮಸೀದಿ ಸೇರಿಸು",
    add_member: "ಸದಸ್ಯ ಸೇರಿಸು",
    add_qhls: "QHLS ಸೇರಿಸು",
    added_by_member: "ಸದಸ್ಯರಿಂದ ಸೇರಿಸಲಾಗಿದೆ",
    address: "ವಿಳಾಸ",
    afsalul_ulama_final: "ಅಫ್ಝಲುಲ್ ಉಲಮಾ ಅಂತಿಮ",
    afsalul_ulama_prelim: "ಅಫ್ಝಲುಲ್ ಉಲಮಾ ಪ್ರಾಥಮಿಕ",
    age: "ವಯಸ್ಸು",
    age_minimum: "ವಯಸ್ಸು ಕನಿಷ್ಠ 1 ಆಗಿರಬೇಕು",
    age_required: "ವಯಸ್ಸು ಅಗತ್ಯ!",
    agree_label: "ನಾನು ಮೇಲಿನ ಎಲ್ಲಾ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪುತ್ತೇನೆ",
    agreement_paragraph:
      "ಉಲ್ಲೇಖಿಸಲಾದ ಬೋಧನೆಗಳ ಪ್ರಕಾರ ಸಂಸ್ಥೆಯ ನಿಯಮಗಳು ಮತ್ತು ನಿಬಂಧನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತೇನೆ ಎಂದು ಇದರ ಮೂಲಕ ಪ್ರಮಾಣೀಕರಿಸುತ್ತೇನೆ.",
    agreement_title: "ಒಪ್ಪಂದ ಪಠ್ಯ",
    all: "ಎಲ್ಲರೂ",
    allowed_file_types: "ಅನುಮತಿಸಿದ ಕಡತ ಪ್ರಕಾರಗಳು: pdf, doc, docx, jpg, png",
    amount_to_pay: "ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ",
    app_version: "ಆಪ್ ಆವೃತ್ತಿ",
    apps_links: "ಆಪ್‌ಗಳು & ಲಿಂಕ್‌ಗಳು",
    approve_and_delete: "ಸದಸ್ಯರನ್ನು ಅನುಮೋದಿಸಿ ಮತ್ತು ಅಳಿಸಿ",
    approve_delete_request: "ಅಳಿಸುವ ವಿನಂತಿಯನ್ನು ಅನುಮೋದಿಸಿ",
    approve_transfer: "ವರ್ಗಾವಣೆ ಅನುಮೋದಿಸಿ",
    arabic_college_details: "ಅರೇಬಿಕ್ ಕಾಲೇಜು ವಿವರಗಳು",
    assigned_member: "ನಿಯೋಜಿತ ಸದಸ್ಯ",
    associated: "ನಮ್ಮ ಸಂಸ್ಥೆಯೊಂದಿಗೆ ಅವರು ಹೇಗೆ ಸಂಬಂಧ ಹೊಂದಿದ್ದಾರೆ?",
    associated_1: "QHLS ವಿದ್ಯಾರ್ಥಿ",
    associated_2: "CRE ವಿದ್ಯಾರ್ಥಿ",
    associated_3: "ಜುಮುಅದಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_4: "ಜಮಾಅದಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_5: "ನಮ್ಮ ಸಭೆಗಳಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_6: "ಸಾರ್ವಜನಿಕ ಕಾರ್ಯಕ್ರಮಗಳಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_7: "ಹಣಕಾಸು ಸಹಾಯ ನೀಡುವರು",
    associated_8: "ಪ್ರೊಫೇಸ್/ಫೋಕಸ್‌ನಲ್ಲಿ ಭಾಗವಹಿಸಿದ್ದಾರೆ",
    associated_9: "ಪ್ರೊಫ್‌ಕಾನ್‌ನಲ್ಲಿ ಭಾಗವಹಿಸಿದ್ದಾರೆ",
    associated_10: "ರಾಜ್ಯ ಸಮ್ಮೇಳನದಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_11: "ಕುಟುಂಬ ಸಮ್ಮೇಳನದಲ್ಲಿ ಭಾಗವಹಿಸಿದ್ದಾರೆ",
    associated_12: "ವಿಜ್ಞಾನ ವೇದಿಯಲ್ಲಿ ಭಾಗವಹಿಸುವರು",
    associated_13: "ಜಕಾತ್ ಸೆಲ್ ಮೂಲಕ",
    associated_14: "ಉಧಿಯಾ ಮೂಲಕ",
    associated_15: "ಫಿತ್ರ್ ಜಕಾತ್ ಮೂಲಕ",
    associated_16: "ಅನಾಥರ ಆರೈಕೆ ಮೂಲಕ",
    associated_17: "ವಿಸ್ಡಮ್ ಹೆಲ್ತ್ ಕೇರ್ ಮೂಲಕ",
    associated_18: "ಇತರ ಮಾರ್ಗಗಳು",

    attendance: "ಹಾಜರಾತಿ",
    availability: "2. ಎಲ್ಲಾ ಮೊಬೈಲ್ ಫೋನ್‌ಗಳಲ್ಲಿ ಆಪ್ ಲಭ್ಯವಿದೆಯೇ?",
    back_to_list: "ಸದಸ್ಯರ ಪಟ್ಟಿಗೆ ಹಿಂತಿರುಗಿ",
    balavedi: "ಬಾಲವೇದಿ",
    balavedi_not_studying: "ಬಾಲವೇದಿ - ಅಧ್ಯಯನ ಮಾಡುತ್ತಿಲ್ಲ",
    balavedi_teams: "ಬಾಲವೇದಿ ತಂಡಗಳು",
    basic_information: "ಮೂಲ ಮಾಹಿತಿ",
    bio_data: "ಜೀವನಚರಿತ್ರೆ",
    become_member: "ಸದಸ್ಯರಾಗಿ",
    between_100_300: "100-300",
    between_300_500: "300-500",
    between_500_1000: "500-1000",
    bio_data_sections: "ಬಯೋಡೇಟಾ ವಿಭಾಗಗಳು",
    biodata_fill_edit: "ಬಯೋಡೇಟಾ ತುಂಬಲು/ಸಂಪಾದಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    blood_donation_willing: "ರಕ್ತದಾನ ಮಾಡಲು ಸಿದ್ಧರಿದ್ದೀರಾ?",
    blood_group: "ರಕ್ತ ಗುಂಪು",
    blood_group_required: "ರಕ್ತದ ಗುಂಪನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    blood_donation_required: "ರಕ್ತದಾನ ಸನ್ನದ್ಧತೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    book_sales: "ಪುಸ್ತಕ ಮಾರಾಟ",
    building_type: "ಕಟ್ಟಡದ ಪ್ರಕಾರ",
    building_type_required: "ಕಟ್ಟಡದ ಪ್ರಕಾರ ಅಗತ್ಯ",
    call: "ಕರೆ",
    campus_type: "ಕ್ಯಾಂಪಸ್ ಪ್ರಕಾರ",
    cancel: "ರದ್ದು",
    cancel_delete_request: "ಅಳಿಸುವ ವಿನಂತಿಯನ್ನು ರದ್ದುಮಾಡಿ",
    cancel_keep_signature: "ರದ್ದು & ಅಸ್ತಿತ್ವದ ಸಹಿ ಉಳಿಸಿ",
    captain: "ಕ್ಯಾಪ್ಟನ್",
    change_pin: "ನಿಮ್ಮ ಪಿನ್ ಬದಲಾಯಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    change_unit: "ಘಟಕ ಬದಲಾಯಿಸಿ",
    change_unit_members: "ಘಟಕ ಬದಲಾಯಿಸಬೇಕಾದ ಸದಸ್ಯರು",
    character_issues: "ಪಾತ್ರ ಸಮಸ್ಯೆಗಳು",
    child_label: "ಉಪ ಅಶಕ್ತತೆ",
    city_kasargod: "ಕಾಸರಗೋಡು",
    city_kochi: "ಕೊಚ್ಚಿ",
    city_kozhikode: "ಕೊಳ್ಳಿಕೋಡ್",
    city_thiruvananthapuram: "ತಿರುವನಂತಪುರಂ",
    class_format: "ವರ್ಗ ಸ್ವರೂಪ",
    clear: "ತೆರವುಗೊಳಿಸಿ",
    clear_cache: "ಕ್ಯಾಶ್ ತೆರವುಗೊಳಿಸಿ ಮತ್ತು ಆಪ್ ಮರುಪ್ರಾರಂಭಿಸಿ",
    click_here_to_bulk_download_expatriate_prints:
      "ಎಲ್ಲಾ ಪ್ರವಾಸಿ ಸದಸ್ಯರ ಮುದ್ರಣಗಳನ್ನು ಬೃಹತ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    click_here_to_consolidated_report: "ಏಕೀಕೃತ ವರದಿಗಾಗಿ ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    click_here_to_download_membership_report:
      "ಸದಸ್ಯತ್ವ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    click_here_to_view_and_pay_fee_details:
      "ಶುಲ್ಕ ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಮತ್ತು ಪಾವತಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    close: "ಮುಚ್ಚಿ",
    cluster: "ಕ್ಲಸ್ಟರ್",
    cluster_admin_add:
      "ವಲಯ ನಿರ್ವಾಹಕರು ನಿಮ್ಮ ಘಟಕದಲ್ಲಿ ಕ್ಲಸ್ಟರ್‌ಗಳನ್ನು ಸೇರಿಸುತ್ತಾರೆ",
    cluster_selected: "ಕ್ಲಸ್ಟರ್ ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ",
    clusters_list: "ಕ್ಲಸ್ಟರ್ ಪಟ್ಟಿ",
    code: "ಸಂಕೇತ",
    collected: "ಸಂಗ್ರಹಿಸಲಾಗಿದೆ",
    college_affiliation: "ಅರೇಬಿಕ್ ಕಾಲೇಜು ಯಾವ ಸಂಸ್ಥೆಯೊಂದಿಗೆ ಸಂಬಂಧ ಹೊಂದಿದೆ?",
    college_affiliation_required: "ಕಾಲೇಜು ಸಂಬಂಧ ಅಗತ್ಯ",
    college_building_type: "ಅರೇಬಿಕ್ ಕಾಲೇಜು ಕಟ್ಟಡದ ಪ್ರಕಾರ",
    college_building_type_required: "ಕಾಲೇಜು ಕಟ್ಟಡದ ಪ್ರಕಾರ ಅಗತ್ಯ",
    college_location: "ಅರೇಬಿಕ್ ಕಾಲೇಜು ಸ್ಥಳ",
    college_name: "ಅರೇಬಿಕ್ ಕಾಲೇಜು ಹೆಸರು",
    college_name_required: "ಕಾಲೇಜು ಹೆಸರು ಅಗತ್ಯ",
    college_started_year: "ಪ್ರಾರಂಭವಾದ ವರ್ಷ",
    conducted: "ನಡೆಸಲಾಗಿದೆ",
    confirmed: "ದೃಢೀಕರಿಸಲಾಗಿದೆ",
    contribute_label:
      "ನೀವು ಕೊಡುಗೆ ನೀಡಬಹುದಾದ ಕ್ಷೇತ್ರಗಳು (ಕನಿಷ್ಠ ಮೂರು ಆಯ್ಕೆಮಾಡಿ)",
    contribute_label_balavedi:
      "ನೀವು ಇಷ್ಟಪಡುವ ಮತ್ತು ಅತ್ಯಂತ ಕುಶಲತೆಯುಳ್ಳ ಚಟುವಟಿಕೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    convener_name: "ಸಂಘಟಕ ಹೆಸರು",
    convener_phone: "ಸಂಘಟಕ ಫೋನ್ ಸಂಖ್ಯೆ",
    convener_phone_required: "ಸಂಘಟಕ ಫೋನ್ ಸಂಖ್ಯೆ ಅಗತ್ಯ",
    country: "ದೇಶ",
    country_required: "ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    country_code_required: "ದೇಶದ ಸಂಕೇತ ಅಗತ್ಯ",
    completed: "ಪೂರ್ಣವಾಗಿದೆ",
    course_completing_year: "ಕೋರ್ಸ್ ಪೂರ್ಣಗೊಳ್ಳುವ ವರ್ಷ",
    course_details: "ಕೋರ್ಸ್ ವಿವರಗಳು",
    cre: "CRE",
    cre_day: "CRE ನಡೆಯುವ ದಿನ",
    cre_details: "CRE ವಿವರಗಳು",
    create_meeting: "ಸಭೆ ರಚಿಸಿ",
    create_new_account: "ಹೊಸ ಖಾತೆ ರಚಿಸಿ",
    current_captain: "ಪ್ರಸ್ತುತ ಕ್ಯಾಪ್ಟನ್",
    current_location: "ಪ್ರಸ್ತುತ ಸ್ಥಳ",
    current_status: "ಪ್ರಸ್ತುತ ಸ್ಥಿತಿ",
    current_vice_captain: "ಪ್ರಸ್ತುತ ಉಪ ಕ್ಯಾಪ್ಟನ್",
    current_location_required: "ಪ್ರಸ್ತುತ ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ!",

    daily: "ದೈನಂದಿನ",
    date: "ದಿನಾಂಕ",
    date_from: "ದಿನಾಂಕದಿಂದ",
    date_to: "ದಿನಾಂಕದವರೆಗೆ",
    dawa_directory: "ದಾವಾ ಡೈರೆಕ್ಟರಿ",
    day: "ನಡೆಯುವ ದಿನ",
    decided: "ನಿರ್ಧರಿಸಲಾಗಿದೆ",
    delete: "ಅಳಿಸಿ",
    delete_member: "ಸದಸ್ಯರನ್ನು ಅಳಿಸಿ",
    delete_members_list: "ಅಳಿಸಬೇಕಾದ ಸದಸ್ಯರ ಪಟ್ಟಿ",
    delete_reason_1: "ಸದಸ್ಯತ್ವಕ್ಕೆ ಅರ್ಹರಲ್ಲ, ತಪ್ಪಾಗಿ ಸೇರಿಸಲಾಗಿದೆ",
    delete_reason_2: "ಹಿಂದೆ ನಮ್ಮ ಕಾರ್ಯಕರ್ತ, ಈಗ ಆಸಕ್ತಿಯಿಲ್ಲ",
    delete_reason_3: "ನಮ್ಮ ಬೆಂಬಲಿಗ, ಸದಸ್ಯತ್ವ ಬೇಡ ಎಂದು ಹೇಳಿದರು",
    delete_reason_4:
      "ನಮ್ಮ ಕಾರ್ಯಕರ್ತ, ಹಲವು ಬಾರಿ ಪ್ರಯತ್ನಿಸಿದರೂ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತಿಲ್ಲ",
    delete_reason_5: "ಗಲ್ಫ್‌ನಲ್ಲಿದ್ದಾರೆ, ಬಯೋಡೇಟಾ ತುಂಬಿಲ್ಲ",
    delete_reason_6: "ಸ್ಮಾರ್ಟ್‌ಫೋನ್ ಇಲ್ಲ, ಬಯೋಡೇಟಾ ತುಂಬಿಲ್ಲ",
    delete_reason_7: "ಬಯೋಡೇಟಾ ತುಂಬಲು ಗೊತ್ತಿಲ್ಲ, ತುಂಬಿಲ್ಲ",
    delete_reason_8: "ಕಾರ್ಡ್‌ನಲ್ಲಿ ಸಂಖ್ಯೆ ತಪ್ಪಾಗಿದೆ, ಲಾಗಿನ್ ಆಗುತ್ತಿಲ್ಲ",
    delete_reason_9: "PIN ಸಿಗುತ್ತಿಲ್ಲ, ಲಾಗಿನ್ ಆಗುತ್ತಿಲ್ಲ",
    delete_reason_other: "ಇತರ ಕಾರಣಗಳು",
    delete_request: "ಅಳಿಸುವ ವಿನಂತಿ",
    delete_selected: "ಆಯ್ಕೆಮಾಡಿದವುಗಳನ್ನು ಅಳಿಸಿ",
    designation: "ಹುದ್ದೆ",
    designation_required: "ಹುದ್ದೆ ಅಗತ್ಯ",
    died: "ನಿಧನರಾಗಿದ್ದಾರೆ",
    disability_label: "ದೈಹಿಕ ಅಶಕ್ತತೆ",
    disability_section_title: "F. ದೈಹಿಕ ಅಶಕ್ತತೆಗಳು",
    disability_section_title_profile: "ದೈಹಿಕ ಅಶಕ್ತತೆಗಳು",
    district: "ಜಿಲ್ಲೆ",
    district_cluster_mapping: "ಜಿಲ್ಲಾ ಕ್ಲಸ್ಟರ್ ಮ್ಯಾಪಿಂಗ್",
    dob_year: "ಹುಟ್ಟಿದ ವರ್ಷ",
    doing_job: "ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದಾರೆ",
    download_biodata: "ಬಯೋಡೇಟಾ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    download_form: "ಫಾರ್ಮ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    download_receipt: "ರಸೀದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    download_result: "ಫಲಿತಾಂಶ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    draft_list: "ಕರಡು ಪಟ್ಟಿ",
    duplicate_entry: "ನಕಲು ನಮೂದು",
    duplicate_number_entry:
      "ಅವರನ್ನು ಬೇರೆ ಸಂಖ್ಯೆಯೊಂದಿಗೆ ಸೇರಿಸಲಾಗಿದೆ, ಇದು ಡಬಲ್ ನಮೂದು.",
    edit: "ಸಂಪಾದಿಸಿ",
    edit_election_officer: "ಚುನಾವಣಾ ಅಧಿಕಾರಿಯನ್ನು ಸಂಪಾದಿಸಿ",
    edit_executive_member: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರನ್ನು ಸಂಪಾದಿಸಿ",
    edit_member: "ಸದಸ್ಯರನ್ನು ಸಂಪಾದಿಸಿ",
    education_qualification: "ಶಿಕ್ಷಣ ಅರ್ಹತೆ",
    education_required: "ಶಾಲೆ/ಕ್ಯಾಂಪಸ್/ಕೋರ್ಸ್ ಮಾಹಿತಿ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ",
    election_attendance: "ಚುನಾವಣಾ ಹಾಜರಾತಿ",
    election_minutes_upload: "ನಿಮಿಷಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    election_officers: "ಚುನಾವಣಾ ಅಧಿಕಾರಿಗಳು",
    election_officers_list: "ಚುನಾವಣಾ ಅಧಿಕಾರಿಗಳ ಪಟ್ಟಿ",
    election_report: "{level} ಚುನಾವಣಾ ವರದಿ ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    eligible: "ಭಾಗವಹಿಸಲು ಅರ್ಹರು",
    email: "ಇಮೇಲ್",
    enter_age: "ವಯಸ್ಸು ನಮೂದಿಸಿ",
    enter_college_location: "ಗೂಗಲ್ ಮ್ಯಾಪ್ಸ್‌ನಿಂದ ಸ್ಥಳ ನಮೂದಿಸಿ",
    enter_college_name: "ಕಾಲೇಜು ಹೆಸರು ನಮೂದಿಸಿ",
    enter_college_started_year: "ಪ್ರಾರಂಭವಾದ ವರ್ಷ ನಮೂದಿಸಿ",
    enter_convener_name: "ಸಂಘಟಕ ಹೆಸರು ನಮೂದಿಸಿ",
    enter_convener_phone: "ಸಂಘಟಕ ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_country_code: "ದೇಶದ ಸಂಕೇತ ನಮೂದಿಸಿ",
    enter_executive_count: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_facebook_link: "ಫೇಸ್‌ಬುಕ್ ಲಿಂಕ್ ನಮೂದಿಸಿ",
    enter_hifdh_students_count: "ವಿದ್ಯಾರ್ಥಿಗಳ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_imam_name: "ಇಮಾಮ್ ಹೆಸರು ನಮೂದಿಸಿ",
    enter_imam_phone: "ಇಮಾಮ್ ಫೋನ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_imam_state: "ಇಮಾಮ್ ರಾಜ್ಯ ನಮೂದಿಸಿ",
    enter_instagram_link: "ಇನ್‌ಸ್ಟಾಗ್ರಾಮ್ ಲಿಂಕ್ ನಮೂದಿಸಿ",
    enter_madrasa_location: "ಗೂಗಲ್ ಮ್ಯಾಪ್ಸ್‌ನಿಂದ ಮದರಸಾ ಸ್ಥಳ ನಮೂದಿಸಿ",
    enter_madrasa_name: "ಮದರಸಾ ಹೆಸರು ನಮೂದಿಸಿ",
    enter_madrasa_started_year: "ಮದರಸಾ ಪ್ರಾರಂಭವಾದ ವರ್ಷ ನಮೂದಿಸಿ",
    enter_main_healthcare_activities: "ಮುಖ್ಯ ಚಟುವಟಿಕೆಗಳನ್ನು ನಮೂದಿಸಿ",
    enter_masjid_location: "ಗೂಗಲ್ ಮ್ಯಾಪ್ ಸ್ಥಳ ನಮೂದಿಸಿ",
    enter_mobile: "ಮೊಬೈಲ್ ನಮೂದಿಸಿ",
    enter_name: "ಹೆಸರು ನಮೂದಿಸಿ",
    enter_name_required: "ಹೆಸರು ನಮೂದಿಸಿ",
    enter_office_location: "ಕಚೇರಿ ಸ್ಥಳ ನಮೂದಿಸಿ",
    enter_orphan_count: "ಮಕ್ಕಳ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_other_institution_1: "ಇತರ ಸಂಸ್ಥೆ ಹೆಸರು 1",
    enter_other_institution_2: "ಇತರ ಸಂಸ್ಥೆ ಹೆಸರು 2",
    enter_other_institution_3: "ಇತರ ಸಂಸ್ಥೆ ಹೆಸರು 3",
    enter_other_land: "ಇತರ ಭೂಮಿಯನ್ನು ಸೆಂಟ್‌ಗಳಲ್ಲಿ ನಮೂದಿಸಿ",
    enter_parking_capacity: "ವಾಹನಗಳ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_qhls_location: "ಗೂಗಲ್ ಮ್ಯಾಪ್ಸ್‌ನಿಂದ QHLS ಸ್ಥಳ ನಮೂದಿಸಿ",
    enter_qhls_name: "QHLS ಹೆಸರು ನಮೂದಿಸಿ",
    enter_qhls_participants_count: "ಭಾಗವಹಿಸುವವರ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_qhls_started_year: "QHLS ಪ್ರಾರಂಭವಾದ ವರ್ಷ ನಮೂದಿಸಿ",
    enter_staff_count: "ಸಿಬ್ಬಂದಿ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_target: "ಗುರಿ ನಮೂದಿಸಿ",
    enter_teachers_count: "ಶಿಕ್ಷಕರ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ",
    enter_trust_land_in_cent: "ಟ್ರಸ್ಟ್ ಭೂಮಿಯನ್ನು ಸೆಂಟ್‌ಗಳಲ್ಲಿ ನಮೂದಿಸಿ",
    enter_wisdom_media_link: "ವಿಸ್ಡಮ್ ಮೀಡಿಯಾ ಲಿಂಕ್ ನಮೂದಿಸಿ",
    enter_youtube_link: "ಯೂಟ್ಯೂಬ್ ಲಿಂಕ್ ನಮೂದಿಸಿ",
    exc_count: "ಕಾರ್ಯಕಾರಿ ಎಣಿಕೆ",
    exc_members_count: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರ ಸಂಖ್ಯೆ: ",
    executive_count: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರ ಸಂಖ್ಯೆ",
    executive_count_selected: "ಆಯ್ಕೆಮಾಡಿದ ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರು",
    executive_members_list: "ಕಾರ್ಯಕಾರಿ ಸದಸ್ಯರ ಪಟ್ಟಿ",
    executives: "ಕಾರ್ಯಕಾರಿಗಳು",
    existing_files: "ಅಸ್ತಿತ್ವದಲ್ಲಿರುವ ಕಡತಗಳು",
    extra_activity_section_title: "E. ಇತರ ಕೌಶಲ್ಯಗಳು / ಆಸಕ್ತಿಗಳು",
    extra_activity_section_title_profile: "ಇತರ ಕೌಶಲ್ಯಗಳು / ಆಸಕ್ತಿಗಳು",
    facebook: "ಫೇಸ್‌ಬುಕ್",
    facilities: "ಮಸೀದಿಯಲ್ಲಿ ಲಭ್ಯವಿರುವ ಸೌಲಭ್ಯಗಳು",
    father_name_english_only: "ತಂದೆಯ ಹೆಸರು (ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಮಾತ್ರ)",
    fee_status: "ಶುಲ್ಕ ಸ್ಥಿತಿ",
    field_required: "ಈ ಕ್ಷೇತ್ರ ಅಗತ್ಯ",
    fill_pending_data: "ತುಂಬಲು ಬಾಕಿ ಇರುವ ಡೇಟಾ.",
    financial_issues: "ಆರ್ಥಿಕ ಸಮಸ್ಯೆಗಳು",
    fill_status: "ಜೀವನ ಚರಿತ್ರೆ ಭರ್ತಿ/ತಿದ್ದು ಮಾಡಲು ಕ್ಲಿಕ್ ಮಾಡಿ",
    forign_mobile: "ವಿದೇಶಿ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    form_collected_status: "ಫಾರ್ಮ್ ಸಂಗ್ರಹಿಸಿದ ಸ್ಥಿತಿ",
    form_collection: "ಫಾರ್ಮ್ ಸಂಗ್ರಹ",
    friday: "ಶುಕ್ರವಾರ",
    girls: "ಹುಡುಗಿಯರು",
    go_to_branch: "ಘಟಕ ಪುಟಕ್ಕೆ ಹೋಗಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    go_to_lajna: "ಲಜ್ನಾ ಪುಟಕ್ಕೆ ಹೋಗಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    happened: "ನಡೆಯಿತು",
    has_arabic_college_mujahid: "ಘಟಕದಲ್ಲಿ ಮುಜಾಹಿದ್ ಅರೇಬಿಕ್ ಕಾಲೇಜು ಇದೆಯೇ?",
    has_centre: "ಘಟಕ ಚಟುವಟಿಕೆಗಳಿಗೆ ಕೇಂದ್ರವಿದೆಯೇ?",
    has_jumua: "ಇದು ಜುಮ್ಆ ನಡೆಯುವ ಮಸೀದಿಯೇ?",
    has_madrasa_mujahid: "ಮುಜಾಹಿದ್ ಮದರಸಾ ಇದೆಯೇ?",
    has_masjid_mujahid: "ಘಟಕದಲ್ಲಿ ಮುಜಾಹಿದ್ ಮಸೀದಿ ಇದೆಯೇ?",
    help_desk: "ಸಹಾಯ ಕೇಂದ್ರ",
    hifdh_college: "ಕುರಾನ್ ಹಿಫ್ಜ್ ಕಾಲೇಜು",
    hifdh_students_count: "ವಿದ್ಯಾರ್ಥಿಗಳ ಸಂಖ್ಯೆ",
    home: "ಮುಖಪುಟ",
    home_name_required: "ಮನೆಯ ಹೆಸರನ್ನು ಟೈಪ್ ಮಾಡಿ!",
    hour: "ಗಂಟೆ",
    hour_required: "ಗಂಟೆ ಅಗತ್ಯ",
    house_status: "ಮನೆಯ ಪ್ರಕಾರ",
    house_status_required: "ಮನೆಯ ಸ್ಥಿತಿಯನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    house_wife: "ಗೃಹಿಣಿ",
    how_to_change_pin: "5. ಈ PIN ಸಂಖ್ಯೆಯನ್ನು ಬದಲಾಯಿಸಬಹುದೇ?",
    how_to_change_pin_1:
      "ಪ್ರಸ್ತುತ 'Profile' ಅಡಿಯಲ್ಲಿ ನಿಮ್ಮ ಇಷ್ಟಾನುಸಾರ PIN ಸಂಖ್ಯೆ ಹೊಂದಿಸಲು ಆಯ್ಕೆ ಇದೆ. ಅದನ್ನು ಬಳಸಿ PIN ಬದಲಾಯಿಸಬಹುದು.",
    how_to_get_pin_again: "6. PIN ಸಂಖ್ಯೆ ಮರೆತಿದ್ದರೆ ಬಳಕೆದಾರರು ಏನು ಮಾಡಬೇಕು?",
    how_to_get_pin_again_1:
      "ಮೊದಲ ಬಾರಿ ಮಾಡಿದಂತೆ, ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಮತ್ತೆ ನಮೂದಿಸಿ, SMS ಮೂಲಕ PIN ಸಂಖ್ಯೆ ಪಡೆಯಬಹುದು. ಆಪ್‌ನಲ್ಲಿ ಈ ವೈಶಿಷ್ಟ್ಯ ಬಳಸಿ.",
    how_to_install: "3. ಲಿಂಕ್‌ನಿಂದ ಆಪ್ ಬಳಸುವುದು ಹೇಗೆ",
    how_to_install_link:
      "ಲಿಂಕ್ ಕ್ಲಿಕ್ ಮಾಡಿದಾಗ, ಅದು ನಿಮ್ಮ ಸಾಧನ ಬ್ರೌಸರ್‌ನಲ್ಲಿ ತೆರೆಯುತ್ತದೆ (ಉದಾ., Google Chrome, ಇತ್ಯಾದಿ). ಅಲ್ಲಿಂದ, ಮೊಬೈಲ್ ಆಪ್‌ನಂತೆ ನಿಮ್ಮ ಫೋನ್‌ನಲ್ಲಿ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಬಹುದು. ಇದಕ್ಕಾಗಿ, ಬ್ರೌಸರ್‌ನಲ್ಲಿ 'Add to Home' ಆಯ್ಕೆ ಬಳಸಿ. ಉತ್ತಮ ತಿಳುವಳಿಕೆಗಾಗಿ ಈ ವೀಡಿಯೊ ವೀಕ್ಷಿಸಿ.",
    how_to_login: "4. ಲಾಗಿನ್ ಮಾಡುವಾಗ ಬಳಕೆದಾರರು ಏನು ನೆನಪಿಡಬೇಕು?",
    how_to_login_1:
      "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಬಳಸಿ ಲಾಗಿನ್ ಮಾಡಬೇಕು. ಮೊದಲ ಬಾರಿ ಬಳಕೆದಾರರು SMS ಮೂಲಕ PIN ಸಂಖ್ಯೆ ಪಡೆಯುತ್ತಾರೆ. ಈ PIN ಸಂಖ್ಯೆ ಎಚ್ಚರಿಕೆಯಿಂದ ನೆನಪಿಡಿ. ಬೇರೆ ಸಾಧನದಿಂದ ಲಾಗಿನ್ ಮಾಡುವಾಗ ಅಥವಾ ಪ್ರಸ್ತುತ ಸಾಧನದಿಂದ ಲಾಗೌಟ್ ಆದ ನಂತರ ಮತ್ತೆ ಲಾಗಿನ್ ಮಾಡುವಾಗ ಇದೇ PIN ಅಗತ್ಯ.",
    how_to_use_app: "1. ವಿಸ್ಡಮ್ ಗೈಡ್ ಮೊಬೈಲ್ ಆಪ್ ಎಲ್ಲಿ ಪಡೆಯುವುದು",
    how_to_use_app_link:
      "http://guide.wisdomislam.org/ ಲಿಂಕ್‌ಗೆ ಭೇಟಿ ನೀಡುವ ಮೂಲಕ ಯಾರಾದರೂ ಆಪ್ ಪ್ರವೇಶಿಸಬಹುದು.",
    i_will_attend: "ನಾನು ಹಾಜರಾಗುತ್ತೇನೆ",
    imam_name: "ಇಮಾಮ್ ಹೆಸರು",
    imam_phone: "ಇಮಾಮ್ ಫೋನ್ ಸಂಖ್ಯೆ",
    imam_state: "ಇಮಾಮ್ ರಾಜ್ಯ",
    in_state: "ರಾಜ್ಯದಲ್ಲಿ",
    incorrectly_added: "ತಪ್ಪಾಗಿ ಸೇರಿಸಲಾಗಿದೆ",
    increase: "ಹೆಚ್ಚಿಸಿ",
    instagram: "ಇನ್‌ಸ್ಟಾಗ್ರಾಮ್",
    institution_name: "ಸಂಸ್ಥೆ/ಕಾಲೇಜು ಹೆಸರು",
    is_member: "ಸದಸ್ಯ",
    is_subscriber: "ಪ್ರಸ್ತುತ ಚಂದಾದಾರರೇ?",
    islamic_education_qualification:
      "ಇಸ್ಲಾಮಿಕ್ ಶಿಕ್ಷಣ ಅರ್ಹತೆ (ಕೊನೆಯ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್)",
    islamic_special_degree: "ವಿಶೇಷ ಇಸ್ಲಾಮಿಕ್ ಪದವಿ",
    islahi_year_label:
      "ಸಲಫಿ/ಇಸ್ಲಾಹಿ ಸಂಸ್ಥೆಗಳಲ್ಲಿ ಎಷ್ಟು ವರ್ಷಗಳು ಸಕ್ರಿಯರಾಗಿದ್ದೀರಿ?",
    job: "ಕೆಲಸ",
    job_category: "ಕೆಲಸದ ವರ್ಗ",
    job_divisions: "ಕೆಲಸದ ವಿಭಾಗಗಳು",
    job_required: "ಕೆಲಸ ಅಗತ್ಯ!",
    job_section_title: "ಕೆಲಸದ ಮಾಹಿತಿ",
    job_sub_category: "ಕೆಲಸದ ಉಪ ವರ್ಗ",
    job_sub_divisions: "ಕೆಲಸದ ಉಪ ವಿಭಾಗಗಳು",
    jumua_attendance: "ಜುಮ್ಆ ನಡೆದರೆ, ಸುಮಾರು ಎಷ್ಟು ಜನರು ಹಾಜರಾಗುತ್ತಾರೆ?",
    knm: "ಕೆ.ಎನ್.ಎಮ್",
    known_languages: "ನಿಮಗೆ ತಿಳಿದಿರುವ ಭಾಷೆಗಳು",
    lajna_member_status: "ಲಜ್ನಾ ಸದಸ್ಯ ಸ್ಥಿತಿ",
    lajna_membership: "ಲಜ್ನಾ ಸದಸ್ಯತ್ವ",
    land_and_building: "ಭೂಮಿ & ಕಟ್ಟಡ",
    land_in_cent: "ಭೂಮಿ ಸೆಂಟ್‌ಗಳಲ್ಲಿ",
    language: "ಭಾಷೆಗಳು",
    language_info_title: "ತಿಳಿದಿರುವ ಭಾಷೆಗಳು",
    last_time_added_by_mistake: "ಕೊನೆಯ ಬಾರಿ ತಪ್ಪಾಗಿ ಸೇರಿಸಲಾಗಿದೆ.",
    latest_news: "ಇತ್ತೀಚಿನ ಸುದ್ದಿಗಳು",
    leave: "ರಜೆ",
    library: "ಗ್ರಂಥಾಲಯ",
    list: "ಪಟ್ಟಿ",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    location: "ಸ್ಥಳ",
    login: "ಲಾಗಿನ್",
    logout: "ಲಾಗೌಟ್",
    madrasa: "ಮದರಸಾ",
    madrasa_affiliation: "ಮದರಸಾ ಯಾವ ಸಂಸ್ಥೆಯೊಂದಿಗೆ ಸಂಬಂಧ ಹೊಂದಿದೆ?",
    madrasa_details: "ಮದರಸಾ ವಿವರಗಳು",
    madrasa_location: "ಮದರಸಾ ಸ್ಥಳ",
    madrasa_name: "ಮದರಸಾ ಹೆಸರು",
    madrasa_started_year: "ಮದರಸಾ ಪ್ರಾರಂಭವಾದ ವರ್ಷ",
    main_healthcare_activities: "ಮುಖ್ಯ ಚಟುವಟಿಕೆಗಳು",
    make_payment: "ಪಾವತಿ ಮಾಡಿ",
    markaz: "ಮರ್ಕಜ್ ದಾವಾ",
    masjid: "ಮಸೀದಿ",
    masjid_affiliation: "ಮಸೀದಿ ಯಾವ ಸಂಸ್ಥೆಯೊಂದಿಗೆ ಸಂಬಂಧ ಹೊಂದಿದೆ?",
    masjid_details: "ಮಸೀದಿ ವಿವರಗಳು",
    masjid_location: "ಮಸೀದಿ ಸ್ಥಳ",
    masjid_required: "ಮಸೀದಿ ವಿವರಗಳು ಅಗತ್ಯ",
    max_allowed: "ಗರಿಷ್ಠ 7 ಸದಸ್ಯರು ಅನುಮತಿ",
    maximum_7_allowed: "ಗರಿಷ್ಠ 7 ಸದಸ್ಯರು ಅನುಮತಿ",
    maximum_7_team_members: "ಗರಿಷ್ಠ 7 ತಂಡ ಸದಸ್ಯರು ಅನುಮತಿ",
    meeting_date: "ಸಭೆ ದಿನಾಂಕ",
    meeting_hall: "ಸಭಾ ಭವನ",
    meeting_level: "ಸಭೆ ಮಟ್ಟ",
    meeting_link: "ಸಭೆ ಲಿಂಕ್",
    meeting_minutes: "ಸಭೆ ನಿಮಿಷಗಳು",
    meeting_mode: "ಸಭೆ ವಿಧಾನ",
    meeting_name: "ಸಭೆ ಹೆಸರು",
    meeting_period: "ಸಭೆ ಅವಧಿ",
    meeting_report: "ಸಭೆ ವರದಿಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    meeting_time: "ಸಭೆ ಸಮಯ",
    meeting_type: "ಸಭೆ ಪ್ರಕಾರ",
    member_current_status: "ಸದಸ್ಯ ಪ್ರಸ್ತುತ ಸ್ಥಿತಿ",
    member_details: "ಸದಸ್ಯರ ವಿವರಗಳು",
    member_signature: "ಸದಸ್ಯ ಸಹಿ (ಮಲಯಾಳಂ: അംഗത്തിന്റെ ഒപ്പ്)",
    member_signature_mal: "അംഗത്തിന്റെ ഒപ്പ്",
    member_status: "ಸದಸ್ಯ ಸ್ಥಿತಿ",
    members: "ಸದಸ್ಯರು",
    members_7: "7 ಸದಸ್ಯರು",
    members_list: "ಸದಸ್ಯರ ಪಟ್ಟಿ",
    members_payments_btn:
      "ಸದಸ್ಯ ಶುಲ್ಕಗಳನ್ನು ವೀಕ್ಷಿಸಲು ಮತ್ತು ಪಾವತಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    members_under_mobile: "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಡಿಯಲ್ಲಿ ಸದಸ್ಯರು.",
    members_under_mobile_of: "{{name}} ಅವರ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಡಿಯಲ್ಲಿ ಸದಸ್ಯರು.",
    membership_biodata: "ಸದಸ್ಯತ್ವ & ಬಯೋಡೇಟಾ",
    membership_consolidated_report_btn:
      "ಏಕೀಕೃತ ಸದಸ್ಯತ್ವ ವರದಿ ವೀಕ್ಷಿಸಲು ಮತ್ತು ವಲಯಕ್ಕೆ ಕಳುಹಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    membership_details: "ಸದಸ್ಯತ್ವ ವಿವರಗಳು",
    membership_details_update: "ಸದಸ್ಯತ್ವ ವಿವರಗಳು & ಬಯೋಡೇಟಾ ನವೀಕರಣಗಳು",
    membership_form_bulk_download_btn:
      "ಎಲ್ಲಾ ಪ್ರವಾಸಿ ಸದಸ್ಯರ ಮುದ್ರಣಗಳನ್ನು ಬೃಹತ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    membership_report: "ಸದಸ್ಯತ್ವ ವರದಿ",
    membership_report_download_btn:
      "ಸದಸ್ಯತ್ವ ವರದಿಯನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
    membership_status: "ಸದಸ್ಯತ್ವ ಸ್ಥಿತಿ",
    membership_verification: "ಸದಸ್ಯತ್ವ ಪರಿಶೀಲನೆ",
    menu: "ಮೆನು",
    minutes: "ನಿಮಿಷಗಳು",
    mobile: "ಮೊಬೈಲ್",
    mobile_number: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    mobile_number_length: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ 10 ಅಂಕೆಗಳು ಇರಬೇಕು",
    mobile_number_required: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಗತ್ಯ",
    mobile_required: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಅಗತ್ಯ!",
    mobile_update_warning:
      "ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಬದಲಾಯಿಸಿದರೆ, ನಿಮ್ಮ ಎಲ್ಲಾ ಸದಸ್ಯರ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗಳು ನವೀಕರಿಸಲ್ಪಡುತ್ತವೆ.",
    monday: "ಸೋಮವಾರ",
    monthly: "ತಿಂಗಳಿಗೊಮ್ಮೆ",
    move_to_karad_list: "ಕರಡು ಪಟ್ಟಿಗೆ ಸರಿಸಿ",
    move_to_members_list: "ಸದಸ್ಯರ ಪಟ್ಟಿಗೆ ಸರಿಸಿ",
    my_attendance: "ನನ್ನ ಹಾಜರಾತಿ",
    my_biodata_form: "ನನ್ನ ಬಯೋಡೇಟಾ ಫಾರ್ಮ್",
    my_campus: "ನನ್ನ ಕ್ಯಾಂಪಸ್",
    my_district: "ನನ್ನ ಜಿಲ್ಲೆ",
    my_duties: "ನನ್ನ ಕರ್ತವ್ಯಗಳು",
    my_meetings: "ನನ್ನ ಸಭೆಗಳು",
    my_profile: "ನನ್ನ ಪ್ರೊಫೈಲ್",
    my_unit: "ನನ್ನ ಘಟಕ",
    my_zone: "ನನ್ನ ವಲಯ",
    name: "ಹೆಸರು",
    name_address: "ಹೆಸರು ಮತ್ತು ವಿಳಾಸ",
    name_english_only: "ಹೆಸರು (ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಮಾತ್ರ)",
    name_regex: "ಹೆಸರನ್ನು ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ ಟೈಪ್ ಮಾಡಿ",
    name_required: "ಹೆಸರು ಅಗತ್ಯ!",
    nerpatham: "ನೇರ್‌ಪಥಮ್",
    nerpatham_desc: "ನೇರ್‌ಪಥಮ್ ಸೇರಿಸಲು ಅಥವಾ ನವೀಕರಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    nerpatham_target: "ನೇರ್‌ಪಥಮ್ ಗುರಿ",
    new: "ಹೊಸ",
    next: "ಮುಂದೆ",
    no: "ಇಲ್ಲ",
    no_2: "ಇಲ್ಲ",
    no_clusters: "ಕ್ಲಸ್ಟರ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    no_clusters_available: "ಆಯ್ಕೆಮಾಡಿದ ಪಂಚಾಯತ್‌ಗೆ ಕ್ಲಸ್ಟರ್‌ಗಳು ಲಭ್ಯವಿಲ್ಲ",
    no_data: "ಡೇಟಾ ಇಲ್ಲ...",
    no_election_officers_found: "ಈ ವಿಭಾಗಕ್ಕೆ ಚುನಾವಣಾ ಅಧಿಕಾರಿಗಳು ಕಂಡುಬಂದಿಲ್ಲ.",
    no_information: "ಮಾಹಿತಿ ಇಲ್ಲ",
    no_job: "ಕೆಲಸವಿಲ್ಲ",
    no_longer_needed: "ಅವರು/ಅವಳು ಇನ್ನು ಸದಸ್ಯತ್ವ ಬೇಡ ಎಂದರು.",
    no_longer_needed_2: "ಘಟಕ ಸಮಿತಿ ಸದಸ್ಯತ್ವ ತೆಗೆದುಹಾಕಲು ನಿರ್ಧರಿಸಿದೆ.",
    no_longer_needed_3: "ನಾವು ಪ್ರಸ್ತುತ ಆದರ್ಶಗಳಲ್ಲಿ ಆಸಕ್ತಿ ಇಲ್ಲ.",
    no_members_added: "ಇನ್ನೂ ಸದಸ್ಯರನ್ನು ಸೇರಿಸಿಲ್ಲ",
    not_active_in_native: "ಸ್ವದೇಶದಲ್ಲಿ ಸಕ್ರಿಯವಿಲ್ಲ",
    not_collected: "ಸಂಗ್ರಹಿಸಿಲ್ಲ",
    not_editable: "ನೀವು ನಿಮ್ಮ ಸ್ವಂತ ಘಟಕದಲ್ಲಿ ಮಾತ್ರ ಡೇಟಾ ತುಂಬಬಹುದು",
    not_in_draft: "ನಿಮ್ಮ ಸಂಖ್ಯೆಯನ್ನು ಕರಡು ಪಟ್ಟಿಗೆ ಸೇರಿಸಿಲ್ಲ.",
    not_member: "ಸದಸ್ಯರಲ್ಲ",
    not_registered: "ನೋಂದಾಯಿಸಿಲ್ಲ",
    not_verified: "ಪರಿಶೀಲಿಸಿಲ್ಲ",
    not_verified_reason: "ಪರಿಶೀಲಿಸದ ಕಾರಣ",
    note: "ಟಿಪ್ಪಣಿ",
    nri_notnow: "ಮೊದಲು NRI ಆಗಿದ್ದರು, ಈಗ ಸ್ವದೇಶದಲ್ಲಿ ನೆಲೆಸಿದ್ದಾರೆ.",
    nri_status: "ನೀವು NRI ಆಗಿದ್ದೀರಾ?",
    nri_yes: "NRI",
    number_of_teachers: "ಎಷ್ಟು ಶಿಕ್ಷಕರಿದ್ದಾರೆ?",
    of: "ರಲ್ಲಿ",
    office_location: "ಕಚೇರಿ ಸ್ಥಳ",
    office_location_required: "ಕಚೇರಿ ಸ್ಥಳ ಅಗತ್ಯ",
    old: "ಹಳೆಯ",
    online: "ಆನ್‌ಲೈನ್",
    optional: "ಐಚ್ಛಿಕ",
    options_selected: "ಆಯ್ಕೆಗಳು ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ",
    orphan_care: "ಅನಾಥ ಆರೈಕೆ",
    orphan_count: "ಬೆಂಬಲಿತ ಮಕ್ಕಳ ಸಂಖ್ಯೆ",
    other: "ಇತರ",
    other_course_details:
      "ನಿಮ್ಮ ಕೋರ್ಸ್ ಮೇಲೆ ಪಟ್ಟಿ ಮಾಡಿಲ್ಲದಿದ್ದರೆ ಅಥವಾ ಇತರ ವಿವರಗಳಿದ್ದರೆ, ದಯವಿಟ್ಟು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ",
    other_institutions: "ಇತರ ಸಂಸ್ಥೆಗಳು",
    other_job_details:
      "ನಿಮ್ಮ ಕೆಲಸ ಮೇಲೆ ಪಟ್ಟಿ ಮಾಡಿಲ್ಲದಿದ್ದರೆ ಅಥವಾ ಇತರ ವಿವರಗಳಿದ್ದರೆ, ದಯವಿಟ್ಟು ನಿರ್ದಿಷ್ಟಪಡಿಸಿ",
    other_land: "ಘಟಕ ನಿಯಂತ್ರಣದಲ್ಲಿ ಇತರ ಭೂಮಿ",
    other_org_label:
      "ಇತರ ಸಾಮಾಜಿಕ/ರಾಜಕೀಯ ಸಂಸ್ಥೆಗಳಲ್ಲಿ ಸಕ್ರಿಯರಿದ್ದೀರಾ? ಹೌದು ಎಂದಾದರೆ, ವಿವರಗಳು?",
    other_reason: "ಇತರ ಕಾರಣ",
    other_services: "ಇತರ ಸೇವೆಗಳು",
    outside_state_india: "ರಾಜ್ಯದ ಹೊರಗೆ (ಭಾರತದಲ್ಲಿ)",
    own: "ಸ್ವಂತ ಕಟ್ಟಡ",
    paid: "ಪಾವತಿಸಲಾಗಿದೆ",
    panchayath: "ಪಂಚಾಯತ್",
    parking_capacity: "ಎಷ್ಟು ವಾಹನಗಳನ್ನು ನಿಲ್ಲಿಸಬಹುದು?",
    participant_id: "ಭಾಗವಹಿಸುವವರ ID",
    participants: "ಭಾಗವಹಿಸುವವರು",
    payment_information: "ಪಾವತಿ ಮಾಹಿತಿ",
    peace_radio: "ಪೀಸ್ ರೇಡಿಯೊ ಕಿಯೋಸ್ಕ್",
    pending: "ಬಾಕಿ ಉಳಿದಿದೆ",
    pending_members_list: "ಬಾಕಿ ಸದಸ್ಯರ ಪಟ್ಟಿ",
    permanent_address_india: "ಶಾಶ್ವತ ವಿಳಾಸ (ಭಾರತದಲ್ಲಿ)",
    physical: "ಭೌತಿಕ",
    physical_education_qualification:
      "ದೈಹಿಕ ಶಿಕ್ಷಣ ಅರ್ಹತೆ (ಕೊನೆಯ ಪೂರ್ಣಗೊಂಡ ಕೋರ್ಸ್)",
    pin_code: "ಪಿನ್ ಕೋಡ್",
    place: "ಸ್ಥಳ",
    plus2: "ಪ್ಲಸ್ 2",
    plustwo: "ಪ್ಲಸ್ ಟೂ",
    plustwo_subject: "ಪ್ಲಸ್ ಟೂ ವಿಷಯ",
    post_office: "ಪೋಸ್ಟ್ ಆಫೀಸ್",
    present: "ಹಾಜರಿದ್ದರು",
    presiding_units_btn:
      "ನೀವು ಅಧ್ಯಕ್ಷ ಅಧಿಕಾರಿಯಾಗಿರುವ ಘಟಕ ವೀಕ್ಷಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    presiding_zones_btn:
      "Click here to view zones where you are the presiding officer",
    presiding_districts_btn: "Click here to view districts where you are the presiding officer",
    print_biodata: "ಬಯೋಡೇಟಾ ಮುದ್ರಿಸಿ",
    public: "ಸಾರ್ವಜನಿಕ",
    qhls: "QHLS",
    qhls_details: "QHLS ವಿವರಗಳು",
    qhls_frequency: "ಆವರ್ತನ",
    qhls_location: "QHLS ಸ್ಥಳ",
    qhls_name: "QHLS ಹೆಸರು",
    qhls_participants_count: "ಭಾಗವಹಿಸುವವರ ಸಂಖ್ಯೆ",
    qhls_register: "QHLS ನೋಂದಣಿ",
    qhls_started_year: "QHLS ಪ್ರಾರಂಭವಾದ ವರ್ಷ",
    qr_code: "QR ಕೋಡ್",
    qr_code_attendance_desc: "QR ಕೋಡ್ ಬಳಸಿ ಹಾಜರಾತಿ ಗುರುತಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    qr_code_scanner: "QR ಕೋಡ್ ಸ್ಕ್ಯಾನರ್.",
    questionnaire: "ಪ್ರಶ್ನಾವಳಿ",
    quick_actions: "ತ್ವರಿತ ಕ್ರಿಯೆಗಳು",
    read_more: "ಇನ್ನಷ್ಟು ಓದಿ",
    reason: "ಕಾರಣ",
    reason_to_delete: "ಅಳಿಸಲು ಕಾರಣ",
    reason_to_delete_explain: "ಅಳಿಸಲು ಕಾರಣ ವಿವರಿಸಿ",
    receipt_number: "ರಸೀತಿ ಸಂಖ್ಯೆ",
    registered: "ನೋಂದಾಯಿಸಲಾಗಿದೆ",
    registration_links: "ನೋಂದಣಿ ಲಿಂಕ್‌ಗಳು",
    reject_and_delete: "ಅಳಿಸುವ ವಿನಂತಿ ತಿರಸ್ಕರಿಸಿ",
    reject_delete_request: "ಅಳಿಸುವ ವಿನಂತಿ ತಿರಸ್ಕರಿಸಿ",
    reject_transfer: "ವರ್ಗಾವಣೆ ತಿರಸ್ಕರಿಸಿ",
    remark: "ಟಿಪ್ಪಣಿ",
    remove: "ತೆಗೆದುಹಾಕಿ",
    remove_from_team: "ತಂಡದಿಂದ ತೆಗೆದುಹಾಕಿ",
    renew_member: "ಸದಸ್ಯರನ್ನು ನವೀಕರಿಸಿ",
    renew_membership: "ಸದಸ್ಯತ್ವ ನವೀಕರಿಸಿ",
    rent: "ಬಾಡಿಗೆ",
    replace_files: "ಕಡತಗಳನ್ನು ಬದಲಾಯಿಸಿ",
    replaced_files: "ಕಡತಗಳನ್ನು ಮರು-ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    report: "ವರದಿ",
    reports: "ವರದಿಗಳು",
    restore_member: "ಸದಸ್ಯರನ್ನು ಮರುಸ್ಥಾಪಿಸಿ",
    restore_to_members_list: "ಸದಸ್ಯರ ಪಟ್ಟಿಗೆ ಮರುಸ್ಥಾಪಿಸಿ",
    retired: "ನಿವೃತ್ತ",
    reupload_signature: "ಸಹಿ ಮರು-ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    salah_asr: "ಅಸರ್",
    salah_dhuhr: "ಜುಹರ್",
    salah_fajr: "ಫಜ್ರ್",
    salah_isha: "ಇಶಾ",
    salah_maghrib: "ಮಗ್ರಿಬ್",
    same_address: "ಪ್ರಸ್ತುತ ವಿಳಾಸ ಮತ್ತು ಶಾಶ್ವತ ವಿಳಾಸ ಒಂದೇ",
    saturday: "ಶನಿವಾರ",
    save: "ಉಳಿಸಿ",
    save_member_list: "ಉಳಿಸಿ ಮತ್ತು ಸದಸ್ಯರ ಪಟ್ಟಿಗೆ ಸರಿಸಿ",
    save_move_to_karad: "ಉಳಿಸಿ ಮತ್ತು ಕರಡು ಪಟ್ಟಿಗೆ ಸರಿಸಿ",
    save_next: "ಉಳಿಸಿ & ಮುಂದೆ",
    scanner: "ಸ್ಕ್ಯಾನರ್",
    search: "ಇಲ್ಲಿ ಹುಡುಕಿ...",
    search_clusters: "ಕ್ಲಸ್ಟರ್‌ಗಳನ್ನು ಹುಡುಕಿ...",
    select: "---ಆಯ್ಕೆಮಾಡಿ---",
    select_all: "ಎಲ್ಲಾ ಕ್ಲಸ್ಟರ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    select_captain: "ಕ್ಯಾಪ್ಟನ್ ಆಯ್ಕೆಮಾಡಿ",
    select_cluster: "ಕ್ಲಸ್ಟರ್ ಆಯ್ಕೆಮಾಡಿ",
    select_day: "ದಿನ ಆಯ್ಕೆಮಾಡಿ",
    select_disability: "ದೈಹಿಕ ಅಶಕ್ತತೆ ಆಯ್ಕೆಮಾಡಿ!",
    select_district: "ಜಿಲ್ಲೆ ಆಯ್ಕೆಮಾಡಿ",
    select_local_body: "ಸ್ಥಳೀಯ ಸಂಸ್ಥೆ ಆಯ್ಕೆಮಾಡಿ",
    select_meeting_mode: "ಸಭೆ ವಿಧಾನ ಆಯ್ಕೆಮಾಡಿ",
    select_member: "ಸದಸ್ಯ ಆಯ್ಕೆಮಾಡಿ",
    select_minutes_files: "ನಿಮಿಷ ಕಡತಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    select_nearest_place: "ಹತ್ತಿರದ ಸ್ಥಳ ಆಯ್ಕೆಮಾಡಿ",
    select_new_files_replace_old:
      "ಹಳೆಯ ಕಡತಗಳನ್ನು ಬದಲಾಯಿಸಲು ಹೊಸ ಕಡತಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ (ಯಾವುದಾದರೂ ಇದ್ದರೆ)",
    select_option: "ಆಯ್ಕೆ ಮಾಡಿ",
    select_panchayath_type: "ಪಂಚಾಯತ್ ಆಯ್ಕೆಮಾಡಿ",
    select_profession: "ವೃತ್ತಿ ಆಯ್ಕೆಮಾಡಿ",
    select_range: "ವ್ಯಾಪ್ತಿ ಆಯ್ಕೆಮಾಡಿ",
    select_reason: "ಕಾರಣ ಆಯ್ಕೆಮಾಡಿ",
    select_unit: "ಘಟಕ ಆಯ್ಕೆಮಾಡಿ",
    select_vice_captain: "ಉಪ ಕ್ಯಾಪ್ಟನ್ ಆಯ್ಕೆಮಾಡಿ",
    select_ward: "ಕ್ಲಸ್ಟರ್ / ವಾರ್ಡ್ ಆಯ್ಕೆಮಾಡಿ",
    select_wing: "ವಿಭಾಗ ಆಯ್ಕೆಮಾಡಿ",
    select_zone: "ವಲಯ ಆಯ್ಕೆಮಾಡಿ",
    selected: "ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ",
    selected_files: "ಆಯ್ಕೆಮಾಡಿದ ಕಡತಗಳು",
    select_state_required: "ರಾಜ್ಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    select_country_required: "ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ!",
    select_abroad_city_required: "ನಗರದ ಹೆಸರನ್ನು ನಮೂದಿಸಿ!",
    send_guide_link: "ಮಾರ್ಗದರ್ಶಿ ಲಿಂಕ್ ಕಳುಹಿಸಿ",
    send_to_pending_members_list: "ಬಾಕಿ ಪಟ್ಟಿಗೆ ಕಳುಹಿಸಿ",
    signature_save_error:
      "ಸಹಿ ಉಳಿಸುವಲ್ಲಿ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    signature_saved_text: "ನಿಮ್ಮ ಸಹಿ ಯಶಸ್ವಿಯಾಗಿ ಉಳಿಸಲಾಗಿದೆ.",
    signature_saved_title: "ಸಹಿ ಉಳಿಸಲಾಗಿದೆ!",
    social_media_details: "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ವಿವರಗಳು",
    social_media_details_unit:
      "ಘಟಕದಲ್ಲಿ ಲಭ್ಯವಿರುವ ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ ಲಿಂಕ್‌ಗಳನ್ನು ಕೆಳಗೆ ನಮೂದಿಸಿ",
    social_media_label: "ಸಾಮಾಜಿಕ ಮಾಧ್ಯಮ",
    social_profiles: "ಸಾಮಾಜಿಕ ಪ್ರೊಫೈಲ್‌ಗಳು",
    speaking_languages: "ನೀವು ಮಾತನಾಡಬಹುದಾದ ಭಾಷೆಗಳು",
    speech_languages: "ನೀವು ಕಲಿಸಬಹುದಾದ/ಮಾತನಾಡಬಹುದಾದ ಭಾಷೆಗಳು",
    staff_count: "ಮಸೀದಿ ಅಡಿಯಲ್ಲಿ ಎಷ್ಟು ಸಿಬ್ಬಂದಿ ಸದಸ್ಯರಿದ್ದಾರೆ?",
    state: "ರಾಜ್ಯ",
    status: "ಸ್ಥಿತಿ",
    stream: "ಸ್ಟ್ರೀಮ್",
    students: "ವಿದ್ಯಾರ್ಥಿಗಳು",
    study_course: "ಅಧ್ಯಯನ ಕೋರ್ಸ್",
    study_year: "ಅಧ್ಯಯನ ವರ್ಷ",
    studying: "ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ",
    submit: "ಸಲ್ಲಿಸಿ",
    subscription: "ಚಂದಾ",
    subscription_number: "ಚಂದಾ ಸಂಖ್ಯೆ",
    summary_title: "g. ಸಾರಾಂಶ & ಸಹಿ",
    summary_title_profile: "ಸಾರಾಂಶ & ಸಹಿ",
    sunday: "ಭಾನುವಾರ",
    target: "ಗುರಿ",
    team_members: "ತಂಡ ಸದಸ್ಯರು",
    text: "ಪಠ್ಯ",
    thursday: "ಗುರುವಾರ",
    time: "ಸಮಯ",
    total: "ಒಟ್ಟು",
    transfer_to_unit: "ಘಟಕಕ್ಕೆ ವರ್ಗಾಯಿಸಿ",
    transfer_unit_actions: "ಘಟಕ ವರ್ಗಾವಣೆ ಕ್ರಮಗಳು",
    trust_land: "ಟ್ರಸ್ಟ್ ನಿಯಂತ್ರಣದಲ್ಲಿ ಭೂಮಿ (ಸೆಂಟ್‌ಗಳಲ್ಲಿ)",
    tuesday: "ಮಂಗಳವಾರ",
    under_100: "100 ಕೆಳಗೆ",
    unit: "ಘಟಕ",
    unit_clusters: "ಘಟಕ ಕ್ಲಸ್ಟರ್‌ಗಳು",
    unit_data_collection: "ಘಟಕ ಡೇಟಾ ಸಂಗ್ರಹ",
    unit_membership_report_election: "ಘಟಕ ಸದಸ್ಯತ್ವ ವರದಿ & ಘಟಕ ಚುನಾವಣೆ",
    zone_membership_report_election:
      "ವಲಯ ಸದಸ್ಯತ್ವ ವರದಿ & ವಲಯ ಚುನಾವಣೆ",
    district_membership_report_election:
      "ಜಿಲ್ಲಾ ಸದಸ್ಯತ್ವ ವರದಿ & ಜಿಲ್ಲೆ ಚುನಾವಣೆ",
    update: "ನವೀಕರಿಸಿ",
    upload: "ಅಪ್‌ಲೋಡ್",
    upload_files: "ಕಡತಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    upload_profile_photo: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
    uploaded: "ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗಿದೆ",
    uploading_files: "ಕಡತಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ...",
    vehicle_status: "ವಾಹನ ವಿವರಗಳು",
    verification_not_completed: "ಪರಿಶೀಲನೆ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ",
    verification_report: "ಪರಿಶೀಲನಾ ವರದಿ",
    verification_status: "ಪರಿಶೀಲನಾ ಸ್ಥಿತಿ",
    verified: "ಪರಿಶೀಲಿಸಲಾಗಿದೆ",
    verified_completed: "ಪರಿಶೀಲನೆ ಪೂರ್ಣಗೊಂಡಿದೆ",
    vice_captain: "ಉಪ ಕ್ಯಾಪ್ಟನ್",
    view_biodata: "ಬಯೋಡೇಟಾ ವೀಕ್ಷಿಸಿ",
    viewing_other_notice:
      "ಇದು ಇನ್ನೊಬ್ಬ ಸದಸ್ಯರ ಬಯೋಡೇಟಾ, ಆದ್ದರಿಂದ ನೀವು ಅದನ್ನು ಸಂಪಾದಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ",
    wednesday: "ಬುಧವಾರ",
    weekly: "ಸಾಪ್ತಾಹಿಕ",
    what_study: "ನೀವು ಏನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದೀರಿ?",
    where_study: "ನೀವು ಎಲ್ಲಿ ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದೀರಿ?",
    whatsapp: "ವಾಟ್ಸಾಪ್",
    whatsapp_number: "ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆ",
    wing: "ವಿಭಾಗ",
    wing_meeting: "ವಿಭಾಗ ಸಭೆ",
    wing_required: "ವಿಭಾಗ ಅಗತ್ಯ!",
    wing_required_field: "ವಿಭಾಗ ಅಗತ್ಯ",
    wings: "ವಿಭಾಗಗಳು",
    wisdom: "ವಿಸ್ಡಮ್",
    wisdom_healthcare: "ವಿಸ್ಡಮ್ ಆರೋಗ್ಯ",
    wisdom_land: "ಘಟಕ ನಿಯಂತ್ರಣದಲ್ಲಿ ವಿಸ್ಡಮ್ ಭೂಮಿ (ಸೆಂಟ್‌ಗಳಲ್ಲಿ)",
    wisdom_media: "ವಿಸ್ಡಮ್ ಮೀಡಿಯಾ",
    women: "ಮಹಿಳೆಯರು",
    women_facility: "ಮಹಿಳೆಯರಿಗೆ ಸೌಲಭ್ಯ",
    worker_home: "ಸಂಬಂಧಿಕರ ಮನೆ",
    writing_languages: "ನೀವು ಬರೆಯಬಹುದಾದ ಭಾಷೆಗಳು",
    yes: "ಹೌದು",
    yes_2: "ಹೌದು",
    yes_availability:
      "ಹೌದು, ವಿಸ್ಡಮ್ ಗೈಡ್ ಆಂಡ್ರಾಯ್ಡ್, iOS, ವಿಂಡೋಸ್ ಹಾಗೂ ಎಲ್ಲಾ ಮೊಬೈಲ್ ಫೋನ್‌ಗಳು, ಕಂಪ್ಯೂಟರ್‌ಗಳು ಮತ್ತು ಲ್ಯಾಪ್‌ಟಾಪ್‌ಗಳಲ್ಲಿ ಬಳಸಬಹುದಾಗಿದೆ.",
    youth: "ಯುವಕರು",
    youtube: "ಯೂಟ್ಯೂಬ್",
    zakath_cell: "ಜಕಾತ್ ಸೆಲ್",
    register_now: "ಈಗ ನೋಂದಾಯಿಸಿ",
    attended: "ಹಾಜರಿದ್ದರು",
    admin_controls: "ನಿರ್ವಹಣಾ ನಿಯಂತ್ರಣಗಳು",
    switch_admin_level: "ನಿರ್ವಹಣಾ ಮಟ್ಟವನ್ನು ಬದಲಾಯಿಸಿ",
    switch_to: "ಮಟ್ಟಕ್ಕೆ ಬದಲಾಯಿಸಿ {level}",
    level: "ಮಟ್ಟ",
    self_registration: "ಸ್ವಯಂ ನೋಂದಣಿ",
    registration_notice: "ನಿಮ್ಮ ಸಂಖ್ಯೆಯಡಿ ಇರುವ ಸದಸ್ಯರ ಹೆಸರನ್ನು ಟಿಕ್ ಮಾಡಿ ನೋಂದಾಯಿಸಿ",
    already_registered: "ನೀವು ಈಗಾಗಲೇ ನೋಂದಾಯಿಸಿಕೊಂಡಿದ್ದೀರಾ?",
    event_dashboard: "ಕಾರ್ಯಕ್ರಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    registration_report: "ನೋಂದಣಿ ವರದಿ",
    registration_summary: "ನೋಂದಣಿ ಸಾರಾಂಶ",
    male: "ಪುರುಷ",
    female: "ಸ್ತ್ರೀ",
    male_members: "ಪುರುಷ ಸದಸ್ಯರು",
    female_members: "ಸ್ತ್ರೀ ಸದಸ್ಯರು",
    participants_summary_with_family: "ಕುಟುಂಬದೊಂದಿಗೆ ಭಾಗವಹಿಸುವವರ ಸಾರಾಂಶ",
    sweet_buds: "ಸ್ವೀಟ್ ಬಡ್ಸ್",
    butterflies: "ಬಟರ್‌ಫ್ಲೈಸ್",
    little_wings: "ಲಿಟಲ್ ವಿಂಗ್ಸ್",
    teenspace: "ಟೀನ್‌ಸ್ಪೇಸ್",
    event_registration_report: "ಇವೆಂಟ್ ನೋಂದಣಿ ವರದಿ",
    total_unit_election_report: "ಒಟ್ಟು ಘಟಕ ಚುನಾವಣೆ ವರದಿ",
    unit_election_report: "ಘಟಕ ಚುನಾವಣೆ ವರದಿ",
    general_body_council: "ಸಾಮಾನ್ಯ ಸಭೆ/ಕೌನ್ಸಿಲ್",
    district_general_body_council: "ಜಿಲ್ಲಾ ಸಾಮಾನ್ಯ ಸಭೆ/ಕೌನ್ಸಿಲ್",
    district_womens_council: "ಜಿಲ್ಲಾ ಮಹಿಳೆಯರ ಕೌನ್ಸಿಲ್",
    district_girls_council: "ಜಿಲ್ಲಾ ಹುಡುಗಿಯರ ಕೌನ್ಸಿಲ್",
    womens_council: "ಮಹಿಳೆಯರ ಕೌನ್ಸಿಲ್",
    girls_council: "ಹುಡುಗಿಯರ ಕೌನ್ಸಿಲ್",
    org_councilers_list: "ಜಿಲ್ಲಾ / ರಾಜ್ಯ ಕೌನ್ಸಿಲರ್‌ಗಳು",
    unit_level_executives: "ಘಟಕ ಮಟ್ಟದ ಕಾರ್ಯಕಾರಿಗಳು",
    zone_level_executives: "ವಲಯ ಮಟ್ಟದ ಕಾರ್ಯಕಾರಿಗಳು",
    zone: "ವಲಯ",
    department: "ವಿಭಾಗ",
    zone_election_report: "ವಲಯ ಚುನಾವಣೆ ವರದಿ",
    circulars: "ಚಕ್ರಗಳು"
  },
};

const i18n = createI18n({
  locale: "ml",
  fallbackLocale: "en",
  messages,
});

export default i18n;
